/* eslint-disable sonarjs/no-duplicate-string */
window.theme = window.theme || {};

/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on("shopify:section:load", this._onSectionLoad.bind(this))
    .on("shopify:section:unload", this._onSectionUnload.bind(this))
    .on("shopify:section:select", this._onSelect.bind(this))
    .on("shopify:section:deselect", this._onDeselect.bind(this))
    .on("shopify:block:select", this._onBlockSelect.bind(this))
    .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var $container = $(container);
    var id = $container.attr("data-section-id");
    var type = $container.attr("data-section-type");

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = $("[data-section-id]", evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    this.instances = _.filter(this.instances, function (instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    $("[data-section-type=" + type + "]").each(
      function (index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  },
});

window.slate = window.slate || {};

/**
 * Slate utilities
 * -----------------------------------------------------------------------------
 * A collection of useful utilities to help build your theme
 *
 *
 * @namespace utils
 */

slate.utils = {
  /**
   * Get the query params in a Url
   * Ex
   * https://mysite.com/search?q=noodles&b
   * getParameterByName('q') = "noodles"
   * getParameterByName('b') = "" (empty value)
   * getParameterByName('test') = null (absent)
   */
  getParameterByName: function (name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  },

  keyboardKeys: {
    TAB: 9,
    ENTER: 13,
    ESCAPE: 27,
    LEFTARROW: 37,
    RIGHTARROW: 39,
  },
};

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function (options) {
    options.$tables.wrap(
      "<div class=\"" + options.tableWrapperClass + "\"></div>"
    );
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function (options) {
    options.$iframes.each(function () {
      // Add wrapper to make video responsive
      $(this).wrap("<div class=\"" + options.iframeWrapperClass + "\"></div>");

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      // eslint-disable-next-line no-self-assign
      this.src = this.src;
    });
  },
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function ($element) {
    var focusClass = "js-focus-hidden";

    $element
      .first()
      .attr("tabIndex", "-1")
      .focus()
      .addClass(focusClass)
      .one("blur", callback);

    function callback() {
      $element.first().removeClass(focusClass).removeAttr("tabindex");
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function () {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function () {
    $("a[href*=#]").on(
      "click",
      function (evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function (options) {
    var eventsName = {
      focusin: options.namespace ? "focusin." + options.namespace : "focusin",
      focusout: options.namespace
        ? "focusout." + options.namespace
        : "focusout",
      keydown: options.namespace
        ? "keydown." + options.namespace
        : "keydown.handleFocus",
    };

    /**
     * Get every possible visible focusable element
     */
    var $focusableElements = options.$container.find(
      $(
        "button, [href], input, select, textarea, [tabindex]:not([tabindex^=\"-\"])"
      ).filter(":visible")
    );
    var firstFocusable = $focusableElements[0];
    var lastFocusable = $focusableElements[$focusableElements.length - 1];

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    function _manageFocus(evt) {
      if (evt.keyCode !== slate.utils.keyboardKeys.TAB) return;

      /**
       * On the last focusable element and tab forward,
       * focus the first element.
       */
      if (evt.target === lastFocusable && !evt.shiftKey) {
        evt.preventDefault();
        firstFocusable.focus();
      }
      /**
       * On the first focusable element and tab backward,
       * focus the last element.
       */
      if (evt.target === firstFocusable && evt.shiftKey) {
        evt.preventDefault();
        lastFocusable.focus();
      }
    }

    options.$container.attr("tabindex", "-1");
    options.$elementToFocus.focus();

    $(document).off("focusin");

    $(document).on(eventsName.focusout, function () {
      $(document).off(eventsName.keydown);
    });

    $(document).on(eventsName.focusin, function (evt) {
      if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;

      $(document).on(eventsName.keydown, function (evt) {
        _manageFocus(evt);
      });
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function (options) {
    var eventName = options.namespace
      ? "focusin." + options.namespace
      : "focusin";

    if (options.$container?.length) {
      options.$container.removeAttr("tabindex");
    }

    $(document).off(eventName);
  },

  /**
   * Add aria-describedby attribute to external and new window links
   *
   * @param {object} options - Options to be used
   * @param {object} options.messages - Custom messages to be used
   * @param {jQuery} options.$links - Specific links to be targeted
   */
  accessibleLinks: function (options) {
    var body = document.querySelector("body");
    var idSelectors = {
      newWindow: "a11y-new-window-message",
      external: "a11y-external-message",
      newWindowExternal: "a11y-new-window-external-message",
    };

    if (options.$links === undefined || !options.$links.jquery) {
      options.$links = $("a[href]:not([aria-describedby])");
    }

    function generateHTML(customMessages) {
      if (typeof customMessages !== "object") {
        customMessages = {};
      }

      var messages = $.extend(
        {
          newWindow: "Opens in a new window.",
          external: "Opens external website.",
          newWindowExternal: "Opens external website in a new window.",
        },
        customMessages
      );

      var container = document.createElement("ul");
      var htmlMessages = "";

      for (var message in messages) {
        htmlMessages +=
          "<li id=" + idSelectors[message] + ">" + messages[message] + "</li>";
      }

      container.setAttribute("hidden", true);
      container.innerHTML = htmlMessages;

      body.appendChild(container);
    }

    function _externalSite($link) {
      var hostname = window.location.hostname;

      return $link[0].hostname !== hostname;
    }

    $.each(options.$links, function () {
      var $link = $(this);
      var target = $link.attr("target");
      var rel = $link.attr("rel");
      var isExternal = _externalSite($link);
      var isTargetBlank = target === "_blank";

      if (isExternal) {
        $link.attr("aria-describedby", idSelectors.external);
      }
      if (isTargetBlank) {
        if (rel === undefined || rel.indexOf("noopener") === -1) {
          $link.attr("rel", function (i, val) {
            var relValue = val === undefined ? "" : val + " ";
            return relValue + "noopener";
          });
        }
        $link.attr("aria-describedby", idSelectors.newWindow);
      }
      if (isExternal && isTargetBlank) {
        $link.attr("aria-describedby", idSelectors.newWindowExternal);
      }
    });

    generateHTML(options.messages);
  },
};

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function () {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === "string") {
      images = [images];
    }

    for (const element of images) {
      var image = element;
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
    );

    if (match !== null) {
      if (match[2] !== undefined) {
        return match[1] + match[2];
      } else {
        return match[1];
      }
    } else {
      return null;
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === "master") {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + "_" + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, "");
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol,
  };
})();

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function () {
  var moneyFormat = "${{amount}}"; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ",";
      decimal = decimal || ".";

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney,
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function () {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on(
      "change",
      this._onSelectChange.bind(this)
    );
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function () {
      var currentOptions = _.map(
        $(this.singleOptionSelector, this.$container),
        function (element) {
          var $element = $(element);
          var type = $element.attr("type");
          var currentOption = {};

          if (type === "radio" || type === "checkbox") {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data("index");

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data("index");

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function () {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      return _.find(variants, function (variant) {
        return selectedValues.every(function (values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function () {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: "variantChange",
        variant: variant,
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function (variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.$container.trigger({
        type: "variantImageChange",
        variant: variant,
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function (variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: "variantPriceChange",
        variant: variant,
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function (variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: "variantSKUChange",
        variant: variant,
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function (variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?variant=" +
        variant.id;
      window.history.replaceState({ path: newurl }, "", newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function (variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    },
  });

  return Variants;
})();

/* ================ GLOBAL ================ */
/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function () {
  function Drawer(id, position, options) {
    var defaults = {
      close: ".js-drawer-close",
      open: ".js-drawer-open-" + position,
      openClass: "js-drawer-open",
      dirOpenClass: "js-drawer-open-" + position,
    };

    this.nodes = {
      $parent: $("html").add("body"),
      $page: $("#PageContainer"),
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $("#" + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function () {
    $(this.config.open).on("click", $.proxy(this.open, this));
    this.$drawer.on("click", this.config.close, $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.$page
    // which closes the drawer.
    if (evt?.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(
      this.config.openClass + " " + this.config.dirOpenClass
    );
    this.drawerIsOpen = true;

    // Set focus on drawer
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: "drawer_focus",
    });

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === "function"
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    // eslint-disable-next-line sonarjs/no-duplicate-string
    if (this.$activeSource?.attr("aria-expanded")) {
      this.$activeSource.attr("aria-expanded", "true");
    }

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) {
      // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger("blur");

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();

    this.nodes.$parent.removeClass(
      this.config.dirOpenClass + " " + this.config.openClass
    );

    if (this.$activeSource?.attr("aria-expanded")) {
      this.$activeSource.attr("aria-expanded", "false");
    }

    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: "drawer_focus",
    });

    this.unbindEvents();

    // Run function when draw closes if set
    if (
      this.config.onDrawerClose &&
      typeof this.config.onDrawerClose === "function"
    ) {
      this.config.onDrawerClose();
    }
  };

  Drawer.prototype.bindEvents = function () {
    this.nodes.$parent.on(
      "keyup.drawer",
      $.proxy(function (evt) {
        // close on 'esc' keypress
        if (evt.keyCode === 27) {
          this.close();
          return false;
        } else {
          return true;
        }
      }, this)
    );

    // Lock scrolling on mobile
    this.nodes.$page.on("touchmove.drawer", function () {
      return false;
    });

    this.nodes.$page.on(
      "click.drawer",
      $.proxy(function () {
        this.close();
        return false;
      }, this)
    );
  };

  Drawer.prototype.unbindEvents = function () {
    this.nodes.$page.off(".drawer");
    this.nodes.$parent.off(".drawer");
  };

  return Drawer;
})();

/* ================ MODULES ================ */
window.theme = window.theme || {};

theme.Header = (function () {
  var selectors = {
    body: "body",
    multicurrencySelector: "[data-currency-selector]",
    navigation: "#AccessibleNav",
    siteNavHasDropdown: "[data-has-dropdowns]",
    siteNavChildLinks: ".site-nav__child-link",
    siteNavActiveDropdown: ".site-nav--active-dropdown",
    siteNavHasCenteredDropdown: ".site-nav--has-centered-dropdown",
    siteNavCenteredDropdown: ".site-nav__dropdown--centered",
    siteNavLinkMain: ".site-nav__link--main",
    siteNavChildLink: ".site-nav__link--last",
    siteNavDropdown: ".site-nav__dropdown",
    siteHeader: ".site-header",
  };

  var config = {
    activeClass: "site-nav--active-dropdown",
    childLinkClass: "site-nav__child-link",
    rightDropdownClass: "site-nav__dropdown--right",
    leftDropdownClass: "site-nav__dropdown--left",
  };

  var cache = {};

  function init() {
    cacheSelectors();
    styleDropdowns($(selectors.siteNavHasDropdown));
    positionFullWidthDropdowns();

    cache.$parents.on("click.siteNav", function () {
      var $el = $(this);
      $el.hasClass(config.activeClass) ? hideDropdown($el) : showDropdown($el);
    });

    // check when we're leaving a dropdown and close the active dropdown
    $(selectors.siteNavChildLink).on("focusout.siteNav", function () {
      setTimeout(function () {
        if (
          $(document.activeElement).hasClass(config.childLinkClass) ||
          !cache.$activeDropdown.length
        ) {
          return;
        }

        hideDropdown(cache.$activeDropdown);
      });
    });

    // close dropdowns when on top level nav
    cache.$topLevel.on("focus.siteNav", function () {
      if (cache.$activeDropdown.length) {
        hideDropdown(cache.$activeDropdown);
      }
    });

    cache.$subMenuLinks.on("click.siteNav", function (evt) {
      // Prevent click on body from firing instead of link
      evt.stopImmediatePropagation();
    });

    $(selectors.multicurrencySelector).on("change", function () {
      $(this).parents("form").submit();
    });

    $(window).resize(
      $.debounce(50, function () {
        styleDropdowns($(selectors.siteNavHasDropdown));
        positionFullWidthDropdowns();
      })
    );
  }

  function cacheSelectors() {
    cache = {
      $nav: $(selectors.navigation),
      $topLevel: $(selectors.siteNavLinkMain),
      $parents: $(selectors.navigation).find(selectors.siteNavHasDropdown),
      $subMenuLinks: $(selectors.siteNavChildLinks),
      $activeDropdown: $(selectors.siteNavActiveDropdown),
      $siteHeader: $(selectors.siteHeader),
    };
  }

  function showDropdown($el) {
    $el.addClass(config.activeClass);

    // close open dropdowns
    if (cache.$activeDropdown.length) {
      hideDropdown(cache.$activeDropdown);
    }

    cache.$activeDropdown = $el;

    // set expanded on open dropdown
    $el.find(selectors.siteNavLinkMain).attr("aria-expanded", "true");

    setTimeout(function () {
      $(window).on("keyup.siteNav", function (evt) {
        if (evt.keyCode === 27) {
          hideDropdown($el);
        }
      });

      $(selectors.body).on("click.siteNav", function () {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown($el) {
    // remove aria on open dropdown
    $el.find(selectors.siteNavLinkMain).attr("aria-expanded", "false");
    $el.removeClass(config.activeClass);

    // reset active dropdown
    cache.$activeDropdown = $(selectors.siteNavActiveDropdown);

    $(selectors.body).off("click.siteNav");
    $(window).off("keyup.siteNav");
  }

  function styleDropdowns($dropdownListItems) {
    $dropdownListItems.each(function () {
      var $dropdownLi = $(this).find(selectors.siteNavDropdown);
      if (!$dropdownLi.length) {
        return;
      }
      var isRightOfLogo =
        Math.ceil($(this).offset().left) >
        Math.floor(cache.$siteHeader.outerWidth()) / 2
          ? true
          : false;
      if (isRightOfLogo) {
        $dropdownLi
          .removeClass(config.leftDropdownClass)
          .addClass(config.rightDropdownClass);
      } else {
        $dropdownLi
          .removeClass(config.rightDropdownClass)
          .addClass(config.leftDropdownClass);
      }
    });
  }

  function positionFullWidthDropdowns() {
    var $listWithCenteredDropdown = $(selectors.siteNavHasCenteredDropdown);

    $listWithCenteredDropdown.each(function () {
      var $hasCenteredDropdown = $(this);
      var $fullWidthDropdown = $hasCenteredDropdown.find(
        selectors.siteNavCenteredDropdown
      );

      var fullWidthDropdownOffset = $hasCenteredDropdown.position().top + 41;
      $fullWidthDropdown.css("top", fullWidthDropdownOffset);
    });
  }

  function unload() {
    $(window).off(".siteNav");
    cache.$parents.off(".siteNav");
    cache.$subMenuLinks.off(".siteNav");
    cache.$topLevel.off(".siteNav");
    $(selectors.siteNavChildLink).off(".siteNav");
    $(selectors.body).off(".siteNav");
  }

  return {
    init: init,
    unload: unload,
  };
})();

window.theme = window.theme || {};

theme.MobileNav = (function () {
  var classes = {
    mobileNavOpenIcon: "mobile-nav--open",
    mobileNavCloseIcon: "mobile-nav--close",
    navLinkWrapper: "mobile-nav__item",
    navLink: "mobile-nav__link",
    subNavLink: "mobile-nav__sublist-link",
    return: "mobile-nav__return-btn",
    subNavActive: "is-active",
    subNavClosing: "is-closing",
    navOpen: "js-menu--is-open",
    subNavShowing: "sub-nav--is-open",
    thirdNavShowing: "third-nav--is-open",
    subNavToggleBtn: "js-toggle-submenu",
  };
  var cache = {};
  var isTransitioning;
  var $activeSubNav;
  var $activeTrigger;
  var menuLevel = 1;
  // Breakpoints from src/stylesheets/global/variables.scss.liquid
  var mediaQuerySmall = "screen and (max-width: 749px)";

  function init() {
    cacheSelectors();

    cache.$mobileNavToggle.on("click", toggleMobileNav);
    cache.$subNavToggleBtn.on("click.subNav", toggleSubNav);

    // Close mobile nav when unmatching mobile breakpoint
    enquire.register(mediaQuerySmall, {
      unmatch: function () {
        if (cache.$mobileNavContainer.hasClass(classes.navOpen)) {
          closeMobileNav();
        }
      },
    });
  }

  function toggleMobileNav() {
    if (cache.$mobileNavToggle.hasClass(classes.mobileNavCloseIcon)) {
      closeMobileNav();
    } else {
      openMobileNav();
    }
  }

  function cacheSelectors() {
    cache = {
      $pageContainer: $("#PageContainer"),
      $siteHeader: $(".site-header"),
      $mobileNavToggle: $(".js-mobile-nav-toggle"),
      $mobileNavContainer: $(".mobile-nav-wrapper"),
      $mobileNav: $("#MobileNav"),
      $sectionHeader: $("#shopify-section-header"),
      $subNavToggleBtn: $("." + classes.subNavToggleBtn),
    };
  }

  function openMobileNav() {
    var translateHeaderHeight = cache.$siteHeader.outerHeight();

    cache.$mobileNavContainer.prepareTransition().addClass(classes.navOpen);

    cache.$mobileNavContainer.css({
      transform: "translateY(" + translateHeaderHeight + "px)",
    });

    cache.$pageContainer.css({
      transform:
        "translate3d(0, " +
        cache.$mobileNavContainer[0].scrollHeight +
        "px, 0)",
    });

    slate.a11y.trapFocus({
      $container: cache.$sectionHeader,
      $elementToFocus: cache.$mobileNavToggle,
      namespace: "navFocus",
    });

    cache.$mobileNavToggle
      .addClass(classes.mobileNavCloseIcon)
      .removeClass(classes.mobileNavOpenIcon)
      .attr("aria-expanded", true);

    // close on escape
    $(window).on("keyup.mobileNav", function (evt) {
      if (evt.which === 27) {
        closeMobileNav();
      }
    });
  }

  function closeMobileNav() {
    cache.$mobileNavContainer.prepareTransition().removeClass(classes.navOpen);

    cache.$mobileNavContainer.css({
      transform: "translateY(-100%)",
    });

    cache.$pageContainer.removeAttr("style");

    slate.a11y.trapFocus({
      $container: $("html"),
      $elementToFocus: $("body"),
    });

    cache.$mobileNavContainer.one(
      "TransitionEnd.navToggle webkitTransitionEnd.navToggle transitionend.navToggle oTransitionEnd.navToggle",
      function () {
        slate.a11y.removeTrapFocus({
          $container: cache.$mobileNav,
          namespace: "navFocus",
        });
      }
    );

    cache.$mobileNavToggle
      .addClass(classes.mobileNavOpenIcon)
      .removeClass(classes.mobileNavCloseIcon)
      .attr("aria-expanded", false)
      .focus();

    $(window).off("keyup.mobileNav");

    scrollTo(0, 0);
  }

  function toggleSubNav(evt) {
    if (isTransitioning) {
      return;
    }

    var $toggleBtn = $(evt.currentTarget);
    var isReturn = $toggleBtn.hasClass(classes.return);
    isTransitioning = true;

    if (isReturn) {
      // Close all subnavs by removing active class on buttons
      $(
        "." + classes.subNavToggleBtn + "[data-level=\"" + (menuLevel - 1) + "\"]"
      ).removeClass(classes.subNavActive);

      if ($activeTrigger && $activeTrigger.length) {
        $activeTrigger.removeClass(classes.subNavActive);
      }
    } else {
      $toggleBtn.addClass(classes.subNavActive);
    }

    $activeTrigger = $toggleBtn;

    goToSubnav($toggleBtn.data("target"));
  }

  function goToSubnav(target) {
    var $targetMenu = target
      ? $(".mobile-nav__dropdown[data-parent=\"" + target + "\"]")
      : cache.$mobileNav;

    menuLevel = $targetMenu.data("level") ? $targetMenu.data("level") : 1;

    if ($activeSubNav?.length) {
      $activeSubNav.prepareTransition().addClass(classes.subNavClosing);
    }

    $activeSubNav = $targetMenu;

    var translateMenuHeight = $targetMenu.outerHeight();

    var openNavClass =
      menuLevel > 2 ? classes.thirdNavShowing : classes.subNavShowing;

    cache.$mobileNavContainer
      .css("height", translateMenuHeight)
      .removeClass(classes.thirdNavShowing)
      .addClass(openNavClass);

    if (!target) {
      // Show top level nav
      cache.$mobileNavContainer
        .removeClass(classes.thirdNavShowing)
        .removeClass(classes.subNavShowing);
    }

    /* if going back to first subnav, focus is on whole header */
    var $container = menuLevel === 1 ? cache.$sectionHeader : $targetMenu;

    var $menuTitle = $targetMenu.find("[data-menu-title=" + menuLevel + "]");
    var $elementToFocus = $menuTitle ? $menuTitle : $targetMenu;

    // Focusing an item in the subnav early forces element into view and breaks the animation.
    cache.$mobileNavContainer.one(
      "TransitionEnd.subnavToggle webkitTransitionEnd.subnavToggle transitionend.subnavToggle oTransitionEnd.subnavToggle",
      function () {
        slate.a11y.trapFocus({
          $container: $container,
          $elementToFocus: $elementToFocus,
          namespace: "subNavFocus",
        });

        cache.$mobileNavContainer.off(".subnavToggle");
        isTransitioning = false;
      }
    );

    // Match height of subnav
    cache.$pageContainer.css({
      transform: "translateY(" + translateMenuHeight + "px)",
    });

    $activeSubNav.removeClass(classes.subNavClosing);
  }

  return {
    init: init,
    closeMobileNav: closeMobileNav,
  };
})(jQuery);

window.theme = window.theme || {};

theme.Search = (function () {
  var selectors = {
    search: ".search",
    searchSubmit: ".search__submit",
    searchInput: ".search__input",

    siteHeader: ".site-header",
    siteHeaderSearchToggle: ".site-header__search-toggle",
    siteHeaderSearch: ".site-header__search",

    searchDrawer: ".search-bar",
    searchDrawerInput: ".search-bar__input",

    searchHeader: ".search-header",
    searchHeaderInput: ".search-header__input",
    searchHeaderSubmit: ".search-header__submit",

    searchResultSubmit: "#SearchResultSubmit",
    searchResultInput: "#SearchInput",
    searchResultMessage: "[data-search-error-message]",

    mobileNavWrapper: ".mobile-nav-wrapper",
  };

  var classes = {
    focus: "search--focus",
    hidden: "hide",
    mobileNavIsOpen: "js-menu--is-open",
    searchTemplate: "template-search",
  };

  function init() {
    if (!$(selectors.siteHeader).length) {
      return;
    }

    this.$searchResultInput = $(selectors.searchResultInput);
    this.$searchErrorMessage = $(selectors.searchResultMessage);

    initDrawer();

    var isSearchPage =
      slate.utils.getParameterByName("q") !== null &&
      $("body").hasClass(classes.searchTemplate);

    if (isSearchPage) {
      validateSearchResultForm.call(this);
    }

    $(selectors.searchResultSubmit).on(
      "click",
      validateSearchResultForm.bind(this)
    );

    $(selectors.searchHeaderInput)
      .add(selectors.searchHeaderSubmit)
      .on("focus blur", function () {
        $(selectors.searchHeader).toggleClass(classes.focus);
      });

    $(selectors.siteHeaderSearchToggle).on("click", function () {
      var searchHeight = $(selectors.siteHeader).outerHeight();
      var searchOffset = $(selectors.siteHeader).offset().top - searchHeight;

      $(selectors.searchDrawer).css({
        height: searchHeight + "px",
        top: searchOffset + "px",
      });
    });
  }

  function initDrawer() {
    // Add required classes to HTML
    $("#PageContainer").addClass("drawer-page-content");
    $(".js-drawer-open-top")
      .attr("aria-controls", "SearchDrawer")
      .attr("aria-expanded", "false")
      .attr("aria-haspopup", "dialog");

    theme.SearchDrawer = new theme.Drawers("SearchDrawer", "top", {
      onDrawerOpen: searchDrawerFocus,
      onDrawerClose: searchDrawerFocusClose,
    });
  }

  function searchDrawerFocus() {
    searchFocus($(selectors.searchDrawerInput));

    if ($(selectors.mobileNavWrapper).hasClass(classes.mobileNavIsOpen)) {
      theme.MobileNav.closeMobileNav();
    }
  }

  function searchFocus($el) {
    $el.focus();
    // set selection range hack for iOS
    $el[0].setSelectionRange(0, $el[0].value.length);
  }

  function searchDrawerFocusClose() {
    $(selectors.siteHeaderSearchToggle).focus();
  }

  /**
   * Remove the aria-attributes and hide the error messages
   */
  function hideErrorMessage() {
    this.$searchErrorMessage.addClass(classes.hidden);
    this.$searchResultInput
      .removeAttr("aria-describedby")
      .removeAttr("aria-invalid");
  }

  /**
   * Add the aria-attributes and show the error messages
   */
  function showErrorMessage() {
    this.$searchErrorMessage.removeClass(classes.hidden);
    this.$searchResultInput
      .attr("aria-describedby", "error-search-form")
      .attr("aria-invalid", true);
  }

  function validateSearchResultForm(evt) {
    var isInputValueEmpty = this.$searchResultInput.val().trim().length === 0;

    if (!isInputValueEmpty) {
      hideErrorMessage.call(this);
      return;
    }

    if (typeof evt !== "undefined") {
      evt.preventDefault();
    }

    searchFocus(this.$searchResultInput);
    showErrorMessage.call(this);
  }

  return {
    init: init,
  };
})();

theme.Profile = (function () {
  var selectors = {
    linkLogin: ".login-link",
    modalLogin: ".login-modal",
    linkCustomerRegister: "#customer_register_link",
    linkCustomerLogin: "#customer_login_link",
    formCustomerRegister: ".register-form__wrapper",
    formCustomerLogin: ".login-form__wrapper",
  };

  function init() {
    $(selectors.linkLogin).on("click", function (evt) {
      evt.preventDefault();

      $(selectors.modalLogin).modal();
    });

    $(selectors.modalLogin)
      .find(selectors.linkCustomerRegister)
      .click(function (evt) {
        evt.preventDefault();
        $(selectors.formCustomerLogin).hide();
        $(selectors.formCustomerRegister).show();
      });

    $(selectors.modalLogin)
      .find(selectors.linkCustomerLogin)
      .click(function (evt) {
        evt.preventDefault();
        $(selectors.formCustomerRegister).hide();
        $(selectors.formCustomerLogin).show();
      });
  }

  return {
    init: init,
  };
})(jQuery);

(function () {
  var selectors = {
    backButton: ".return-link",
  };

  var $backButton = $(selectors.backButton);

  if (!document.referrer || !$backButton.length || !window.history.length) {
    return;
  }

  $backButton.one("click", function (evt) {
    evt.preventDefault();

    var referrerDomain = urlDomain(document.referrer);
    var shopDomain = urlDomain(window.location.href);

    if (shopDomain === referrerDomain) {
      history.back();
    }

    return false;
  });

  function urlDomain(url) {
    var anchor = document.createElement("a");
    anchor.ref = url;

    return anchor.hostname;
  }
})();

theme.SlidingCollection = (function () {
  this.$slidingCollection = null;

  function slidingCollection(el) {
    this.$slidingCollection = this.$slidingCollection = $(el);

    this.settings = {
      arrows: true,
      prevArrow: "<button type=\"button\" class=\"slick-prev\"></button>",
      nextArrow: "<button type=\"button\" class=\"slick-next\"></button>",
      slidesToShow: 4,
      infinite: false,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
          },
        },
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ],
    };

    this.$slidingCollection.slick(this.settings);
  }

  return slidingCollection;
})();

theme.Slideshow = (function () {
  this.$slideshow = null;
  var classes = {
    slideshow: "slideshow",
    slickActiveMobile: "slick-active-mobile",
    controlsHover: "slideshow__controls--hover",
    isPaused: "is-paused",
  };

  var selectors = {
    section: ".shopify-section",
    wrapper: "#SlideshowWrapper-",
    slides: ".slideshow__slide",
    textWrapperMobile: ".slideshow__text-wrap--mobile",
    textContentMobile: ".slideshow__text-content--mobile",
    controls: ".slideshow__controls",
    pauseButton: ".slideshow__pause",
    dots: ".slick-dots",
    arrows: ".slideshow__arrows",
    arrowsMobile: ".slideshow__arrows--mobile",
    arrowLeft: ".slideshow__arrow-left",
    arrowRight: ".slideshow__arrow-right",
  };

  function slideshow(el, sectionId) {
    var $slideshow = (this.$slideshow = $(el));
    this.adaptHeight = this.$slideshow.data("adapt-height");
    this.$wrapper = this.$slideshow.closest(selectors.wrapper + sectionId);
    this.$section = this.$wrapper.closest(selectors.section);
    this.$controls = this.$wrapper.find(selectors.controls);
    this.$arrows = this.$section.find(selectors.arrows);
    this.$arrowsMobile = this.$section.find(selectors.arrowsMobile);
    this.$pause = this.$controls.find(selectors.pauseButton);
    this.$textWrapperMobile = this.$section.find(selectors.textWrapperMobile);
    this.autorotate = this.$slideshow.data("autorotate");
    var autoplaySpeed = this.$slideshow.data("speed");
    var loadSlideA11yString = this.$slideshow.data("slide-nav-a11y");

    this.settings = {
      accessibility: true,
      arrows: false,
      dots: true,
      rows: 0,
      fade: true,
      draggable: true,
      touchThreshold: 20,
      autoplay: this.autorotate,
      autoplaySpeed: autoplaySpeed,
      appendDots: this.$arrows,
      customPaging: function (slick, index) {
        return (
          "<a href=\"" +
          selectors.wrapper +
          sectionId +
          "\" aria-label=\"" +
          loadSlideA11yString.replace("[slide_number]", index + 1) +
          "\" data-slide-number=\"" +
          index +
          "\"></a>"
        );
      },
    };

    this.$slideshow.on("beforeChange", beforeChange.bind(this));
    this.$slideshow.on("init", slideshowA11ySetup.bind(this));

    // Add class to style mobile dots & show the correct text content for the
    // first slide on mobile when the slideshow initialises
    this.$slideshow.on(
      "init",
      function () {
        this.$mobileDots
          .find("li:first-of-type")
          .addClass(classes.slickActiveMobile);
        this.showMobileText(0);
      }.bind(this)
    );

    // Stop the autorotate when you scroll past the mobile controls, resume when
    // they are scrolled back into view
    if (this.autorotate) {
      $(document).scroll(
        $.debounce(
          250,
          function () {
            if (
              this.$arrowsMobile.offset().top +
                this.$arrowsMobile.outerHeight() <
              window.pageYOffset
            ) {
              $slideshow.slick("slickPause");
            } else if (!this.$pause.hasClass(classes.isPaused)) {
              $slideshow.slick("slickPlay");
            }
          }.bind(this)
        )
      );
    }

    if (this.adaptHeight) {
      this.setSlideshowHeight();
      $(window).resize($.debounce(50, this.setSlideshowHeight.bind(this)));
    }

    this.$slideshow.slick(this.settings);

    // This can't be called when the slick 'init' event fires due to how slick
    // adds a11y features.
    slideshowPostInitA11ySetup.bind(this)();

    this.$arrows.find(selectors.arrowLeft).on("click", function () {
      $slideshow.slick("slickPrev");
    });
    this.$arrows.find(selectors.arrowRight).on("click", function () {
      $slideshow.slick("slickNext");
    });

    this.$pause.on("click", this.togglePause.bind(this));
  }

  function slideshowA11ySetup(event, obj) {
    var $slider = obj.$slider;
    var $list = obj.$list;
    this.$dots = this.$section.find(selectors.dots);
    this.$mobileDots = this.$dots.eq(1);

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr("aria-live");

    this.$wrapper.on("keyup", keyboardNavigation.bind(this));
    this.$controls.on("keyup", keyboardNavigation.bind(this));
    this.$textWrapperMobile.on("keyup", keyboardNavigation.bind(this));

    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    this.$wrapper
      .on(
        "focusin",
        function (evt) {
          if (!this.$wrapper.has(evt.target).length) {
            return;
          }

          $list.attr("aria-live", "polite");
          if (this.autorotate) {
            $slider.slick("slickPause");
          }
        }.bind(this)
      )
      .on(
        "focusout",
        function (evt) {
          if (!this.$wrapper.has(evt.target).length) {
            return;
          }

          $list.removeAttr("aria-live");
          if (this.autorotate) {
            // Only resume playing if the user hasn't paused using the pause
            // button
            if (!this.$pause.is(".is-paused")) {
              $slider.slick("slickPlay");
            }
          }
        }.bind(this)
      );

    // Add arrow key support when focused
    if (this.$dots) {
      this.$dots
        .find("a")
        .each(function () {
          var $dot = $(this);
          $dot.on("click keyup", function (evt) {
            if (
              evt.type === "keyup" &&
              evt.which !== slate.utils.keyboardKeys.ENTER
            )
              return;

            evt.preventDefault();

            var slideNumber = $(evt.target).data("slide-number");

            $slider.attr("tabindex", -1).slick("slickGoTo", slideNumber);

            if (evt.type === "keyup") {
              $slider.focus();
            }
          });
        })
        .eq(0)
        .attr("aria-current", "true");
    }

    this.$controls
      .on("focusin", highlightControls.bind(this))
      .on("focusout", unhighlightControls.bind(this));
  }

  function slideshowPostInitA11ySetup() {
    var $slides = this.$slideshow.find(selectors.slides);

    $slides.removeAttr("role").removeAttr("aria-labelledby");
    this.$dots
      .removeAttr("role")
      .find("li")
      .removeAttr("role")
      .removeAttr("aria-selected")
      .each(function () {
        var $dot = $(this);
        var ariaControls = $dot.attr("aria-controls");
        $dot
          .removeAttr("aria-controls")
          .find("a")
          .attr("aria-controls", ariaControls);
      });
  }

  function beforeChange(event, slick, currentSlide, nextSlide) {
    var $dotLinks = this.$dots.find("a");
    var $mobileDotLinks = this.$mobileDots.find("li");

    $dotLinks
      .removeAttr("aria-current")
      .eq(nextSlide)
      .attr("aria-current", "true");

    $mobileDotLinks
      .removeClass(classes.slickActiveMobile)
      .eq(nextSlide)
      .addClass(classes.slickActiveMobile);
    this.showMobileText(nextSlide);
  }

  function keyboardNavigation() {
    if (event.keyCode === slate.utils.keyboardKeys.LEFTARROW) {
      this.$slideshow.slick("slickPrev");
    }
    if (event.keyCode === slate.utils.keyboardKeys.RIGHTARROW) {
      this.$slideshow.slick("slickNext");
    }
  }

  function highlightControls() {
    this.$controls.addClass(classes.controlsHover);
  }

  function unhighlightControls() {
    this.$controls.removeClass(classes.controlsHover);
  }

  slideshow.prototype.togglePause = function () {
    var slideshowSelector = getSlideshowId(this.$pause);
    if (this.$pause.hasClass(classes.isPaused)) {
      this.$pause.removeClass(classes.isPaused).attr("aria-pressed", "false");
      if (this.autorotate) {
        $(slideshowSelector).slick("slickPlay");
      }
    } else {
      this.$pause.addClass(classes.isPaused).attr("aria-pressed", "true");
      if (this.autorotate) {
        $(slideshowSelector).slick("slickPause");
      }
    }
  };

  slideshow.prototype.setSlideshowHeight = function () {
    var minAspectRatio = this.$slideshow.data("min-aspect-ratio");
    this.$slideshow.height($(document).width() / minAspectRatio);
  };

  slideshow.prototype.showMobileText = function (slideIndex) {
    var $allTextContent = this.$textWrapperMobile.find(
      selectors.textContentMobile
    );
    var currentTextContentSelector =
      selectors.textContentMobile + "-" + slideIndex;
    var $currentTextContent = this.$textWrapperMobile.find(
      currentTextContentSelector
    );
    if (
      !$currentTextContent.length &&
      this.$slideshow.find(selectors.slides).length === 1
    ) {
      this.$textWrapperMobile.hide();
    } else {
      this.$textWrapperMobile.show();
    }
    $allTextContent.hide();
    $currentTextContent.show();
  };

  function getSlideshowId($el) {
    return "#Slideshow-" + $el.data("id");
  }

  return slideshow;
})();

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  theme.Video.loadVideos();
}

theme.Video = (function () {
  var autoplayCheckComplete = false;
  var playOnClickChecked = false;
  var playOnClick = false;
  var youtubeLoaded = false;
  var videos = {};
  var videoPlayers = [];
  var videoOptions = {
    ratio: 16 / 9,
    scrollAnimationDuration: 400,
    playerVars: {
      // eslint-disable-next-line camelcase
      iv_load_policy: 3,
      modestbranding: 1,
      autoplay: 0,
      controls: 0,
      wmode: "opaque",
      branding: 0,
      autohide: 0,
      rel: 0,
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerChange,
    },
  };
  var classes = {
    playing: "video-is-playing",
    paused: "video-is-paused",
    loading: "video-is-loading",
    loaded: "video-is-loaded",
    backgroundVideoWrapper: "video-background-wrapper",
    videoWithImage: "video--image_with_play",
    backgroundVideo: "video--background",
    userPaused: "is-paused",
    supportsAutoplay: "autoplay",
    supportsNoAutoplay: "no-autoplay",
    wrapperMinHeight: "video-section-wrapper--min-height",
  };

  var selectors = {
    section: ".video-section",
    videoWrapper: ".video-section-wrapper",
    playVideoBtn: ".video-control__play",
    closeVideoBtn: ".video-control__close-wrapper",
    pauseVideoBtn: ".video__pause",
    pauseVideoStop: ".video__pause-stop",
    pauseVideoResume: ".video__pause-resume",
    fallbackText: ".icon__fallback-text",
  };

  /**
   * Public functions
   */
  function init($video) {
    if (!$video.length) {
      return;
    }

    videos[$video.attr("id")] = {
      id: $video.attr("id"),
      videoId: $video.data("id"),
      type: $video.data("type"),
      status:
        $video.data("type") === "image_with_play" ? "closed" : "background", // closed, open, background
      $video: $video,
      $videoWrapper: $video.closest(selectors.videoWrapper),
      $section: $video.closest(selectors.section),
      controls: $video.data("type") === "background" ? 0 : 1,
    };

    if (!youtubeLoaded) {
      // This code loads the IFrame Player API code asynchronously.
      var tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      var firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    playOnClickCheck();
  }

  function customPlayVideo(playerId) {
    // Make sure we have carried out the playOnClick check first
    if (!playOnClickChecked && !playOnClick) {
      return;
    }

    if (playerId && typeof videoPlayers[playerId].playVideo === "function") {
      privatePlayVideo(playerId);
    }
  }

  function pauseVideo(playerId) {
    if (
      videoPlayers[playerId] &&
      typeof videoPlayers[playerId].pauseVideo === "function"
    ) {
      videoPlayers[playerId].pauseVideo();
    }
  }

  function loadVideos() {
    for (var key in videos) {
      // eslint-disable-next-line no-prototype-builtins
      if (videos.hasOwnProperty(key)) {
        createPlayer(key);
      }
    }

    initEvents();
    youtubeLoaded = true;
  }

  function editorLoadVideo(key) {
    if (!youtubeLoaded) {
      return;
    }
    createPlayer(key);

    initEvents();
  }

  /**
   * Private functions
   */

  function privatePlayVideo(id, clicked) {
    var videoData = videos[id];
    var player = videoPlayers[id];
    var $videoWrapper = videoData.$videoWrapper;

    if (playOnClick) {
      // playOnClick means we are probably on mobile (no autoplay).
      // setAsPlaying will show the iframe, requiring another click
      // to play the video.
      setAsPlaying(videoData);
    } else if (clicked || autoplayCheckComplete) {
      // Play if autoplay is available or clicked to play
      $videoWrapper.removeClass(classes.loading);
      setAsPlaying(videoData);
      player.playVideo();
      return;
    } else {
      player.playVideo();
    }
  }

  function setAutoplaySupport(supported) {
    var supportClass = supported
      ? classes.supportsAutoplay
      : classes.supportsNoAutoplay;
    $(document.documentElement)
      .removeClass(classes.supportsAutoplay)
      .removeClass(classes.supportsNoAutoplay)
      .addClass(supportClass);

    if (!supported) {
      playOnClick = true;
    }

    autoplayCheckComplete = true;
  }

  function playOnClickCheck() {
    // Bail early for a few instances:
    // - small screen
    // - device sniff mobile browser

    if (playOnClickChecked) {
      return;
    }

    if (isMobile()) {
      playOnClick = true;
    }

    if (playOnClick) {
      // No need to also do the autoplay check
      setAutoplaySupport(false);
    }

    playOnClickChecked = true;
  }

  // The API will call this function when each video player is ready
  function onPlayerReady(evt) {
    evt.target.setPlaybackQuality("hd1080");
    var videoData = getVideoOptions(evt);
    var videoTitle = evt.target.getVideoData().title;
    playOnClickCheck();

    // Prevent tabbing through YouTube player controls until visible
    $("#" + videoData.id).attr("tabindex", "-1");

    sizeBackgroundVideos();
    setButtonLabels(videoData.$videoWrapper, videoTitle);

    // Customize based on options from the video ID
    if (videoData.type === "background") {
      evt.target.mute();
      privatePlayVideo(videoData.id);
    }

    videoData.$videoWrapper.addClass(classes.loaded);
  }

  function onPlayerChange(evt) {
    var videoData = getVideoOptions(evt);
    if (
      videoData.status === "background" &&
      !isMobile() &&
      !autoplayCheckComplete &&
      (evt.data === YT.PlayerState.PLAYING ||
        evt.data === YT.PlayerState.BUFFERING)
    ) {
      setAutoplaySupport(true);
      autoplayCheckComplete = true;
      videoData.$videoWrapper.removeClass(classes.loading);
    }
    switch (evt.data) {
      case YT.PlayerState.ENDED:
        setAsFinished(videoData);
        break;
      case YT.PlayerState.PAUSED:
        // Seeking on a YouTube video also fires a PAUSED state change,
        // checking the state after a delay prevents us pausing the video when
        // the user is seeking instead of pausing
        setTimeout(function () {
          if (evt.target.getPlayerState() === YT.PlayerState.PAUSED) {
            setAsPaused(videoData);
          }
        }, 200);
        break;
    }
  }

  function setAsFinished(videoData) {
    switch (videoData.type) {
      case "background":
        videoPlayers[videoData.id].seekTo(0);
        break;
      case "image_with_play":
        closeVideo(videoData.id);
        toggleExpandVideo(videoData.id, false);
        break;
    }
  }

  function setAsPlaying(videoData) {
    var $videoWrapper = videoData.$videoWrapper;
    var $pauseButton = $videoWrapper.find(selectors.pauseVideoBtn);

    $videoWrapper.removeClass(classes.loading);

    if ($pauseButton.hasClass(classes.userPaused)) {
      $pauseButton.removeClass(classes.userPaused);
    }

    // Do not change element visibility if it is a background video
    if (videoData.status === "background") {
      return;
    }

    $("#" + videoData.id).attr("tabindex", "0");

    if (videoData.type === "image_with_play") {
      $videoWrapper.removeClass(classes.paused).addClass(classes.playing);
    }

    // Update focus to the close button so we stay within the video wrapper,
    // allowing time for the scroll animation
    setTimeout(function () {
      $videoWrapper.find(selectors.closeVideoBtn).focus();
    }, videoOptions.scrollAnimationDuration);
  }

  function setAsPaused(videoData) {
    var $videoWrapper = videoData.$videoWrapper;

    // YT's events fire after our click event. This status flag ensures
    // we don't interact with a closed or background video.
    if (videoData.type === "image_with_play") {
      if (videoData.status === "closed") {
        $videoWrapper.removeClass(classes.paused);
      } else {
        $videoWrapper.addClass(classes.paused);
      }
    }

    $videoWrapper.removeClass(classes.playing);
  }

  function closeVideo(playerId) {
    var videoData = videos[playerId];
    var $videoWrapper = videoData.$videoWrapper;
    var classesToRemove = [classes.paused, classes.playing].join(" ");

    if (isMobile()) {
      $videoWrapper.removeAttr("style");
    }

    $("#" + videoData.id).attr("tabindex", "-1");

    videoData.status = "closed";

    switch (videoData.type) {
      case "image_with_play":
        videoPlayers[playerId].stopVideo();
        setAsPaused(videoData); // in case the video is already paused
        break;
      case "background":
        videoPlayers[playerId].mute();
        setBackgroundVideo(playerId);
        break;
    }

    $videoWrapper.removeClass(classesToRemove);
  }

  function getVideoOptions(evt) {
    return videos[evt.target.a.id];
  }

  function toggleExpandVideo(playerId, expand) {
    var video = videos[playerId];
    var elementTop = video.$videoWrapper.offset().top;
    var $playButton = video.$videoWrapper.find(selectors.playVideoBtn);
    var offset = 0;
    var newHeight = 0;

    if (isMobile()) {
      video.$videoWrapper.parent().toggleClass("page-width", !expand);
    }

    if (expand) {
      if (isMobile()) {
        newHeight = $(window).width() / videoOptions.ratio;
      } else {
        newHeight = video.$videoWrapper.width() / videoOptions.ratio;
      }
      offset = ($(window).height() - newHeight) / 2;

      video.$videoWrapper
        .removeClass(classes.wrapperMinHeight)
        .animate({ height: newHeight }, 600);

      // Animate doesn't work in mobile editor, so we don't use it
      if (!(isMobile() && Shopify.designMode)) {
        $("html, body").animate(
          {
            scrollTop: elementTop - offset,
          },
          videoOptions.scrollAnimationDuration
        );
      }
    } else {
      if (isMobile()) {
        newHeight = video.$videoWrapper.data("mobile-height");
      } else {
        newHeight = video.$videoWrapper.data("desktop-height");
      }

      video.$videoWrapper
        .height(video.$videoWrapper.width() / videoOptions.ratio)
        .animate({ height: newHeight }, 600);
      setTimeout(function () {
        video.$videoWrapper.addClass(classes.wrapperMinHeight);
      }, 600);
      $playButton.focus();
    }
  }

  function togglePause(playerId) {
    var $pauseButton = videos[playerId].$videoWrapper.find(
      selectors.pauseVideoBtn
    );
    var paused = $pauseButton.hasClass(classes.userPaused);
    if (paused) {
      $pauseButton.removeClass(classes.userPaused);
      customPlayVideo(playerId);
    } else {
      $pauseButton.addClass(classes.userPaused);
      pauseVideo(playerId);
    }
    $pauseButton.attr("aria-pressed", !paused);
  }

  function startVideoOnClick(playerId) {
    var video = videos[playerId];

    // add loading class to wrapper
    video.$videoWrapper.addClass(classes.loading);

    // Explicity set the video wrapper height (needed for height transition)
    video.$videoWrapper.attr(
      "style",
      "height: " + video.$videoWrapper.height() + "px"
    );

    video.status = "open";

    switch (video.type) {
      case "image_with_play":
        privatePlayVideo(playerId, true);
        break;
      case "background":
        unsetBackgroundVideo(playerId, video);
        videoPlayers[playerId].unMute();
        privatePlayVideo(playerId, true);
        break;
    }

    toggleExpandVideo(playerId, true);

    // esc to close video player
    $(document).on("keydown.videoPlayer", function (evt) {
      var playerId = $(document.activeElement).data("controls");
      if (evt.keyCode !== slate.utils.keyboardKeys.ESCAPE || !playerId) {
        return;
      }

      closeVideo(playerId);
      toggleExpandVideo(playerId, false);
    });
  }

  function sizeBackgroundVideos() {
    $("." + classes.backgroundVideo).each(function (index, el) {
      sizeBackgroundVideo($(el));
    });
  }

  function sizeBackgroundVideo($videoPlayer) {
    if (!youtubeLoaded) {
      return;
    }

    if (isMobile()) {
      $videoPlayer.removeAttr("style");
    } else {
      var $videoWrapper = $videoPlayer.closest(selectors.videoWrapper);
      var videoWidth = $videoWrapper.width();
      var playerWidth = $videoPlayer.width();
      var desktopHeight = $videoWrapper.data("desktop-height");

      // when screen aspect ratio differs from video, video must center and underlay one dimension
      if (videoWidth / videoOptions.ratio < desktopHeight) {
        playerWidth = Math.ceil(desktopHeight * videoOptions.ratio); // get new player width
        $videoPlayer
          .width(playerWidth)
          .height(desktopHeight)
          .css({
            left: (videoWidth - playerWidth) / 2,
            top: 0,
          }); // player width is greater, offset left; reset top
      } else {
        // new video width < window width (gap to right)
        desktopHeight = Math.ceil(videoWidth / videoOptions.ratio); // get new player height
        $videoPlayer
          .width(videoWidth)
          .height(desktopHeight)
          .css({
            left: 0,
            // eslint-disable-next-line sonarjs/no-identical-expressions
            top: (desktopHeight - desktopHeight) / 2,
          }); // player height is greater, offset top; reset left
      }

      $videoPlayer.prepareTransition();
      $videoWrapper.addClass(classes.loaded);
    }
  }

  function unsetBackgroundVideo(playerId) {
    // Switch the background video to a chrome-only player once played
    $("#" + playerId)
      .removeClass(classes.backgroundVideo)
      .addClass(classes.videoWithImage);

    setTimeout(function () {
      $("#" + playerId).removeAttr("style");
    }, 600);

    videos[playerId].$videoWrapper
      .removeClass(classes.backgroundVideoWrapper)
      .addClass(classes.playing);

    videos[playerId].status = "open";
  }

  function setBackgroundVideo(playerId) {
    $("#" + playerId)
      .removeClass(classes.videoWithImage)
      .addClass(classes.backgroundVideo);

    videos[playerId].$videoWrapper.addClass(classes.backgroundVideoWrapper);

    videos[playerId].status = "background";
    sizeBackgroundVideo($("#" + playerId));
  }

  function isMobile() {
    return $(window).width() < 750 || window.mobileCheck();
  }

  function initEvents() {
    $(document).on("click.videoPlayer", selectors.playVideoBtn, function (evt) {
      var playerId = $(evt.currentTarget).data("controls");

      startVideoOnClick(playerId);
    });

    $(document).on("click.videoPlayer", selectors.closeVideoBtn, function (
      evt
    ) {
      var playerId = $(evt.currentTarget).data("controls");

      $(evt.currentTarget).blur();
      closeVideo(playerId);
      toggleExpandVideo(playerId, false);
    });

    $(document).on("click.videoPlayer", selectors.pauseVideoBtn, function (
      evt
    ) {
      var playerId = $(evt.currentTarget).data("controls");
      togglePause(playerId);
    });

    // Listen to resize to keep a background-size:cover-like layout
    $(window).on(
      "resize.videoPlayer",
      $.debounce(200, function () {
        if (!youtubeLoaded) return;
        var key;
        var fullscreen = window.innerHeight === screen.height;

        sizeBackgroundVideos();

        if (isMobile()) {
          for (key in videos) {
            // eslint-disable-next-line no-prototype-builtins
            if (videos.hasOwnProperty(key)) {
              if (videos[key].$videoWrapper.hasClass(classes.playing)) {
                if (!fullscreen) {
                  pauseVideo(key);
                  setAsPaused(videos[key]);
                }
              }
              videos[key].$videoWrapper.height(
                $(document).width() / videoOptions.ratio
              );
            }
          }
          setAutoplaySupport(false);
        } else {
          setAutoplaySupport(true);
          for (key in videos) {
            if (
              videos[key].$videoWrapper.find("." + classes.videoWithImage)
                .length
            ) {
              continue;
            }
            videoPlayers[key].playVideo();
            setAsPlaying(videos[key]);
          }
        }
      })
    );

    $(window).on(
      "scroll.videoPlayer",
      $.debounce(50, function () {
        if (!youtubeLoaded) return;

        for (var key in videos) {
          // eslint-disable-next-line no-prototype-builtins
          if (videos.hasOwnProperty(key)) {
            var $videoWrapper = videos[key].$videoWrapper;

            // Close the video if more than 75% of it is scrolled out of view
            if (
              $videoWrapper.hasClass(classes.playing) &&
              ($videoWrapper.offset().top + $videoWrapper.height() * 0.75 <
                $(window).scrollTop() ||
                $videoWrapper.offset().top + $videoWrapper.height() * 0.25 >
                  $(window).scrollTop() + $(window).height())
            ) {
              closeVideo(key);
              toggleExpandVideo(key, false);
            }
          }
        }
      })
    );
  }

  function createPlayer(key) {
    var args = $.extend({}, videoOptions, videos[key]);
    args.playerVars.controls = args.controls;
    videoPlayers[key] = new YT.Player(key, args);
  }

  function removeEvents() {
    $(document).off(".videoPlayer");
    $(window).off(".videoPlayer");
  }

  function setButtonLabels($videoWrapper, title) {
    var $playButtons = $videoWrapper.find(selectors.playVideoBtn);
    var $closeButton = $videoWrapper.find(selectors.closeVideoBtn);
    var $pauseButton = $videoWrapper.find(selectors.pauseVideoBtn);
    var $closeButtonText = $closeButton.find(selectors.fallbackText);
    var $pauseButtonStopText = $pauseButton
      .find(selectors.pauseVideoStop)
      .find(selectors.fallbackText);
    var $pauseButtonResumeText = $pauseButton
      .find(selectors.pauseVideoResume)
      .find(selectors.fallbackText);

    // Insert the video title retrieved from YouTube into the instructional text
    // for each button
    $playButtons.each(function () {
      var $playButton = $(this);
      var $playButtonText = $playButton.find(selectors.fallbackText);

      $playButtonText.text(
        $playButtonText.text().replace("[video_title]", title)
      );
    });
    $closeButtonText.text(
      $closeButtonText.text().replace("[video_title]", title)
    );
    $pauseButtonStopText.text(
      $pauseButtonStopText.text().replace("[video_title]", title)
    );
    $pauseButtonResumeText.text(
      $pauseButtonResumeText.text().replace("[video_title]", title)
    );
  }

  return {
    init: init,
    editorLoadVideo: editorLoadVideo,
    loadVideos: loadVideos,
    playVideo: customPlayVideo,
    pauseVideo: pauseVideo,
    removeEvents: removeEvents,
  };
})();

window.theme = window.theme || {};

theme.FormStatus = (function () {
  var selectors = {
    statusMessage: "[data-form-status]",
  };

  function init() {
    this.$statusMessage = $(selectors.statusMessage);

    if (!this.$statusMessage) return;

    this.$statusMessage.attr("tabindex", -1).focus();

    this.$statusMessage.on("blur", handleBlur.bind(this));
  }

  function handleBlur() {
    this.$statusMessage.removeAttr("tabindex");
  }

  return {
    init: init,
  };
})();

theme.Hero = (function () {
  var classes = {
    indexSectionFlush: "index-section--flush",
  };

  var selectors = {
    heroFixedWidthContent: ".hero-fixed-width__content",
    heroFixedWidthImage: ".hero-fixed-width__image",
  };

  function hero(el, sectionId) {
    this.$hero = $(el);
    this.layout = this.$hero.data("layout");
    var $parentSection = $("#shopify-section-" + sectionId);
    var $heroContent = $parentSection.find(selectors.heroFixedWidthContent);
    var $heroImage = $parentSection.find(selectors.heroFixedWidthImage);

    if (this.layout !== "fixed_width") {
      return;
    }

    $parentSection.removeClass(classes.indexSectionFlush);
    heroFixedHeight();
    $(window).resize(
      $.debounce(50, function () {
        heroFixedHeight();
      })
    );

    function heroFixedHeight() {
      var contentHeight = $heroContent.height() + 50;
      var imageHeight = $heroImage.height();

      if (contentHeight > imageHeight) {
        $heroImage.css("min-height", contentHeight);
      }
    }
  }

  return hero;
})();

/* ================ TEMPLATES ================ */
(function () {
  var $filterBy = $("#BlogTagFilter");

  if (!$filterBy.length) {
    return;
  }

  $filterBy.on("change", function () {
    location.href = $(this).val();
  });
})();

window.theme = theme || {};

theme.customerTemplates = (function () {
  var selectors = {
    RecoverHeading: "#RecoverHeading",
    RecoverEmail: "#RecoverEmail",
    LoginHeading: "#LoginHeading",
  };

  function initEventListeners() {
    this.$RecoverHeading = $(selectors.RecoverHeading);
    this.$RecoverEmail = $(selectors.RecoverEmail);
    this.$LoginHeading = $(selectors.LoginHeading);

    // Show reset password form
    $("#RecoverPassword").on(
      "click",
      function (evt) {
        evt.preventDefault();
        showRecoverPasswordForm();
        this.$RecoverHeading.attr("tabindex", "-1").focus();
      }.bind(this)
    );

    // Hide reset password form
    $("#HideRecoverPasswordLink").on(
      "click",
      function (evt) {
        evt.preventDefault();
        hideRecoverPasswordForm();
        this.$LoginHeading.attr("tabindex", "-1").focus();
      }.bind(this)
    );

    this.$RecoverHeading.on("blur", function () {
      $(this).removeAttr("tabindex");
    });

    this.$LoginHeading.on("blur", function () {
      $(this).removeAttr("tabindex");
    });
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */

  function showRecoverPasswordForm() {
    $("#RecoverPasswordForm").removeClass("hide");
    $("#CustomerLoginForm").addClass("hide");

    if (this.$RecoverEmail.attr("aria-invalid") === "true") {
      this.$RecoverEmail.focus();
    }
  }

  function hideRecoverPasswordForm() {
    $("#RecoverPasswordForm").addClass("hide");
    $("#CustomerLoginForm").removeClass("hide");
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    var $formState = $(".reset-password-success");

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $("#ResetSuccess").removeClass("hide").focus();
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $("#AddressNewForm");
    var $newAddressFormButton = $("#AddressNewButton");

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(
        "AddressCountryNew",
        "AddressProvinceNew",
        {
          hideElement: "AddressProvinceContainerNew",
        }
      );
    }

    // Initialize each edit form's country/province selector
    $(".address-country-option").each(function () {
      var formId = $(this).data("form-id");
      var countrySelector = "AddressCountry_" + formId;
      var provinceSelector = "AddressProvince_" + formId;
      var containerSelector = "AddressProvinceContainer_" + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector,
      });
    });

    // Toggle new/edit address forms
    $(".address-new-toggle").on("click", function () {
      var isExpanded = $newAddressFormButton.attr("aria-expanded") === "true";

      $newAddressForm.toggleClass("hide");
      $newAddressFormButton.attr("aria-expanded", !isExpanded).focus();
    });

    $(".address-edit-toggle").on("click", function () {
      var formId = $(this).data("form-id");
      var $editButton = $("#EditFormButton_" + formId);
      var $editAddress = $("#EditAddress_" + formId);
      var isExpanded = $editButton.attr("aria-expanded") === "true";

      $editAddress.toggleClass("hide");
      $editButton.attr("aria-expanded", !isExpanded).focus();
    });

    $(".address-delete").on("click", function () {
      var $el = $(this);
      var target = $el.data("target");
      var confirmMessage = $el.data("confirm-message");

      // eslint-disable-next-line no-alert
      if (
        confirm(
          confirmMessage || "Are you sure you wish to delete this address?"
        )
      ) {
        Shopify.postLink(target, {
          parameters: { _method: "delete" },
        });
      }
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === "#recover") {
      showRecoverPasswordForm.bind(this)();
    }
  }

  return {
    init: function () {
      initEventListeners();
      checkUrlHash();
      resetPasswordSuccess();
      customerAddressForm();
    },
  };
})();

/*================ SECTIONS ================*/
window.theme = window.theme || {};

theme.Cart = (function () {
  var selectors = {
    cartCount: "[data-cart-count]",
    cartCountBubble: "[data-cart-count-bubble]",
    cartDiscount: "[data-cart-discount]",
    cartDiscountTitle: "[data-cart-discount-title]",
    cartDiscountAmount: "[data-cart-discount-amount]",
    cartDiscountWrapper: "[data-cart-discount-wrapper]",
    cartErrorMessage: "[data-cart-error-message]",
    cartErrorMessageWrapper: "[data-cart-error-message-wrapper]",
    cartItem: "[data-cart-item]",
    cartItemDetails: "[data-cart-item-details]",
    cartItemDiscount: "[data-cart-item-discount]",
    cartItemDiscountedPriceGroup: "[data-cart-item-discounted-price-group]",
    cartItemDiscountTitle: "[data-cart-item-discount-title]",
    cartItemDiscountAmount: "[data-cart-item-discount-amount]",
    cartItemDiscountList: "[data-cart-item-discount-list]",
    cartItemFinalPrice: "[data-cart-item-final-price]",
    cartItemImage: "[data-cart-item-image]",
    cartItemLinePrice: "[data-cart-item-line-price]",
    cartItemOriginalPrice: "[data-cart-item-original-price]",
    cartItemPrice: "[data-cart-item-price]",
    cartItemPriceList: "[data-cart-item-price-list]",
    cartItemProperty: "[data-cart-item-property]",
    cartItemPropertyName: "[data-cart-item-property-name]",
    cartItemPropertyValue: "[data-cart-item-property-value]",
    cartItemRegularPriceGroup: "[data-cart-item-regular-price-group]",
    cartItemRegularPrice: "[data-cart-item-regular-price]",
    cartItemTitle: "[data-cart-item-title]",
    cartItemOption: "[data-cart-item-option]",
    cartLineItems: "[data-cart-line-items]",
    cartNote: "[data-cart-notes]",
    cartQuantityErrorMessage: "[data-cart-quantity-error-message]",
    cartQuantityErrorMessageWrapper:
      "[data-cart-quantity-error-message-wrapper]",
    cartRemove: "[data-cart-remove]",
    cartStatus: "[data-cart-status]",
    cartSubtotal: "[data-cart-subtotal]",
    cartTableCell: "[data-cart-table-cell]",
    cartWrapper: "[data-cart-wrapper]",
    emptyPageContent: "[data-empty-page-content]",
    quantityInput: "[data-quantity-input]",
    quantityInputMobile: "[data-quantity-input-mobile]",
    quantityInputDesktop: "[data-quantity-input-desktop]",
    quantityLabelMobile: "[data-quantity-label-mobile]",
    quantityLabelDesktop: "[data-quantity-label-desktop]",
    inputQty: "[data-quantity-input]",
    thumbnails: ".cart__image",
    unitPrice: "[data-unit-price]",
    unitPriceBaseUnit: "[data-unit-price-base-unit]",
    unitPriceGroup: "[data-unit-price-group]",
  };

  var classes = {
    cartNoCookies: "cart--no-cookies",
    cartRemovedProduct: "cart__removed-product",
    hide: "hide",
    inputError: "input--error",
  };

  var attributes = {
    cartItemIndex: "data-cart-item-index",
    cartItemKey: "data-cart-item-key",
    cartItemQuantity: "data-cart-item-quantity",
    cartItemTitle: "data-cart-item-title",
    cartItemUrl: "data-cart-item-url",
    quantityItem: "data-quantity-item",
  };

  var mediumUpQuery = "(min-width: " + theme.breakpoints.medium + "px)";

  function Cart(container) {
    this.$container = $(container);
    this.$thumbnails = $(selectors.thumbnails, this.$container);
    this.ajaxEnabled = this.$container.data("ajax-enabled");

    if (!this.cookiesEnabled()) {
      this.$container.addClass(classes.cartNoCookies);
    }

    this.$thumbnails.css("cursor", "pointer");
    this.$container.on(
      "click",
      selectors.thumbnails,
      this._handleThumbnailClick
    );

    this.$container.on(
      "change",
      selectors.inputQty,
      $.debounce(500, this._handleInputQty.bind(this))
    );

    this.mql = window.matchMedia(mediumUpQuery);
    this.mql.addListener(this.setQuantityFormControllers.bind(this));
    this.setQuantityFormControllers();

    if (this.ajaxEnabled) {
      /**
       * Because the entire cart is recreated when a cart item is updated,
       * we cannot cache the elements in the cart. Instead, we add the event
       * listeners on the cart's container to allow us to retain the event
       * listeners after rebuilding the cart when an item is updated.
       */

      this.$container.on(
        "change",
        selectors.cartNote,
        this._onNoteChange.bind(this)
      );

      this.$container.on(
        "click",
        selectors.cartRemove,
        this._onRemoveItem.bind(this)
      );

      this._setupCartTemplates();
    }
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    _setupCartTemplates: function () {
      this.$itemTemplate = $(selectors.cartItem, this.$container)
        .first()
        .clone();
      this.$itemDiscountTemplate = $(
        selectors.cartItemDiscount,
        this.$itemTemplate
      ).clone();
      this.$itemOptionTemplate = $(
        selectors.cartItemOption,
        this.$itemTemplate
      ).clone();
      this.$itemPropertyTemplate = $(
        selectors.cartItemProperty,
        this.$itemTemplate
      ).clone();
      this.$itemPriceListTemplate = $(
        selectors.cartItemPriceList,
        this.$itemTemplate
      ).clone();
      this.$itemLinePriceTemplate = $(
        selectors.cartItemLinePrice,
        this.$itemTemplate
      ).clone();
      this.$cartDiscountTemplate = $(
        selectors.cartDiscount,
        this.$container
      ).clone();
    },

    _handleInputQty: function (evt) {
      var $input = $(evt.target);
      var itemIndex = $input.data("quantity-item");
      var $itemElement = $input.closest(selectors.cartItem);
      var $itemQtyInputs = $("[data-quantity-item=" + itemIndex + "]");
      var value = parseInt($input.val());
      var isValidValue = !(value < 0 || isNaN(value));
      $itemQtyInputs.val(value);

      this._hideCartError();
      this._hideQuantityErrorMessage();

      if (!isValidValue) {
        this._showQuantityErrorMessages($itemElement);
        return;
      }

      if (isValidValue && this.ajaxEnabled) {
        this._updateItemQuantity(
          itemIndex,
          $itemElement,
          $itemQtyInputs,
          value
        );
      }
    },

    _updateItemQuantity: function (
      itemIndex,
      $itemElement,
      $itemQtyInputs,
      value
    ) {
      var key = $itemElement.attr(attributes.cartItemKey);
      var index = $itemElement.attr(attributes.cartItemIndex);

      var params = {
        url: "/cart/change.js",
        data: { quantity: value, line: index },
        dataType: "json",
      };

      $.post(params)
        .done(
          function (state) {
            if (state.item_count === 0) {
              this._emptyCart();
            } else {
              this._createCart(state);

              if (value === 0) {
                this._showRemoveMessage($itemElement.clone());
              } else {
                var $lineItem = $("[data-cart-item-key=\"" + key + "\"]");
                var item = this.getItem(key, state);

                $(selectors.quantityInput, $lineItem).focus();
                this._updateLiveRegion(item);
              }
            }

            this._setCartCountBubble(state.item_count);
          }.bind(this)
        )
        .fail(
          function () {
            this._showCartError($itemQtyInputs);
          }.bind(this)
        );
    },

    getItem: function (key, state) {
      return state.items.find(function (item) {
        return item.key === key;
      });
    },

    _liveRegionText: function (item) {
      // Dummy content for live region
      var liveRegionText =
        theme.strings.update +
        ": [QuantityLabel]: [Quantity], [Regular] [$$] [DiscountedPrice] [$]. [PriceInformation]";

      // Update Quantity
      liveRegionText = liveRegionText
        .replace("[QuantityLabel]", theme.strings.quantity)
        .replace("[Quantity]", item.quantity);

      // Update pricing information
      var regularLabel = "";
      var regularPrice = theme.Currency.formatMoney(
        item.original_line_price,
        theme.moneyFormat
      );
      var discountLabel = "";
      var discountPrice = "";
      var discountInformation = "";

      if (item.original_line_price > item.final_line_price) {
        regularLabel = theme.strings.regularTotal;

        discountLabel = theme.strings.discountedTotal;
        discountPrice = theme.Currency.formatMoney(
          item.final_line_price,
          theme.moneyFormat
        );

        discountInformation = theme.strings.priceColumn;
      }

      liveRegionText = liveRegionText
        .replace("[Regular]", regularLabel)
        .replace("[$$]", regularPrice)
        .replace("[DiscountedPrice]", discountLabel)
        .replace("[$]", discountPrice)
        .replace("[PriceInformation]", discountInformation)
        .trim();

      return liveRegionText;
    },

    _updateLiveRegion: function (item) {
      var $liveRegion = $(selectors.cartStatus);
      $liveRegion.html(this._liveRegionText(item)).attr("aria-hidden", false);

      // hide content from accessibility tree after announcement
      setTimeout(function () {
        $liveRegion.attr("aria-hidden", true);
      }, 1000);
    },

    _createCart: function (state) {
      var cartDiscountList = this._createCartDiscountList(state);

      $(selectors.cartLineItems, this.$container).html(
        this._createLineItemList(state)
      );

      this.setQuantityFormControllers();

      $(selectors.cartNote, this.$container).val(state.note);

      if (cartDiscountList.length === 0) {
        $(selectors.cartDiscountWrapper, this.$container)
          .html("")
          .addClass(classes.hide);
      } else {
        $(selectors.cartDiscountWrapper, this.$container)
          .html(cartDiscountList)
          .removeClass(classes.hide);
      }

      $(selectors.cartSubtotal, this.$container).html(
        theme.Currency.formatMoney(
          state.total_price,
          theme.moneyFormatWithCurrency
        )
      );
    },

    _createCartDiscountList: function (cart) {
      return $.map(
        cart.cart_level_discount_applications,
        function (discount) {
          var $discount = this.$cartDiscountTemplate.clone();
          $discount.find(selectors.cartDiscountTitle).text(discount.title);
          $discount
            .find(selectors.cartDiscountAmount)
            .html(
              theme.Currency.formatMoney(
                discount.total_allocated_amount,
                theme.moneyFormat
              )
            );
          return $discount[0];
        }.bind(this)
      );
    },

    _createLineItemList: function (state) {
      return $.map(
        state.items,
        function (item, index) {
          var $item = this.$itemTemplate.clone();
          var $itemPriceList = this.$itemPriceListTemplate.clone();

          this._setLineItemAttributes($item, item, index);
          this._setLineItemImage($item, item.featured_image);

          $(selectors.cartItemTitle, $item)
            .text(item.product_title)
            .attr("href", item.url);

          var productDetailsList = this._createProductDetailsList(
            item.product_has_only_default_variant,
            item.options_with_values,
            item.properties
          );
          this._setProductDetailsList($item, productDetailsList);

          this._setItemRemove($item, item.title);

          $itemPriceList.html(
            this._createItemPrice(
              item.original_price,
              item.final_price,
              this.$itemPriceListTemplate
            )
          );

          if (item.unit_price_measurement) {
            $itemPriceList.append(
              this._createUnitPrice(
                item.unit_price,
                item.unit_price_measurement,
                this.$itemPriceListTemplate
              )
            );
          }

          this._setItemPrice($item, $itemPriceList);

          var itemDiscountList = this._createItemDiscountList(item);
          this._setItemDiscountList($item, itemDiscountList);

          this._setQuantityInputs($item, item, index);

          var itemLinePrice = this._createItemPrice(
            item.original_line_price,
            item.final_line_price,
            this.$itemLinePriceTemplate
          );
          this._setItemLinePrice($item, itemLinePrice);

          return $item[0];
        }.bind(this)
      );
    },

    _setLineItemAttributes: function ($item, item, index) {
      $item
        .attr(attributes.cartItemKey, item.key)
        .attr(attributes.cartItemUrl, item.url)
        .attr(attributes.cartItemTitle, item.title)
        .attr(attributes.cartItemIndex, index + 1)
        .attr(attributes.cartItemQuantity, item.quantity);
    },

    _setLineItemImage: function ($item, featuredImage) {
      var $image = $(selectors.cartItemImage, $item);

      var sizedImageUrl =
        featuredImage.url !== null
          ? theme.Images.getSizedImageUrl(featuredImage.url, "x190")
          : null;

      if (sizedImageUrl) {
        $image
          .attr("alt", featuredImage.alt)
          .attr("src", sizedImageUrl)
          .removeClass(classes.hide);
      } else {
        $image.remove();
      }
    },

    _setProductDetailsList: function ($item, productDetailsList) {
      var $itemDetails = $(selectors.cartItemDetails, $item);

      if (productDetailsList.length === 0) {
        $itemDetails.addClass(classes.hide).text("");
      } else {
        $itemDetails.removeClass(classes.hide).html(productDetailsList);
      }
    },

    _setItemPrice: function ($item, price) {
      $(selectors.cartItemPrice, $item).html(price);
    },

    _setItemDiscountList: function ($item, discountList) {
      var $itemDiscountList = $(selectors.cartItemDiscountList, $item);

      if (discountList.length === 0) {
        $itemDiscountList.html("").addClass(classes.hide);
      } else {
        $itemDiscountList.html(discountList).removeClass(classes.hide);
      }
    },

    _setItemRemove: function ($item, title) {
      $(selectors.cartRemove, $item).attr(
        "aria-label",
        theme.strings.removeLabel.replace("[product]", title)
      );
    },

    _setQuantityInputs: function ($item, item, index) {
      $(selectors.quantityInputMobile, $item)
        .attr("id", "updates_" + item.key)
        .attr(attributes.quantityItem, index + 1)
        .val(item.quantity);

      $(selectors.quantityInputDesktop, $item)
        .attr("id", "updates_large_" + item.key)
        .attr(attributes.quantityItem, index + 1)
        .val(item.quantity);

      $(selectors.quantityLabelMobile, $item).attr(
        "for",
        "updates_" + item.key
      );

      $(selectors.quantityLabelDesktop, $item).attr(
        "for",
        "updates_large_" + item.key
      );
    },

    setQuantityFormControllers: function () {
      if (this.mql.matches) {
        $(selectors.quantityInputDesktop).attr("name", "updates[]");
        $(selectors.quantityInputMobile).removeAttr("name");
      } else {
        $(selectors.quantityInputMobile).attr("name", "updates[]");
        $(selectors.quantityInputDesktop).removeAttr("name");
      }
    },

    _setItemLinePrice: function ($item, price) {
      $(selectors.cartItemLinePrice, $item).html(price);
    },

    _createProductDetailsList: function (
      product_has_only_default_variant,
      options,
      properties
    ) {
      var optionsPropertiesHTML = [];

      if (!product_has_only_default_variant) {
        optionsPropertiesHTML = optionsPropertiesHTML.concat(
          this._getOptionList(options)
        );
      }

      if (properties !== null && Object.keys(properties).length !== 0) {
        optionsPropertiesHTML = optionsPropertiesHTML.concat(
          this._getPropertyList(properties)
        );
      }

      return optionsPropertiesHTML;
    },

    _getOptionList: function (options) {
      return $.map(
        options,
        function (option) {
          var $optionElement = this.$itemOptionTemplate.clone();

          $optionElement
            .text(option.name + ": " + option.value)
            .removeClass(classes.hide);

          return $optionElement[0];
        }.bind(this)
      );
    },

    _getPropertyList: function (properties) {
      var propertiesArray =
        properties !== null ? Object.entries(properties) : [];

      return $.map(
        propertiesArray,
        function (property) {
          var $propertyElement = this.$itemPropertyTemplate.clone();

          // Line item properties prefixed with an underscore are not to be displayed
          if (property[0].charAt(0) === "_") return;

          // if the property value has a length of 0 (empty), don't display it
          if (property[1].length === 0) return;

          $propertyElement
            .find(selectors.cartItemPropertyName)
            .text(property[0]);

          if (property[0].indexOf("/uploads/") === -1) {
            $propertyElement
              .find(selectors.cartItemPropertyValue)
              .text(": " + property[1]);
          } else {
            $propertyElement
              .find(selectors.cartItemPropertyValue)
              .html(
                ": <a href=\"" +
                  property[1] +
                  "\"> " +
                  property[1].split("/").pop() +
                  "</a>"
              );
          }

          $propertyElement.removeClass(classes.hide);

          return $propertyElement[0];
        }.bind(this)
      );
    },

    _createItemPrice: function (original_price, final_price, $priceTemplate) {
      if (original_price !== final_price) {
        var $discountedPrice = $(
          selectors.cartItemDiscountedPriceGroup,
          $priceTemplate
        ).clone();

        $(selectors.cartItemOriginalPrice, $discountedPrice).html(
          theme.Currency.formatMoney(original_price, theme.moneyFormat)
        );
        $(selectors.cartItemFinalPrice, $discountedPrice).html(
          theme.Currency.formatMoney(final_price, theme.moneyFormat)
        );
        $discountedPrice.removeClass(classes.hide);

        return $discountedPrice[0];
      } else {
        var $regularPrice = $(
          selectors.cartItemRegularPriceGroup,
          $priceTemplate
        ).clone();

        $(selectors.cartItemRegularPrice, $regularPrice).html(
          theme.Currency.formatMoney(original_price, theme.moneyFormat)
        );

        $regularPrice.removeClass(classes.hide);

        return $regularPrice[0];
      }
    },

    _createUnitPrice: function (
      unitPrice,
      unitPriceMeasurement,
      $itemPriceGroup
    ) {
      var $unitPriceGroup = $(
        selectors.unitPriceGroup,
        $itemPriceGroup
      ).clone();

      var unitPriceBaseUnit =
        (unitPriceMeasurement.reference_value !== 1
          ? unitPriceMeasurement.reference_value
          : "") + unitPriceMeasurement.reference_unit;

      $(selectors.unitPriceBaseUnit, $unitPriceGroup).text(unitPriceBaseUnit);
      $(selectors.unitPrice, $unitPriceGroup).html(
        theme.Currency.formatMoney(unitPrice, theme.moneyFormat)
      );

      $unitPriceGroup.removeClass(classes.hide);

      return $unitPriceGroup[0];
    },

    _createItemDiscountList: function (item) {
      return $.map(
        item.line_level_discount_allocations,
        function (discount) {
          var $discount = this.$itemDiscountTemplate.clone();
          $discount
            .find(selectors.cartItemDiscountTitle)
            .text(discount.discount_application.title);
          $discount
            .find(selectors.cartItemDiscountAmount)
            .html(
              theme.Currency.formatMoney(discount.amount, theme.moneyFormat)
            );
          return $discount[0];
        }.bind(this)
      );
    },

    _showQuantityErrorMessages: function (itemElement) {
      $(selectors.cartQuantityErrorMessage, itemElement).text(
        theme.strings.quantityMinimumMessage
      );

      $(selectors.cartQuantityErrorMessageWrapper, itemElement).removeClass(
        classes.hide
      );

      $(selectors.inputQty, itemElement).addClass(classes.inputError).focus();
    },

    _hideQuantityErrorMessage: function () {
      var $errorMessages = $(
        selectors.cartQuantityErrorMessageWrapper
      ).addClass(classes.hide);

      $(selectors.cartQuantityErrorMessage, $errorMessages).text("");

      $(selectors.inputQty, this.$container).removeClass(classes.inputError);
    },

    _handleThumbnailClick: function (evt) {
      var url = $(evt.target).closest(selectors.cartItem).data("cart-item-url");

      window.location.href = url;
    },

    _onNoteChange: function (evt) {
      var note = evt.currentTarget.value;
      this._hideCartError();
      this._hideQuantityErrorMessage();

      var params = {
        url: "/cart/update.js",
        data: { note: note },
        dataType: "json",
      };

      $.post(params).fail(
        function () {
          this._showCartError(evt.currentTarget);
        }.bind(this)
      );
    },

    _showCartError: function (elementToFocus) {
      $(selectors.cartErrorMessage).text(theme.strings.cartError);

      $(selectors.cartErrorMessageWrapper).removeClass(classes.hide);

      elementToFocus.focus();
    },

    _hideCartError: function () {
      $(selectors.cartErrorMessageWrapper).addClass(classes.hide);
      $(selectors.cartErrorMessage).text("");
    },

    _onRemoveItem: function (evt) {
      evt.preventDefault();
      var $remove = $(evt.target);
      var $lineItem = $remove.closest(selectors.cartItem);
      var index = $lineItem.attr(attributes.cartItemIndex);
      this._hideCartError();

      var params = {
        url: "/cart/change.js",
        data: { quantity: 0, line: index },
        dataType: "json",
      };

      $.post(params)
        .done(
          function (state) {
            if (state.item_count === 0) {
              this._emptyCart();
            } else {
              this._createCart(state);
              this._showRemoveMessage($lineItem.clone());
            }

            this._setCartCountBubble(state.item_count);
          }.bind(this)
        )
        .fail(
          function () {
            this._showCartError(null);
          }.bind(this)
        );
    },

    _showRemoveMessage: function (lineItem) {
      var index = lineItem.data("cart-item-index");
      var removeMessage = this._getRemoveMessage(lineItem);
      var $lineItemAtIndex;

      if (index - 1 === 0) {
        $lineItemAtIndex = $("[data-cart-item-index=\"1\"]", this.$container);
        $(removeMessage).insertBefore($lineItemAtIndex);
      } else {
        $lineItemAtIndex = $(
          "[data-cart-item-index=\"" + (index - 1) + "\"]",
          this.$container
        );
        removeMessage.insertAfter($lineItemAtIndex);
      }
      removeMessage.focus();
    },

    _getRemoveMessage: function (lineItem) {
      var formattedMessage = this._formatRemoveMessage(lineItem);

      var $tableCell = $(selectors.cartTableCell, lineItem).clone();
      $tableCell
        .removeClass()
        .addClass(classes.cartRemovedProduct)
        .attr("colspan", "4")
        .html(formattedMessage);

      lineItem.attr("role", "alert").html($tableCell).attr("tabindex", "-1");

      return lineItem;
    },

    _formatRemoveMessage: function (lineItem) {
      var quantity = lineItem.data("cart-item-quantity");
      var url = lineItem.attr(attributes.cartItemUrl);
      var title = lineItem.attr(attributes.cartItemTitle);

      return theme.strings.removedItemMessage
        .replace("[quantity]", quantity)
        .replace(
          "[link]",
          "<a " +
            "href=\"" +
            url +
            "\" class=\"text-link text-link--accent\">" +
            title +
            "</a>"
        );
    },

    _setCartCountBubble: function (quantity) {
      this.$cartCountBubble =
        this.$cartCountBubble || $(selectors.cartCountBubble);
      this.$cartCount = this.$cartCount || $(selectors.cartCount);

      if (quantity > 0) {
        this.$cartCountBubble.removeClass(classes.hide);
        this.$cartCount.html(quantity);
      } else {
        this.$cartCountBubble.addClass(classes.hide);
        this.$cartCount.html("");
      }
    },

    _emptyCart: function () {
      this.$emptyPageContent =
        this.$emptyPageContent ||
        $(selectors.emptyPageContent, this.$container);
      this.$cartWrapper =
        this.$cartWrapper || $(selectors.cartWrapper, this.$container);

      this.$emptyPageContent.removeClass(classes.hide);
      this.$cartWrapper.addClass(classes.hide);
    },

    cookiesEnabled: function () {
      var cookieEnabled = navigator.cookieEnabled;

      if (!cookieEnabled) {
        document.cookie = "testcookie";
        cookieEnabled = document.cookie.indexOf("testcookie") !== -1;
      }
      return cookieEnabled;
    },
  });

  return Cart;
})();

window.theme = window.theme || {};

theme.Filters = (function () {
  var settings = {
    // Breakpoints from src/stylesheets/global/variables.scss.liquid
    mediaQueryMediumUp: "screen and (min-width: 750px)",
  };

  var constants = {
    SORT_BY: "sort_by",
  };

  var selectors = {
    mainContent: "#MainContent",
    filterSelection: "#FilterTags",
    sortSelection: "#SortBy",
  };

  var data = {
    sortBy: "data-default-sortby",
  };

  function Filters(container) {
    var $container = (this.$container = $(container));

    this.$filterSelect = $(selectors.filterSelection, $container);
    this.$sortSelect = $(selectors.sortSelection, $container);
    this.$selects = $(selectors.filterSelection, $container).add(
      $(selectors.sortSelection, $container)
    );

    this.defaultSort = this._getDefaultSortValue();
    this.$selects.removeClass("hidden");

    this.$filterSelect.on("change", this._onFilterChange.bind(this));
    this.$sortSelect.on("change", this._onSortChange.bind(this));
    this._initBreakpoints();
  }

  Filters.prototype = _.assignIn({}, Filters.prototype, {
    _initBreakpoints: function () {
      enquire.register(settings.mediaQueryMediumUp, {
        match: function () {
          this._resizeSelect(this.$selects);
        },
      });
    },

    _onSortChange: function () {
      var sort = this._sortValue();
      var url = window.location.href.replace(window.location.search, "");
      var queryStringValue = slate.utils.getParameterByName("q");
      var query = queryStringValue !== null ? queryStringValue : "";

      if (sort.length) {
        var urlStripped = url.replace(window.location.hash, "");
        query = query !== "" ? "?q=" + query + "&" : "?";

        window.location.href =
          urlStripped + query + sort + selectors.mainContent;
      } else {
        // clean up our url if the sort value is blank for default
        window.location.href = url;
      }
    },

    _onFilterChange: function () {
      var filter = this._getFilterValue();

      // remove the 'page' parameter to go to the first page of results
      var search = document.location.search.replace(/\?(page=\w+)?&?/, "");

      // only add the search parameters to the url if they exist
      search = search !== "" ? "?" + search : "";

      document.location.href = filter + search + selectors.mainContent;
    },

    _getFilterValue: function () {
      return this.$filterSelect.val();
    },

    _getSortValue: function () {
      return this.$sortSelect.val() || this.defaultSort;
    },

    _getDefaultSortValue: function () {
      return this.$sortSelect.attr(data.sortBy);
    },

    _sortValue: function () {
      var sort = this._getSortValue();
      var query = "";

      if (sort !== this.defaultSort) {
        query = constants.SORT_BY + "=" + sort;
      }

      return query;
    },

    _resizeSelect: function ($selection) {
      $selection.each(function () {
        var $this = $(this);
        var arrowWidth = 10;
        // create test element
        var text = $this.find("option:selected").text();
        var $test = $("<span>").html(text);

        // add to body, get width, and get out
        $test.appendTo("body");
        var width = $test.width();
        $test.remove();

        // set select width
        $this.width(width + arrowWidth);
      });
    },

    onUnload: function () {
      this.$filterSelect.off("change", this._onFilterChange);
      this.$sortSelect.off("change", this._onSortChange);
    },
  });

  return Filters;
})();

window.theme = window.theme || {};

theme.HeaderSection = (function () {
  function Header() {
    theme.Header.init();
    theme.MobileNav.init();
    theme.Search.init();
    theme.Profile.init();
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    onUnload: function () {
      theme.Header.unload();
    },
  });

  return Header;
})();

theme.Maps = (function () {
  var config = {
    zoom: 14,
  };
  var apiStatus = null;
  var mapsToLoad = [];

  var errors = {
    addressNoResults: theme.strings.addressNoResults,
    addressQueryLimit: theme.strings.addressQueryLimit,
    addressError: theme.strings.addressError,
    authError: theme.strings.authError,
  };

  var selectors = {
    section: "[data-section-type=\"map\"]",
    map: "[data-map]",
    mapOverlay: "[data-map-overlay]",
  };

  var classes = {
    mapError: "map-section--load-error",
    errorMsg: "map-section__error errors text-center",
  };

  // Global function called by Google on auth errors.
  // Show an auto error message on all map instances.
  // eslint-disable-next-line camelcase, no-unused-vars
  window.gm_authFailure = function () {
    if (!Shopify.designMode) {
      return;
    }

    $(selectors.section).addClass(classes.mapError);
    $(selectors.map).remove();
    $(selectors.mapOverlay).after(
      "<div class=\"" +
        classes.errorMsg +
        "\">" +
        theme.strings.authError +
        "</div>"
    );
  };

  function Map(container) {
    this.$container = $(container);
    this.$map = this.$container.find(selectors.map);
    this.key = this.$map.data("api-key");

    if (typeof this.key === "undefined") {
      return;
    }

    if (apiStatus === "loaded") {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== "loading") {
        apiStatus = "loading";
        if (typeof window.google === "undefined") {
          $.getScript(
            "https://maps.googleapis.com/maps/api/js?key=" + this.key
          ).then(function () {
            apiStatus = "loaded";
            initAllMaps();
          });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function (index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data("address-setting");

    geocoder.geocode({ address: address }, function (results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function () {
      var $map = this.$map;

      return geolocate($map)
        .then(
          function (results) {
            var mapOptions = {
              zoom: config.zoom,
              center: results[0].geometry.location,
              draggable: false,
              clickableIcons: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true,
            };

            var map = (this.map = new google.maps.Map($map[0], mapOptions));
            var center = (this.center = map.getCenter());

            //eslint-disable-next-line no-unused-vars
            var marker = new google.maps.Marker({
              map: map,
              position: map.getCenter(),
            });

            google.maps.event.addDomListener(
              window,
              "resize",
              $.debounce(250, function () {
                google.maps.event.trigger(map, "resize");
                map.setCenter(center);
                $map.removeAttr("style");
              })
            );
          }.bind(this)
        )
        .fail(function () {
          var errorMessage;

          switch (status) {
            case "ZERO_RESULTS":
              errorMessage = errors.addressNoResults;
              break;
            case "OVER_QUERY_LIMIT":
              errorMessage = errors.addressQueryLimit;
              break;
            case "REQUEST_DENIED":
              errorMessage = errors.authError;
              break;
            default:
              errorMessage = errors.addressError;
              break;
          }

          // Show errors only to merchant in the editor.
          if (Shopify.designMode) {
            $map
              .parent()
              .addClass(classes.mapError)
              .html(
                "<div class=\"" +
                  classes.errorMsg +
                  "\">" +
                  errorMessage +
                  "</div>"
              );
          }
        });
    },

    onUnload: function () {
      if (this.$map.length === 0) {
        return;
      }
      google.maps.event.clearListeners(this.map, "resize");
    },
  });

  return Map;
})();

/* eslint-disable no-new */
theme.Product = (function () {
  function Product(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr("data-section-id");
    this.ajaxEnabled = $container.data("ajax-enabled");

    this.settings = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      mediaQueryMediumUp: "screen and (min-width: 750px)",
      mediaQuerySmall: "screen and (max-width: 749px)",
      bpSmall: false,
      enableHistoryState: $container.data("enable-history-state") || false,
      namespace: ".slideshow-" + sectionId,
      sectionId: sectionId,
      sliderActive: false,
      zoomEnabled: false,
    };

    this.selectors = {
      addToCart: "[data-add-to-cart]",
      addToCartText: "[data-add-to-cart-text]",
      cartCount: "[data-cart-count]",
      cartCountBubble: "[data-cart-count-bubble]",
      cartPopup: "[data-cart-popup]",
      cartPopupCartQuantity: "[data-cart-popup-cart-quantity]",
      cartPopupClose: "[data-cart-popup-close]",
      cartPopupDismiss: "[data-cart-popup-dismiss]",
      cartPopupImage: "[data-cart-popup-image]",
      cartPopupImageWrapper: "[data-cart-popup-image-wrapper]",
      cartPopupImagePlaceholder: "[data-cart-popup-image-placeholder]",
      cartPopupPlaceholderSize: "[data-placeholder-size]",
      cartPopupProductDetails: "[data-cart-popup-product-details]",
      cartPopupQuantity: "[data-cart-popup-quantity]",
      cartPopupQuantityLabel: "[data-cart-popup-quantity-label]",
      cartPopupTitle: "[data-cart-popup-title]",
      cartPopupWrapper: "[data-cart-popup-wrapper]",
      loader: "[data-loader]",
      loaderStatus: "[data-loader-status]",
      quantity: "[data-quantity-input]",
      SKU: ".variant-sku",
      productStatus: "[data-product-status]",
      originalSelectorId: "#ProductSelect-" + sectionId,
      productForm: "[data-product-form]",
      errorMessage: "[data-error-message]",
      errorMessageWrapper: "[data-error-message-wrapper]",
      productImageWraps: ".product-single__photo",
      productThumbImages: ".product-single__thumbnail--" + sectionId,
      productThumbs: ".product-single__thumbnails-" + sectionId,
      productThumbListItem: ".product-single__thumbnails-item",
      productFeaturedImage: ".product-featured-img",
      productThumbsWrapper: ".thumbnails-wrapper",
      saleLabel: ".product-price__sale-label-" + sectionId,
      singleOptionSelector: ".single-option-selector-" + sectionId,
      shopifyPaymentButton: ".shopify-payment-button",
      priceContainer: "[data-price]",
      regularPrice: "[data-regular-price]",
      salePrice: "[data-sale-price]",
      unitPrice: "[data-unit-price]",
      unitPriceBaseUnit: "[data-unit-price-base-unit]",
    };

    this.classes = {
      cartPopupWrapperHidden: "cart-popup-wrapper--hidden",
      hidden: "hide",
      inputError: "input--error",
      productOnSale: "price--on-sale",
      productUnitAvailable: "price--unit-available",
      productUnavailable: "price--unavailable",
      cartImage: "cart-popup-item__image",
      productFormErrorMessageWrapperHidden:
        "product-form__error-message-wrapper--hidden",
      activeClass: "active-thumb",
    };

    this.$quantityInput = $(this.selectors.quantity, $container);
    this.$errorMessageWrapper = $(
      this.selectors.errorMessageWrapper,
      $container
    );
    this.$addToCart = $(this.selectors.addToCart, $container);
    this.$addToCartText = $(this.selectors.addToCartText, this.$addToCart);
    this.$shopifyPaymentButton = $(
      this.selectors.shopifyPaymentButton,
      $container
    );

    this.$loader = $(this.selectors.loader, this.$addToCart);
    this.$loaderStatus = $(this.selectors.loaderStatus, $container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$("#ProductJson-" + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(
      document.getElementById("ProductJson-" + sectionId).innerHTML
    );

    this.settings.zoomEnabled = $(this.selectors.productImageWraps).hasClass(
      "js-zoom-enabled"
    );

    this._initBreakpoints();
    this._stringOverrides();
    this._initVariants();
    this._initImageSwitch();
    this._initAddToCart();
    this._setActiveThumbnail();
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    _stringOverrides: function () {
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    _initBreakpoints: function () {
      enquire.register(this.settings.mediaQuerySmall, {
        match: function () {
          // initialize thumbnail slider on mobile if more than three thumbnails
          if ($(this.selectors.productThumbImages).length > 3) {
            this._initThumbnailSlider();
          }

          // destroy image zooming if enabled
          if (this.settings.zoomEnabled) {
            $(this.selectors.productImageWraps).each(function () {
              _destroyZoom(this);
            });
          }

          this.settings.bpSmall = true;
        },
        unmatch: function () {
          if (this.settings.sliderActive) {
            this._destroyThumbnailSlider();
          }

          this.settings.bpSmall = false;
        },
      });

      enquire.register(this.settings.mediaQueryMediumUp, {
        match: function () {
          if (this.settings.zoomEnabled) {
            $(this.selectors.productImageWraps).each(function () {
              _enableZoom(this);
            });
          }
        },
      });
    },

    _initVariants: function () {
      var options = {
        $container: this.$container,
        enableHistoryState:
          this.$container.data("enable-history-state") || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject,
      };

      this.variants = new slate.Variants(options);

      this.$container.on(
        "variantChange" + this.settings.namespace,
        this._updateAvailability.bind(this)
      );
      this.$container.on(
        "variantImageChange" + this.settings.namespace,
        this._updateImages.bind(this)
      );
      this.$container.on(
        "variantPriceChange" + this.settings.namespace,
        this._updatePrice.bind(this)
      );
      this.$container.on(
        "variantSKUChange" + this.settings.namespace,
        this._updateSKU.bind(this)
      );
    },

    _initImageSwitch: function () {
      if (!$(this.selectors.productThumbImages).length) {
        return;
      }

      $(this.selectors.productThumbImages)
        .on("click", function (evt) {
          evt.preventDefault();
          var $el = $(this);

          var imageId = $el.data("thumbnail-id");

          this._switchImage(imageId);
          this._setActiveThumbnail(imageId);
        })
        .on("keyup", this._handleImageFocus.bind(this));
    },

    _initAddToCart: function () {
      $(this.selectors.productForm, this.$container).on(
        "submit",
        function (evt) {
          evt.preventDefault();

          if (this.$addToCart.is("[aria-disabled]")) {
            return;
          }

          this.$previouslyFocusedElement = $(":focus");

          var isInvalidQuantity = this.$quantityInput.val() <= 0;

          if (isInvalidQuantity) {
            this._showErrorMessage(theme.strings.quantityMinimumMessage);
            return;
          }

          if (!isInvalidQuantity && this.ajaxEnabled) {
            // disable the addToCart and dynamic checkout button while
            // request/cart popup is loading and handle loading state
            this._handleButtonLoadingState(true);
            var $data = $(this.selectors.productForm, this.$container);
            this._addItemToCart($data);
            return;
          }

          if (!isInvalidQuantity && !this.ajaxEnabled) {
            // submit the product form and get redirected to cart
            evt.target.submit();
          }
        }.bind(this)
      );
    },

    _addItemToCart: function (data) {
      var params = {
        url: "/cart/add.js",
        data: $(data).serialize(),
        dataType: "json",
      };

      $.post(params)
        .done(
          function (item) {
            this._hideErrorMessage();
            this._setupCartPopup(item);
          }.bind(this)
        )
        .fail(
          function (response) {
            this.$previouslyFocusedElement.focus();
            this._showErrorMessage(response.responseJSON.description);
            this._handleButtonLoadingState(false);
          }.bind(this)
        );
    },

    _handleButtonLoadingState: function (isLoading) {
      if (isLoading) {
        this.$addToCart.attr("aria-disabled", true);
        this.$addToCartText.addClass(this.classes.hidden);
        this.$loader.removeClass(this.classes.hidden);
        this.$shopifyPaymentButton.attr("disabled", true);
        this.$loaderStatus.attr("aria-hidden", false);
      } else {
        this.$addToCart.removeAttr("aria-disabled");
        this.$addToCartText.removeClass(this.classes.hidden);
        this.$loader.addClass(this.classes.hidden);
        this.$shopifyPaymentButton.removeAttr("disabled");
        this.$loaderStatus.attr("aria-hidden", true);
      }
    },

    _showErrorMessage: function (errorMessage) {
      $(this.selectors.errorMessage, this.$container).html(errorMessage);

      if (this.$quantityInput.length !== 0) {
        this.$quantityInput.addClass(this.classes.inputError);
      }

      this.$errorMessageWrapper
        .removeClass(this.classes.productFormErrorMessageWrapperHidden)
        .attr("aria-hidden", true)
        .removeAttr("aria-hidden");
    },

    _hideErrorMessage: function () {
      this.$errorMessageWrapper.addClass(
        this.classes.productFormErrorMessageWrapperHidden
      );

      if (this.$quantityInput.length !== 0) {
        this.$quantityInput.removeClass(this.classes.inputError);
      }
    },

    _setupCartPopup: function (item) {
      this.$cartPopup = this.$cartPopup || $(this.selectors.cartPopup);
      this.$cartPopupWrapper =
        this.$cartPopupWrapper || $(this.selectors.cartPopupWrapper);
      this.$cartPopupTitle =
        this.$cartPopupTitle || $(this.selectors.cartPopupTitle);
      this.$cartPopupQuantity =
        this.$cartPopupQuantity || $(this.selectors.cartPopupQuantity);
      this.$cartPopupQuantityLabel =
        this.$cartPopupQuantityLabel ||
        $(this.selectors.cartPopupQuantityLabel);
      this.$cartPopupClose =
        this.$cartPopupClose || $(this.selectors.cartPopupClose);
      this.$cartPopupDismiss =
        this.cartPopupDismiss || $(this.selectors.cartPopupDismiss);
      this.$cartPopupImagePlaceholder =
        this.$cartPopupImagePlaceholder ||
        $(this.selectors.cartPopupImagePlaceholder);

      this._setupCartPopupEventListeners();

      this._updateCartPopupContent(item);
    },

    _updateCartPopupContent: function (item) {
      var quantity = this.$quantityInput.length ? this.$quantityInput.val() : 1;

      this.$cartPopupTitle.text(item.product_title);
      this.$cartPopupQuantity.text(quantity);
      this.$cartPopupQuantityLabel.text(
        theme.strings.quantityLabel.replace("[count]", quantity)
      );

      this._setCartPopupPlaceholder(
        item.featured_image.url,
        item.featured_image.aspect_ratio
      );
      this._setCartPopupImage(item.featured_image.url, item.featured_image.alt);
      this._setCartPopupProductDetails(
        item.product_has_only_default_variant,
        item.options_with_values,
        item.properties
      );

      $.getJSON("/cart.js").then(
        function (cart) {
          this._setCartQuantity(cart.item_count);
          this._setCartCountBubble(cart.item_count);
          this._showCartPopup();
        }.bind(this)
      );
    },

    _setupCartPopupEventListeners: function () {
      this.$cartPopupWrapper.on(
        "keyup",
        function (event) {
          if (event.keyCode === slate.utils.keyboardKeys.ESCAPE) {
            this._hideCartPopup(event);
          }
        }.bind(this)
      );

      this.$cartPopupClose.on("click", this._hideCartPopup.bind(this));
      this.$cartPopupDismiss.on("click", this._hideCartPopup.bind(this));
      $("body").on("click", this._onBodyClick.bind(this));
    },

    _setCartPopupPlaceholder: function (imageUrl, imageAspectRatio) {
      this.$cartPopupImageWrapper =
        this.$cartPopupImageWrapper || $(this.selectors.cartPopupImageWrapper);

      if (imageUrl === null) {
        this.$cartPopupImageWrapper.addClass(this.classes.hidden);
        return;
      }

      var $placeholder = $(this.selectors.cartPopupPlaceholderSize);
      var maxWidth = 95 * imageAspectRatio;
      var heightRatio = 100 / imageAspectRatio;

      this.$cartPopupImagePlaceholder.css("max-width", maxWidth);

      $placeholder.css("padding-top", heightRatio + "%");
    },

    _setCartPopupImage: function (imageUrl, imageAlt) {
      if (imageUrl === null) return;

      this.$cartPopupImageWrapper.removeClass(this.classes.hidden);
      var sizedImageUrl = theme.Images.getSizedImageUrl(imageUrl, "200x");
      var image = document.createElement("img");
      image.src = sizedImageUrl;
      image.alt = imageAlt;
      image.classList.add(this.classes.cartImage);
      image.dataset.cartPopupImage = "";

      image.onload = function () {
        this.$cartPopupImagePlaceholder.addClass(this.classes.hidden);
        this.$cartPopupImageWrapper.append(image);
      }.bind(this);
    },

    _setCartPopupProductDetails: function (
      product_has_only_default_variant,
      options,
      properties
    ) {
      this.$cartPopupProductDetails =
        this.$cartPopupProductDetails ||
        $(this.selectors.cartPopupProductDetails);
      var variantPropertiesHTML = "";

      if (!product_has_only_default_variant) {
        variantPropertiesHTML =
          variantPropertiesHTML + this._getVariantOptionList(options);
      }

      if (properties !== null && Object.keys(properties).length !== 0) {
        variantPropertiesHTML =
          variantPropertiesHTML + this._getPropertyList(properties);
      }

      if (variantPropertiesHTML.length === 0) {
        this.$cartPopupProductDetails.html("");
        this.$cartPopupProductDetails.attr("hidden", "");
      } else {
        this.$cartPopupProductDetails.html(variantPropertiesHTML);
        this.$cartPopupProductDetails.removeAttr("hidden");
      }
    },

    _getVariantOptionList: function (variantOptions) {
      var variantOptionListHTML = "";

      variantOptions.forEach(function (variantOption) {
        variantOptionListHTML =
          variantOptionListHTML +
          "<li class=\"product-details__item product-details__item--variant-option\">" +
          variantOption.name +
          ": " +
          variantOption.value +
          "</li>";
      });

      return variantOptionListHTML;
    },

    _getPropertyList: function (properties) {
      var propertyListHTML = "";
      var propertiesArray = Object.entries(properties);

      propertiesArray.forEach(function (property) {
        // Line item properties prefixed with an underscore are not to be displayed
        if (property[0].charAt(0) === "_") return;

        // if the property value has a length of 0 (empty), don't display it
        if (property[1].length === 0) return;

        propertyListHTML =
          propertyListHTML +
          "<li class=\"product-details__item product-details__item--property\">" +
          "<span class=\"product-details__property-label\">" +
          property[0] +
          ": </span>" +
          property[1];
        ": " + "</li>";
      });

      return propertyListHTML;
    },

    _setCartQuantity: function (quantity) {
      this.$cartPopupCartQuantity =
        this.$cartPopupCartQuantity || $(this.selectors.cartPopupCartQuantity);
      var ariaLabel;

      if (quantity === 1) {
        ariaLabel = theme.strings.oneCartCount;
      } else if (quantity > 1) {
        ariaLabel = theme.strings.otherCartCount.replace("[count]", quantity);
      }

      this.$cartPopupCartQuantity.text(quantity).attr("aria-label", ariaLabel);
    },

    _setCartCountBubble: function (quantity) {
      this.$cartCountBubble =
        this.$cartCountBubble || $(this.selectors.cartCountBubble);
      this.$cartCount = this.$cartCount || $(this.selectors.cartCount);

      this.$cartCountBubble.removeClass(this.classes.hidden);
      this.$cartCount.text(quantity);
    },

    _showCartPopup: function () {
      this.$cartPopupWrapper
        .prepareTransition()
        .removeClass(this.classes.cartPopupWrapperHidden);
      this._handleButtonLoadingState(false);

      slate.a11y.trapFocus({
        $container: this.$cartPopupWrapper,
        $elementToFocus: this.$cartPopup,
        namespace: "cartPopupFocus",
      });
    },

    _hideCartPopup: function (event) {
      var setFocus = event.detail === 0 ? true : false;
      this.$cartPopupWrapper
        .prepareTransition()
        .addClass(this.classes.cartPopupWrapperHidden);

      $(this.selectors.cartPopupImage).remove();
      this.$cartPopupImagePlaceholder.removeClass(this.classes.hidden);

      slate.a11y.removeTrapFocus({
        $container: this.$cartPopupWrapper,
        namespace: "cartPopupFocus",
      });

      if (setFocus) this.$previouslyFocusedElement[0].focus();

      this.$cartPopupWrapper.off("keyup");
      this.$cartPopupClose.off("click");
      this.$cartPopupDismiss.off("click");
      $("body").off("click");
    },

    _onBodyClick: function (event) {
      var $target = $(event.target);

      if (
        $target[0] !== this.$cartPopupWrapper[0] &&
        !$target.parents(this.selectors.cartPopup).length
      ) {
        this._hideCartPopup(event);
      }
    },

    _setActiveThumbnail: function (imageId) {
      // If there is no element passed, find it by the current product image
      if (typeof imageId === "undefined") {
        imageId = $(
          this.selectors.productImageWraps + ":not(.hide)",
          this.$container
        ).data("image-id");
      }

      var $thumbnailWrappers = $(
        this.selectors.productThumbListItem + ":not(.slick-cloned)",
        this.$container
      );

      var $activeThumbnail = $thumbnailWrappers.find(
        this.selectors.productThumbImages +
          "[data-thumbnail-id='" +
          imageId +
          "']"
      );

      $(this.selectors.productThumbImages)
        .removeClass(this.classes.activeClass)
        .removeAttr("aria-current");

      $activeThumbnail.addClass(this.classes.activeClass);
      $activeThumbnail.attr("aria-current", true);

      if (!$thumbnailWrappers.hasClass("slick-slide")) {
        return;
      }

      var slideIndex = $activeThumbnail.parent().data("slick-index");

      $(this.selectors.productThumbs).slick("slickGoTo", slideIndex, true);
    },

    _switchImage: function (imageId) {
      var $newImage = $(
        this.selectors.productImageWraps + "[data-image-id='" + imageId + "']",
        this.$container
      );
      var $otherImages = $(
        this.selectors.productImageWraps +
          ":not([data-image-id='" +
          imageId +
          "'])",
        this.$container
      );

      $newImage.removeClass(this.classes.hidden);
      $otherImages.addClass(this.classes.hidden);
    },

    _handleImageFocus: function (evt) {
      if (evt.keyCode !== slate.utils.keyboardKeys.ENTER) return;

      $(this.selectors.productFeaturedImage + ":visible").focus();
    },

    _initThumbnailSlider: function () {
      var options = {
        slidesToShow: 4,
        slidesToScroll: 3,
        infinite: false,
        prevArrow: ".thumbnails-slider__prev--" + this.settings.sectionId,
        nextArrow: ".thumbnails-slider__next--" + this.settings.sectionId,
        responsive: [
          {
            breakpoint: 321,
            settings: {
              slidesToShow: 3,
            },
          },
        ],
      };

      $(this.selectors.productThumbs).slick(options);

      // Accessibility concerns not yet fixed in Slick Slider
      $(this.selectors.productThumbsWrapper, this.$container)
        .find(".slick-list")
        .removeAttr("aria-live");
      $(this.selectors.productThumbsWrapper, this.$container)
        .find(".slick-disabled")
        .removeAttr("aria-disabled");

      this.settings.sliderActive = true;
    },

    _destroyThumbnailSlider: function () {
      $(this.selectors.productThumbs).slick("unslick");
      this.settings.sliderActive = false;

      // Accessibility concerns not yet fixed in Slick Slider
      $(this.selectors.productThumbsWrapper, this.$container)
        .find("[tabindex=\"-1\"]")
        .removeAttr("tabindex");
    },

    _liveRegionText: function (variant) {
      // Dummy content for live region
      var liveRegionText =
        "[Availability] [Regular] [$$] [Sale] [$]. [UnitPrice] [$$$]";

      if (!variant) {
        liveRegionText = theme.strings.unavailable;
        return liveRegionText;
      }

      // Update availability
      var availability = variant.available ? "" : theme.strings.soldOut + ",";
      liveRegionText = liveRegionText.replace("[Availability]", availability);

      // Update pricing information
      var regularLabel = "";
      var regularPrice = theme.Currency.formatMoney(
        variant.price,
        theme.moneyFormat
      );
      var saleLabel = "";
      var salePrice = "";
      var unitLabel = "";
      var unitPrice = "";

      if (variant.compare_at_price > variant.price) {
        regularLabel = theme.strings.regularPrice;
        regularPrice =
          theme.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          ) + ",";
        saleLabel = theme.strings.sale;
        salePrice = theme.Currency.formatMoney(
          variant.price,
          theme.moneyFormat
        );
      }

      if (variant.unit_price) {
        unitLabel = theme.strings.unitPrice;
        unitPrice =
          theme.Currency.formatMoney(variant.unit_price, theme.moneyFormat) +
          " " +
          theme.strings.unitPriceSeparator +
          " " +
          this._getBaseUnit(variant);
      }

      liveRegionText = liveRegionText
        .replace("[Regular]", regularLabel)
        .replace("[$$]", regularPrice)
        .replace("[Sale]", saleLabel)
        .replace("[$]", salePrice)
        .replace("[UnitPrice]", unitLabel)
        .replace("[$$$]", unitPrice)
        .trim();

      return liveRegionText;
    },

    _updateLiveRegion: function (evt) {
      var variant = evt.variant;
      var liveRegion = this.container.querySelector(
        this.selectors.productStatus
      );
      liveRegion.innerHTML = this._liveRegionText(variant);
      liveRegion.setAttribute("aria-hidden", false);

      // hide content from accessibility tree after announcement
      setTimeout(function () {
        liveRegion.setAttribute("aria-hidden", true);
      }, 1000);
    },

    _updateAddToCart: function (evt) {
      var variant = evt.variant;

      if (variant) {
        if (variant.available) {
          this.$addToCart
            .removeAttr("aria-disabled")
            .attr("aria-label", theme.strings.addToCart);
          $(this.selectors.addToCartText, this.$container).text(
            theme.strings.addToCart
          );
          this.$shopifyPaymentButton.show();
        } else {
          // The variant doesn't exist, disable submit button and change the text.
          // This may be an error or notice that a specific variant is not available.
          this.$addToCart
            .attr("aria-disabled", true)
            .attr("aria-label", theme.strings.soldOut);
          $(this.selectors.addToCartText, this.$container).text(
            theme.strings.soldOut
          );
          this.$shopifyPaymentButton.hide();
        }
      } else {
        this.$addToCart
          .attr("aria-disabled", true)
          .attr("aria-label", theme.strings.unavailable);
        $(this.selectors.addToCartText, this.$container).text(
          theme.strings.unavailable
        );
        this.$shopifyPaymentButton.hide();
      }
    },

    _updateAvailability: function (evt) {
      // remove error message if one is showing
      this._hideErrorMessage();

      // update form submit
      this._updateAddToCart(evt);
      // update live region
      this._updateLiveRegion(evt);

      this._updatePrice(evt);
    },

    _updateImages: function (evt) {
      var variant = evt.variant;
      var imageId = variant.featured_image.id;

      this._switchImage(imageId);
      this._setActiveThumbnail(imageId);
    },

    _updatePrice: function (evt) {
      var variant = evt.variant;

      var $priceContainer = $(this.selectors.priceContainer, this.$container);
      var $regularPrice = $(this.selectors.regularPrice, $priceContainer);
      var $salePrice = $(this.selectors.salePrice, $priceContainer);
      var $unitPrice = $(this.selectors.unitPrice, $priceContainer);
      var $unitPriceBaseUnit = $(
        this.selectors.unitPriceBaseUnit,
        $priceContainer
      );

      // Reset product price state
      $priceContainer
        .removeClass(this.classes.productUnavailable)
        .removeClass(this.classes.productOnSale)
        .removeClass(this.classes.productUnitAvailable)
        .removeAttr("aria-hidden");

      // Unavailable
      if (!variant) {
        $priceContainer
          .addClass(this.classes.productUnavailable)
          .attr("aria-hidden", true);
        return;
      }

      // On sale
      if (variant.compare_at_price > variant.price) {
        $regularPrice.html(
          theme.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          )
        );
        $salePrice.html(
          theme.Currency.formatMoney(variant.price, theme.moneyFormat)
        );
        $priceContainer.addClass(this.classes.productOnSale);
      } else {
        // Regular price
        $regularPrice.html(
          theme.Currency.formatMoney(variant.price, theme.moneyFormat)
        );
      }

      // Unit price
      if (variant.unit_price) {
        $unitPrice.html(
          theme.Currency.formatMoney(variant.unit_price, theme.moneyFormat)
        );
        $unitPriceBaseUnit.html(this._getBaseUnit(variant));
        $priceContainer.addClass(this.classes.productUnitAvailable);
      }
    },

    _getBaseUnit: function (variant) {
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    },

    _updateSKU: function (evt) {
      var variant = evt.variant;

      // Update the sku
      $(this.selectors.SKU).html(variant.sku);
    },

    onUnload: function () {
      this.$container.off(this.settings.namespace);
    },
  });

  function _enableZoom(el) {
    var zoomUrl = $(el).data("zoom");
    $(el).zoom({
      url: zoomUrl,
    });
  }

  function _destroyZoom(el) {
    $(el).trigger("zoom.destroy");
  }

  return Product;
})();

theme.ProductRecommendations = (function () {
  var selectors = {
    productCard: "[data-product-card]",
  };

  function ProductRecommendations(container) {
    this.$container = $(container);

    var productId = this.$container.data("productId");
    var recommendationsSectionUrl =
      "/recommendations/products?&section_id=product-recommendations&product_id=" +
      productId +
      "&limit=4";

    $.get(recommendationsSectionUrl).then(
      function (section) {
        var recommendationsMarkup = $(section).html();
        if (recommendationsMarkup.trim() !== "") {
          this.$container.html(recommendationsMarkup);
          this.sendTrekkieEvent();
        }
      }.bind(this)
    );
  }

  ProductRecommendations.prototype = _.assignIn(
    {},
    ProductRecommendations.prototype,
    {
      sendTrekkieEvent: function () {
        if (
          !window.ShopifyAnalytics ||
          !window.ShopifyAnalytics.lib ||
          !window.ShopifyAnalytics.lib.track
        ) {
          return;
        }

        var didPageJumpOccur =
          this.$container[0].getBoundingClientRect().top <= window.innerHeight;
        var numberOfRecommendationsDisplayed = this.$container.find(
          selectors.productCard
        ).length;

        window.ShopifyAnalytics.lib.track("Product Recommendations Displayed", {
          theme: "debut",
          didPageJumpOccur: didPageJumpOccur,
          numberOfRecommendationsDisplayed: numberOfRecommendationsDisplayed,
        });
      },
    }
  );

  return ProductRecommendations;
})();

theme.Quotes = (function () {
  var config = {
    mediaQuerySmall: "screen and (max-width: 749px)",
    mediaQueryMediumUp: "screen and (min-width: 750px)",
    slideCount: 0,
  };
  var defaults = {
    accessibility: true,
    arrows: false,
    dots: true,
    autoplay: false,
    touchThreshold: 20,
    slidesToShow: 3,
    slidesToScroll: 3,
  };

  function Quotes(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr("data-section-id");
    var wrapper = (this.wrapper = ".quotes-wrapper");
    var slider = (this.slider = "#Quotes-" + sectionId);
    var $slider = $(slider, wrapper);

    var sliderActive = false;
    var mobileOptions = $.extend({}, defaults, {
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
    });

    config.slideCount = $slider.data("count");

    // Override slidesToShow/Scroll if there are not enough blocks
    if (config.slideCount < defaults.slidesToShow) {
      defaults.slidesToShow = config.slideCount;
      defaults.slidesToScroll = config.slideCount;
    }

    $slider.on("init", this.a11y.bind(this));

    enquire.register(config.mediaQuerySmall, {
      match: function () {
        initSlider($slider, mobileOptions);
      },
    });

    enquire.register(config.mediaQueryMediumUp, {
      match: function () {
        initSlider($slider, defaults);
      },
    });

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick("unslick");
        sliderActive = false;
      }

      sliderObj.slick(args);
      sliderActive = true;
    }
  }

  Quotes.prototype = _.assignIn({}, Quotes.prototype, {
    onUnload: function () {
      enquire.unregister(config.mediaQuerySmall);
      enquire.unregister(config.mediaQueryMediumUp);

      $(this.slider, this.wrapper).slick("unslick");
    },

    onBlockSelect: function (evt) {
      // Ignore the cloned version
      var $slide = $(
        ".quotes-slide--" + evt.detail.blockId + ":not(.slick-cloned)"
      );
      var slideIndex = $slide.data("slick-index");

      // Go to selected slide, pause autoplay
      $(this.slider, this.wrapper).slick("slickGoTo", slideIndex);
    },

    a11y: function (event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr("aria-live");

      // When an element in the slider is focused set aria-live
      $wrapper.on("focusin", function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr("aria-live", "polite");
        }
      });

      // Remove aria-live
      $wrapper.on("focusout", function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr("aria-live");
        }
      });
    },
  });

  return Quotes;
})();

theme.slideshows = {};

theme.SlideshowSection = (function () {
  function SlideshowSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr("data-section-id");
    var slideshow = (this.slideshow = "#Slideshow-" + sectionId);

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow, sectionId);
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn(
  {},
  theme.SlideshowSection.prototype,
  {
    onUnload: function () {
      delete theme.slideshows[this.slideshow];
    },

    onBlockSelect: function (evt) {
      var $slideshow = $(this.slideshow);
      var adaptHeight = $slideshow.data("adapt-height");

      if (adaptHeight) {
        theme.slideshows[this.slideshow].setSlideshowHeight();
      }

      // Ignore the cloned version
      var $slide = $(
        ".slideshow__slide--" + evt.detail.blockId + ":not(.slick-cloned)"
      );
      var slideIndex = $slide.data("slick-index");

      // Go to selected slide, pause auto-rotate
      $slideshow.slick("slickGoTo", slideIndex).slick("slickPause");
    },

    onBlockDeselect: function () {
      // Resume auto-rotate
      $(this.slideshow).slick("slickPlay");
    },
  }
);

theme.slideshows = {};

theme.slidingCollections = {};

theme.SlidingCollectionSection = (function () {
  function SlidingCollectionSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr("data-section-id");
    var slidingCollection = (this.slidingCollection =
      "#SlidingCollection-" + sectionId);

    theme.slidingCollections[slidingCollection] = new theme.SlidingCollection(
      slidingCollection,
      sectionId
    );
  }

  return SlidingCollectionSection;
})();

theme.VideoSection = (function () {
  function VideoSection(container) {
    var $container = (this.$container = $(container));

    $(".video", $container).each(function () {
      var $el = $(this);
      theme.Video.init($el);
      theme.Video.editorLoadVideo($el.attr("id"));
    });
  }

  return VideoSection;
})();

theme.VideoSection.prototype = _.assignIn({}, theme.VideoSection.prototype, {
  onUnload: function () {
    theme.Video.removeEvents();
  },
});

theme.heros = {};
var createForm = function (selector, options) {
  var $el = $(selector);
  var formUrl = $el.attr("data-form-url");
  return Formio.createForm($el[0], formUrl, options);
};
theme.HeroSection = (function () {
  function HeroSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr("data-section-id");
    var hero = "#Hero-" + sectionId;
    theme.heros[hero] = new theme.Hero(hero, sectionId);
  }

  return HeroSection;
})();

var updateStickySidebar = function () {
  if (window.innerWidth > 767) {
    this._initStickySidebar();
  } else {
    this._destroyStickySidebar();
  }
};

theme.Giftoffers = (function () {
  function Giftoffers() {
    var selectors = {
      formGiftoffers: "#FormGiftoffers",
      sectionMain: ".section-main",
      sectionThank: ".section-thank",
      modalCollectionFilter: ".collection__filter-modal",
      buttonClaimOffers: ".claim-offers",
    };

    var getSelectedOffers = function () {
      var offers = [];
      $("input[name=\"claimOffer\"]:checked").each(function () {
        var offerId = $(this).val();
        var offerName = $(
          "[data-product-id=" + offerId + "] input.GiftOfferName"
        ).val();
        var offerImage = $(
          "[data-product-id=" + offerId + "] input.GiftOfferImage"
        ).val();
        var offerLogo = $(
          "[data-product-id=" + offerId + "] input.GiftOfferLogo"
        ).val();
        var offerCode = $(
          "[data-product-id=" + offerId + "] input.GiftOfferCode"
        ).val();
        var offerUrl = $(
          "[data-product-id=" + offerId + "] input.GiftOfferUrl"
        ).val();
        var offerAmount = $(
          "[data-product-id=" + offerId + "] input.GiftOfferAmount"
        ).val();

        offers.push({
          id: offerId,
          name: offerName,
          image: offerImage,
          logo: offerLogo,
          code: offerCode,
          url: offerUrl,
          amount: offerAmount == 0 ? "Free" : offerAmount,
        });
      });
      return offers;
    };

    var saveSelectedOffers = function (offers) {
      sessionStorage.setItem(
        "giftoffers.selectedOffers",
        offers
          .map(function (offer) {
            return offer.id;
          })
          .join(",")
      );
    };

    var loadSelectedOffers = function () {
      var selectedOffers = sessionStorage.getItem("giftoffers.selectedOffers");
      if (!selectedOffers) return;

      var offerIds = selectedOffers.split(",");
      if (offerIds.length > 0) {
        offerIds.forEach(function (id) {
          $("#checkGiftoffer" + id).click();
        });
      }
    };

    var renderThank = function () {
      var selectedOffers = getSelectedOffers();

      var template = $("#template").html();
      Mustache.parse(template); // optional, speeds up future uses
      var rendered = Mustache.render(template, {
        offers: selectedOffers,
      });
      $(".offers").html(rendered);
    };

    var formOptions = {
      hooks: {
        beforeSubmit: function (submission, next) {
          var selectedOffers = getSelectedOffers().map(function (offer) {
            return offer.name;
          });

          if (!selectedOffers || selectedOffers.length == 0) {
            alert("You haven't selected any offer to opt in");
            return;
          }
          submission.data.offers = selectedOffers.join(", ");
          next();
        },
      },
    };

    var init = function () {
      updateStickySidebar();

      $(window).resize(function () {
        updateStickySidebar();
      });

      $("[data-giftoffer-id]").each(function (idx, el) {
        var id = $(el).attr("data-giftoffer-id");
        // var name = $(el).attr("data-giftoffer-name");

        $(
          "<div class=\"giftoffer-select\"><input type=\"checkbox\" name=\"claimOffer\" id=\"checkGiftoffer" +
            id +
            "\" value=\"" +
            id +
            "\"/><label for=\"checkGiftoffer" +
            id +
            "\"></label></div>"
        ).appendTo($(el));
      });

      $(".collection__filter-icon").click(function () {
        $(selectors.modalCollectionFilter).modal();
        return false;
      });

      $("input[name=\"claimOffer\"]").click(function (event) {
        var selectedOffers = getSelectedOffers();
        if (selectedOffers.length > 5) {
          alert("You can only claim maximum 5 offers at a time");
          return false;
        }
        saveSelectedOffers(selectedOffers);
        event.stopPropagation();
      });

      loadSelectedOffers();
    };

    if (window.Formio) {
      createForm(selectors.formGiftoffers, formOptions).then(function (form) {
        form.submission = {
          data: {
            email:
              theme.customer.email ||
              sessionStorage.getItem("giftoffers.email"),
          },
        };

        $(selectors.buttonClaimOffers).click(function () {
          form.submit();
        });

        var saveEmailTimeout = null;
        $("input[name=\"data[email]\"]").keyup(function (event) {
          if (saveEmailTimeout) {
            clearTimeout(saveEmailTimeout);
          }
          saveEmailTimeout = setTimeout(function () {
            sessionStorage.setItem("giftoffers.email", event.target.value);
          }, 500);
        });

        form.on("submit", function () {
          renderThank();
        });

        form.on("submitDone", function () {
          $(selectors.sectionMain).hide();

          sessionStorage.setItem("giftoffers.selectedOffers", []);
          $(selectors.sectionThank).show();
          window.scrollTo(0, 0);
        });
      });
    }

    init();
  }

  Giftoffers.prototype = _.assignIn({}, Giftoffers.prototype, {
    _initStickySidebar: function () {
      this.stickySidebar = new StickySidebar(".giftoffers-form-container", {
        topSpacing: 60,
        bottomSpacing: 60,
        containerSelector: ".grid",
        innerWrapperSelector: ".giftoffers-form-container__inner",
      });
    },
    _destroyStickySidebar: function () {
      if (this.stickySidebar) {
        this.stickySidebar.destroy();
        this.stickySidebar = null;
      }
    },
  });

  return Giftoffers;
})();

theme.Giftoffer = (function () {
  function Giftoffer() {
    var selectors = {
      formGiftoffer: "#FormGiftoffer",
      hiddenHandle: "#GiftOfferHandle",
      sectionForm: ".form-container",
      sectionGiftCode: ".code-container",
      inputGiftCode: ".gift-code",
      buttonCopyGiftCode: ".copy-code",
    };

    var createForm = function (selector, options) {
      var $el = $(selector);
      var formUrl = $el.attr("data-form-url");
      return Formio.createForm($el[0], formUrl, options || {});
    };

    createForm(selectors.formGiftoffer).then(function (form) {
      var termsUrl = "/pages/" + handle + "-terms-conditions";
      var spanTerms = $(selectors.formGiftoffer)
        .find("input[type=checkbox]")
        .next();
      spanTerms.html(
        spanTerms
          .html()
          .replace(
            "Terms and Conditions",
            "<a href=\"" +
              termsUrl +
              "\" target=\"_blank\">Terms and Conditions</a>"
          )
      );

      form.submission = {
        data: {
          email: theme.customer.email,
        },
      };

      form.on("submitDone", function () {
        $(selectors.sectionForm).hide();
        $(selectors.sectionGiftCode).show();
      });
    });

    var handle = $(selectors.hiddenHandle).val();

    var init = function () {
      updateStickySidebar();

      $(window).resize(function () {
        updateStickySidebar();
      });

      $(selectors.buttonCopyGiftCode).click(function () {
        const el = document.createElement("textarea"); // Create a <textarea> element
        el.value = $(selectors.inputGiftCode).val(); // Set its value to the string that you want copied
        el.setAttribute("readonly", ""); // Make it readonly to be tamper-proof
        el.style.position = "absolute";
        el.style.left = "-9999px"; // Move outside the screen to make it invisible
        document.body.appendChild(el); // Append the <textarea> element to the HTML document
        const selected =
          document.getSelection().rangeCount > 0 // Check if there is any content selected previously
            ? document.getSelection().getRangeAt(0) // Store selection if found
            : false; // Mark as false to know no selection existed before
        el.select(); // Select the <textarea> content
        document.execCommand("copy"); // Copy - only works as a result of a user action (e.g. click events)
        document.body.removeChild(el); // Remove the <textarea> element
        if (selected) {
          // If a selection existed before copying
          document.getSelection().removeAllRanges(); // Unselect everything on the HTML document
          document.getSelection().addRange(selected); // Restore the original selection
        }

        $(this).html("Copied");
        $(this).addClass("copied");
      });
    };

    init();
  }

  Giftoffer.prototype = _.assignIn({}, Giftoffer.prototype, {
    _initStickySidebar: function () {
      this.stickySidebar = new StickySidebar(".giftoffer-information", {
        topSpacing: 35,
        bottomSpacing: 0,
        containerSelector: ".grid",
        innerWrapperSelector: ".giftoffer-information__inner",
      });
    },
    _destroyStickySidebar: function () {
      if (this.stickySidebar) {
        this.stickySidebar.destroy();
        this.stickySidebar = null;
      }
    },
  });

  return Giftoffer;
})();

theme.OtherWinners = (function () {
  function OtherWinners() {
    var selectors = {
      sectionMoreWinners: "#shopify-section-more-winners-template",
      moreWinnersWrapper: ".more-winners-wrapper",
    };
    var init = function () {
      $(selectors.moreWinnersWrapper, selectors.sectionMoreWinners).slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
              dots: true,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ],
      });
    };

    init();
  }

  return OtherWinners;
})();

theme.CareerJobs = (function () {
  function CareerJobs() {
    var init = function () {
      $("#openings").slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
              dots: true,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ],
      });
    };

    init();
  }

  return CareerJobs;
})();

theme.Account = (function () {
  function Account() {
    var selectors = {
      accountSidebar: ".myaccount__sidebar",
    };

    var init = function () {
      $(selectors.accountSidebar)
        .find("li a")
        .click(function () {
          return;
        });
    };

    init();
  }

  return Account;
})();

const AdsService = () => {
  const GOOGLE_TAG = window.googletag;
  let adSlots;

  return {
    setAds: function (adSlotsProps) {
      adSlots = adSlotsProps.map((adSlotProps) => {
        let adSlot;
        GOOGLE_TAG.cmd.push(() => {
          // Define the ad slot
          adSlot = GOOGLE_TAG.defineSlot(
            adSlotProps.slotId,
            [adSlotProps.width, adSlotProps.height],
            adSlotProps.elementId
          )
            .setTargeting("test", "refresh")
            .addService(GOOGLE_TAG.pubads());

          // Configure SRA
          GOOGLE_TAG.pubads().enableSingleRequest();

          // Start ad fetching
          GOOGLE_TAG.enableServices();

          GOOGLE_TAG.cmd.push(() => {
            GOOGLE_TAG.display(adSlotProps.elementId);
          });
        });
        return adSlot;
      });

      return adSlots;
    },

    refreshAds: function () {
      GOOGLE_TAG.cmd.push(() => {
        GOOGLE_TAG.pubads().refresh([...adSlots]);
      });
    },
  };
};

theme.AdsService = AdsService();

class GAService {
  /**
   * Enable GA tag
   *
   */
  static enableDataTracker() {
    try {
      window.gtag("config", window.FKL.ga_tracking_code);
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * Set user data to the GA tag
   *
   * @argument {string} userEmailHash
   */
  static setUserDataTracker(userEmailHash) {
    try {
      window.gtag("config", window.FKL.ga_tracking_code, {
        user_id: userEmailHash,
        transport_type: "beacon",
      });
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * Send CPL event to GA
   *
   * @argument {string} cplEventAction
   * @argument {string} cplName
   * @argument {number} cplBid
   */
  static landerCplEventTracker(cplEventAction, cplName, cplBid) {
    try {
      const CPL_OPT_IN_GA_CATEGORY = "CPL";
      const GA_CPL_BID_FIXED_DECIMALS = 3;
      const GA_CPL_BID_MULTIPLIER = 1000;
      const cplTrackGAEventObject = {
        send_to: window.FKL.ga_tracking_code,
        event_category: CPL_OPT_IN_GA_CATEGORY,
        event_label: cplName,
        value:
          cplBid && Number(cplBid)
            ? Number(Number(cplBid).toFixed(GA_CPL_BID_FIXED_DECIMALS)) *
              GA_CPL_BID_MULTIPLIER
            : undefined,
      };
      window.gtag("event", cplEventAction, cplTrackGAEventObject);
    } catch (error) {
      console.error(error);
    }
  }
}

theme.GAService = GAService;

const Utils = () => {
  return {
    capitalize: (str) => str.replace(/\b\w/g, (s) => s.toUpperCase()),
    formatCurrency: (value) =>
      new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(value),
    getCurrentQueryParams: () => {
      return new URL(window.location.href).searchParams;
    },
    isURL: (string) => {
      try {
        return Boolean(new URL(string));
      } catch (e) {
        return false;
      }
    },
    clearInSessionStorage: (key) => {
      sessionStorage.removeItem(key);
    },
    retrieveFromSessionStorage: (key) => {
      return JSON.parse(sessionStorage.getItem(key));
    },
    saveInSessionStorage: (key, payload) => {
      sessionStorage.setItem(key, JSON.stringify(payload));
    },
    transformBundle: (bundle) => {
      const minQuantity = 1;
      return bundle.reduce((acc, product) => {
        acc.push({ id: product.variantId, quantity: minQuantity });
        return acc;
      }, []);
    },
    transformProduct: (productId) => {
      const minQuantity = 1;
      return { id: productId, quantity: minQuantity };
    },
    truncate: (str, length) =>
      str.length > length ? `${str.substring(0, length)}...` : str,
    getHash: (value) => {
      const encoder = new TextEncoder();
      const data = encoder.encode(value);
      return window.crypto.subtle
        .digest("SHA-256", data)
        .then((x) => Array.from(new Uint8Array(x)))
        .then((x) => x.map((b) => b.toString(16).padStart(2, "0")).join(""));
    },
    handleHttpErrors: async (status, description) => {
      switch (status) {
        case 422:
          alert(
            `There was an error while adding the products to the shopping cart:
            ${description}`
          );
          throw new Error(description);
        default:
          throw new Error(description);
      }
    },
    escapeRegExp: (string) => {
      return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    },
    getCookie: (cookieName) => {
      // Function to Get a Cookie
      // From: https://www.w3schools.com/js/js_cookies.asp
      const name = cookieName + "=";
      const decodedCookie = decodeURIComponent(document.cookie);
      const ca = decodedCookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return null;
    },
  };
};

theme.Utils = Utils();

// Unit testing
if (typeof module !== "undefined" && module.exports) {
  module.exports = Utils;
}

const lyticsEvents = {
  cplOptin: "cpl_opt-in",
  sweepOptin: "sweep_opt-in",
  cplCosponsorsOptin: "cpl_co-sponsors_opt-in",
};

class LyticsService {
  /**
   * Send user data to lytics
   *
   * @argument {string} userEmail
   */
  static userDataTracker(userEmail) {
    try {
      window.jstag?.send({ email: userEmail });
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * Send CPL viewed event to lytics
   *
   * @argument {string} cplName
   */
  static viewedCplEventTracker(cplName) {
    const cplTrackEventObject = {
      event: lyticsEvents.cplOptin,
      cplName,
      hasUserAcceptedOffer: "null",
    };
    try {
      window.jstag?.send(cplTrackEventObject);
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * Send sweep opt-in event to lytics
   *
   * @argument {string} sweepName
   * @argument {Submission} submission
   */
  static sweepOptinEventTracker(sweepName, submission) {
    try {
      const sweepTrackEventObject = {
        event: lyticsEvents.sweepOptin,
        sweepName,
        email: submission.data.email,
        urlReferrer: submission.data.urlReferrer,
        zipCode: submission.data.zipCode,
        gender: submission.data.gender,
        birthYear: submission.data.birthYear,
      };
      window.jstag?.send(sweepTrackEventObject);
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * Send CPL accepted event to lytics
   *
   * @argument {string} cplName
   * @argument {string} userEmail
   */
  static acceptedCplEventTracker(cplName, userEmail) {
    const cplTrackEventObject = {
      event: lyticsEvents.cplOptin,
      cplName,
      email: userEmail,
      hasUserAcceptedOffer: true,
    };
    return new Promise((resolve, reject) => {
      try {
        window.jstag
          ? window.jstag.send(_, cplTrackEventObject, (resp) => {
              resolve(resp);
            })
          : resolve();
      } catch (error) {
        reject(error);
      }
    });
  }

  /**
   * Send CPL Lander Opt-in event to lytics
   *
   * @argument {Array<T>} sponsorsCpls
   * @argument {string} userEmail
   * @argument {string} sweepFormPath
   */
  static async sweepCplLanderEventTracker(
    sponsorsCpls,
    userEmail,
    sweepFormPath
  ) {
    if (sponsorsCpls) {
      const cplsGroup = sponsorsCpls
        .filter((cpl) => cpl.name && cpl.name !== "")
        .map((cpl) => cpl.name)
        .join(",");
      const cosponsorsOplTrackEventObject = {
        event: lyticsEvents.cplCosponsorsOptin,
        _uid: theme.Utils.getCookie("seerid") || "",
        email: userEmail,
        cplName: cplsGroup,
        sweepFormPath: sweepFormPath.substring(1),
      };
      await new Promise((resolve, reject) => {
        try {
          window.jstag
            ? window.jstag.send(_, cosponsorsOplTrackEventObject, (resp) => {
                resolve(resp);
              })
            : resolve();
        } catch (error) {
          reject(error);
        }
      });
    }
  }

  /**
   * Send lander quiz variables to lytics
   *
   * @argument demographicQuizObj
   */
  static landerQuizVariablesTracker(demographicQuizObj) {
    const demographicQuizTrackEventObject = {
      _uid: theme.Utils.getCookie("seerid") || "",
      [demographicQuizObj.variableKey]: demographicQuizObj.variableValue,
    };
    return new Promise((resolve, reject) => {
      try {
        window.jstag
          ? window.jstag.send(_, demographicQuizTrackEventObject, (resp) => {
              resolve(resp);
            })
          : resolve();
      } catch (error) {
        reject(error);
      }
    });
  }

  /**
   * Send SNHU completion event to lytics
   */
  static snhuCompletionEventTracker() {
    const snhuTrackEventObject = {
      _uid: theme.Utils.getCookie("seerid"),
      hasCompletedSnhu: true,
    };    

    return new Promise((resolve, reject) => {
      try {
        window.jstag
          ? window.jstag.send(_, snhuTrackEventObject, (resp) => {            
            resolve(resp);
          })
          : resolve();
      } catch (error) {
        reject(error);
      }
    });
  }
}

theme.LyticsService = LyticsService;

// @ts-check
class RecaptchaUtils {
  /**
   * Updates submission if form has reCaptcha token
   *
   * @argument {Submission} submission
   * @returns {Promise<unknown>}
   */
  static updateSubmissionToken(submission) {
    if (!submission["data"] || !submission["data"]["recaptcha"]) {
      return Promise.resolve(submission);
    } else {
      return this.withRecaptchaV3(
        (verificationResult, token) => ({
          ...submission,
          data: {
            ...submission.data,
            recaptcha: {
              ...submission.data.recaptcha,
              ...verificationResult,
              token,
            },
          },
        }),
        submission
      );
    }
  }

  /**
   * Request a reCaptcha v3 token and verifies the token against Form.io
   *
   * @argument {(object, string) => void} callback
   * @argument {Submission} submission
   * @returns {Promise<unknown>}
   */
  static withRecaptchaV3(callback, submission) {
    const requestReCaptchaToken = () =>
      new Promise((resolve, reject) => {
        window.grecaptcha.ready(() => {
          try {
            return window.grecaptcha
              .execute(window.FKL.reCAPTCHAv3SiteKey, {
                action: "updateSubmissionToken",
              })
              .then(resolve)
              .catch(reject);
          } catch (error) {
            return reject(error);
          }
        });
      });
    const verifyToken = (token) =>
      window.Formio.makeStaticRequest(
        `${window.Formio.projectUrl}/recaptcha?recaptchaToken=${token}`
      );
    return requestReCaptchaToken()
      .then((token) => {
        return verifyToken(token).then((verificationResult) =>
          callback(verificationResult, token)
        );
      })
      .catch((error) => {
        console.error(error);
        return submission;
      });
  }
}

theme.RecaptchaUtils = RecaptchaUtils;

const Routing = () => {
  return {
    redirectToNextPage: function (metadata, handle, current = null) {
      if (metadata.next_page_url && theme.Utils.isURL(metadata.next_page_url)) {
        const handleURL = "$handleURL";
        let next_page_url = metadata.next_page_url;
        if (next_page_url.indexOf(handleURL) != -1) {
          next_page_url = next_page_url.replace(handleURL, handle);
        }
        return next_page_url;
      } else if (
        metadata.sms_page_url &&
        ["sms", "quiz", "box"].indexOf(current) === -1
      ) {
        return `/collections/${metadata.sms_page_url}`;
      } else if (
        metadata.quiz_page_url &&
        ["quiz", "box"].indexOf(current) === -1
      ) {
        return `/collections/${metadata.quiz_page_url}`;
      } else if (
        metadata.box_of_samples_url &&
        ["sms", "box"].indexOf(current) === -1
      ) {
        return `/products/${metadata.box_of_samples_url}`;
      }
      return `/pages/${handle}-thank-you`;
    },
    updateUrlQueryParams: function (url, params) {
      if (params && params.size !== 0) {
        params.forEach((value, key) => {
          url.searchParams.delete(key);
          url.searchParams.append(key, value);
        });
        window.history.pushState({ html: document.html }, "", url);
      }
      return;
    },
  };
};

theme.Routing = Routing();

// Unit testing
if (typeof module !== "undefined" && module.exports) {
  module.exports = Routing;
}

Sentry.init({
  dsn: SENTRY_DSN,
  release: "d5387469bdb17d96286a4a60f1006414c150e340",
  environment: "production",
  allowUrls: [/cdn.shopify.com.*theme.js.*/],
  ignoreErrors: [
    "Non-Error promise rejection captured with value: Invalid alias",
    "AbortError: The play() request was interrupted by a call to pause()",
  ],
  sampleRate: 0.5,
});

// @ts-check
class ShopifyFormioProxy {
  /**
   * Update formio submission
   *
   * @argument formPath
   * @argument submissionObj
   */
  static updateFormioSubmission(formPath, submissionObj) {
    const options = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(submissionObj),
    };
    return fetch(
      `${window.FKL.yentaServicesApiUrl}/submissions${formPath}`,
      options
    ).then((response) => response.json());
  }

  /**
   * Submit formio submission
   *
   * @argument formPath
   * @argument submissionObj
   */
  static submitFormioSweepSubmission(formPath, submissionObj) {
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(submissionObj),
    };
    return fetch(
      `${window.FKL.yentaServicesApiUrl}/submissions${formPath}`,
      options
    )
      .then((response) =>
        response.json().then((data) => ({ isError: !response.ok, data }))
      )
      .then((responseObj) => {
        if (responseObj.isError) {
          return Promise.reject(responseObj.data);
        }
        return Promise.resolve(responseObj.data);
      });
  }
}

theme.ShopifyFormioProxy = ShopifyFormioProxy;

class YentaApi {
  /**
   * Get lander sponsors
   *
   * @argument {string} formPath
   */
  static getLanderSponsors(formPath) {
    const { yentaServicesApiUrl } = window.FKL;
    const endpointUrl = `${yentaServicesApiUrl}/cpl-lander/cosponsors`;
    const landerUrl = new URL(document.location.href);
    const lyticsUid = landerUrl.searchParams.get("l_uid");
    const options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };
    const params = {
      uid: lyticsUid ? lyticsUid : theme.Utils.getCookie("seerid") || "",
      url_referrer: landerUrl.href,
    };

    return fetch(
      `${endpointUrl}${formPath}?${new URLSearchParams(params).toString()}`,
      options
    )
      .then((response) =>
        response.json().then((data) => ({ isError: !response.ok, data }))
      )
      .then((responseObj) => {
        if (responseObj.isError) {
          return Promise.reject(responseObj.data);
        }
        return Promise.resolve(responseObj.data);
      });
  }

  /**
   * Notify to Yenta a successful cpl lander optin
   *
   * @argument {Array<T>} sponsorsCpls
   * @argument {string} formPath
   * @argument {string} userEmail
   */
  static notifyCplLanderOptin(sponsorsCpls, formPath, userEmail) {
    const { yentaServicesApiUrl } = window.FKL;
    const endpointUrl = `${yentaServicesApiUrl}/cpl-lander/cosponsors`;
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        cosponsor_names: sponsorsCpls.map((cpl) => cpl.name),
      }),
    };
    const params = {
      uid: theme.Utils.getCookie("seerid") || "",
      email: userEmail,
    };

    return fetch(
      `${endpointUrl}${formPath}?${new URLSearchParams(params).toString()}`,
      options
    );
  }

  /**
   * Get T&C page dynamic content
   *
   * @argument {string} sweepHandler
   */
  static getTacPageDynamicContent(sweepHandler) {
    const { yentaServicesApiUrl } = window.FKL;
    const endpointUrl = `${yentaServicesApiUrl}/terms-conditions`;
    const options = {
      method: "GET",
    };

    return fetch(`${endpointUrl}/sweepstake/${sweepHandler}`, options)
      .then((response) =>
        response.json().then((data) => ({ isError: !response.ok, data }))
      )
      .then((responseObj) => {
        if (responseObj.isError) {
          return Promise.resolve([]);
        }
        return Promise.resolve(responseObj.data.historical_cpls);
      });
  }

  /**
   * Retrieves the social referral information of a sweepstake
   *
   * @argument {Array<T>} submission
   * @argument {string} formPath
   */
  static getSocialReferralInformation(submission, formPath) {
    const { yentaServicesApiUrl } = window.FKL;
    const endpointUrl = `${yentaServicesApiUrl}/social-referral`;
    const defaultSocialReferralValues = {
      social_referral_link: "",
      social_referral_extra_entries: 0,
      social_referral_max_extra_entries: 0,
    };

    if (submission) {
      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ formio_submission_id: submission._id }),
      };
      return fetch(`${endpointUrl}${formPath}`, options)
        .then((response) =>
          response.json().then((data) => ({ isError: !response.ok, data }))
        )
        .then((responseObj) => {
          if (responseObj.isError) {
            return Promise.resolve(defaultSocialReferralValues);
          }
          return Promise.resolve(responseObj.data);
        });
    }
    return defaultSocialReferralValues;
  }
}

theme.YentaApi = YentaApi;

const ArcadeChooseGameModal = (() => {
  function ArcadeChooseGameModal() {
    const selectors = {
      modalarcadeModalChooseGame: "#arcadeModalChooseGame",
      modalActionButton: ".game__container",
      modalCloseButton: ".close-button",
    };

    const registerModal = () => {
      const modal = document.querySelector(
        selectors.modalarcadeModalChooseGame
      );

      const closeModalButtons = document.querySelectorAll(
        `${selectors.modalarcadeModalChooseGame} ${selectors.modalCloseButton}`
      );

      function toggleModal() {
        modal.classList.toggle("show-modal");
      }

      if (modal) {
        closeModalButtons.forEach((e) =>
          e.addEventListener("click", toggleModal)
        );
      }

      $(selectors.modalActionButton).on("click", async (event) => {
        event.preventDefault();
        const gameUrl = event.currentTarget.getAttribute("data-game-path");
        if (gameUrl === window.location.href) {
          toggleModal();
        } else {
          window.location.href = gameUrl;
        }
      });
    };

    const init = async () => {
      registerModal();
    };

    init();
  }

  return ArcadeChooseGameModal;
})();

theme.ArcadeChooseGameModal = ArcadeChooseGameModal();

const ArcadePrizeVaultModal = (() => {
  function ArcadePrizeVaultModal() {
    const selectors = {
      modalArcadeModalPrizeVault: "#arcadeModalPrizeVault",
      modalActionButton: ".arcade-vault-modal-button",
      modalContent: ".modal-content",
      modalCloseButton: ".close-button",
      modalHowRedeemLink: ".banner__how__redeem--link",
      modalArcadeBody: ".arcade__modal__body",
      modalHowRedeemSection: ".arcade__modal__how-to-redeem",
    };

    const registerModal = () => {
      const modal = document.querySelector(
        selectors.modalArcadeModalPrizeVault
      );

      const closeModalButtons = document.querySelectorAll(
        `${selectors.modalArcadeModalPrizeVault} ${selectors.modalCloseButton}`
      );

      function toggleModal() {
        modal.classList.toggle("show-modal");
      }

      function windowOnClick(event) {
        if (event.target === modal) {
          toggleModal();
        }
      }

      if (modal) {
        closeModalButtons.forEach((e) => e.addEventListener("click", toggleModal));
        window.addEventListener("click", windowOnClick);
      }

      $(selectors.modalActionButton).on("click", async (event) => {
        event.preventDefault();
        document
          .querySelector(`${selectors.modalArcadeModalPrizeVault}`)
          .classList.toggle("show-modal");
      });
    };

    const bindScrollAction = () => {
      $(selectors.modalHowRedeemLink).on("click", () => {
        $(selectors.modalArcadeBody).animate(
          { scrollTop: $(selectors.modalArcadeBody).prop("scrollHeight") },
          1500
        );
      });
    };

    const init = async () => {
      registerModal();
      bindScrollAction();
    };

    init();
  }

  return ArcadePrizeVaultModal;
})();

theme.ArcadePrizeVaultModal = ArcadePrizeVaultModal();

const PopUpComponent = () => {
  const DISPLAY_TIMER = 2000;
  const HIDE_TIMER = 4000;
  const EASYING = "linear";

  const selectors = {
    popUp: ".popup",
    popUpCloseButton: ".popup__close-button",
    popUpTitle: ".popup__title",
    popUpMessage: ".popup__message",
  };

  const close = () => {
    $(selectors.popUpCloseButton).on("click", () => {
      hide();
    });
  };

  const hide = () => {
    $(selectors.popUp).hide();
  };

  const hideAuto = (time) => {
    $(selectors.popUp).hide(time);
  };

  const setPopUp = (title, message) => {
    $(selectors.popUpTitle).text(title);
    $(selectors.popUpMessage).text(message);
    show();
  };

  const show = () => {
    $(selectors.popUp).show(DISPLAY_TIMER, EASYING, () => {
      setTimeout(() => {
        hideAuto(DISPLAY_TIMER);
      }, HIDE_TIMER);
    });
  };

  const init = () => {
    close();
  };

  init();

  return {
    setPopUp,
  };
};

theme.PopUpComponent = PopUpComponent();

const ShoppingCart = () => {
  const CART_ID = "testCart";
  const headers = { "Content-Type": "application/json" };

  // TODO: this is just a workaround to enable the
  // shopping cart only for the sweepstakes that have
  // the product.metafields.global.hasCart flag
  const hasCart = (cartId) => {
    return theme.Utils.retrieveFromSessionStorage(cartId);
  };

  const addToCart = async (product) => {
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers,
        body: JSON.stringify({ items: [product] }),
      });

      if (response.status === 200) {
        return true;
      }

      const json = await response.json();
      theme.Utils.handleHttpErrors(response.status, json.description);
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  const addBundleToCart = async (products) => {
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers,
        body: JSON.stringify({ items: products }),
      });

      if (response.status === 200) {
        return true;
      }
      const json = await response.json();
      theme.Utils.handleHttpErrors(response.status, json.description);
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  const retrieveCart = async () => {
    try {
      const response = await fetch("/cart.js", {
        method: "GET",
        headers,
      });
      const cart = await response.json();
      return cart.items;
    } catch (error) {
      console.error(error);
    }
  };

  const setCartCount = async () => {
    try {
      const cart = await retrieveCart();
      document.querySelector("#cart-count").textContent = cart.length;
    } catch (error) {
      console.error(error);
    }
  };

  const enableCart = () => {
    if (hasCart(CART_ID)) {
      $(".shopping-cart-component").css("visibility", "visible");
    }
  };

  const clearCart = async () => {
    try {
      await fetch("/cart/clear.js", {
        method: "POST",
        headers,
      });
    } catch (error) {
      console.error(error);
    }
  };

  const init = async () => {
    enableCart();
    await setCartCount();
  };

  init();

  return {
    addToCart,
    addBundleToCart,
    retrieveCart,
    setCartCount,
    clearCart,
  };
};

theme.ShoppingCart = ShoppingCart();

const WinnersVideoModal = (() => {
  function WinnersVideoModal() {
    const selectors = {
      modalWinnersVideo: "#winnerVideoModal",
      modalActionButton: ".winners-page__video",
      modalCloseButton: ".close-button",
      winnersVideosWrapper: "#shopify-section-winners-videos",
      modalVideo: ".winner-video-modal--video",
    };

    const registerModal = () => {
      const modal = document.querySelector(selectors.modalWinnersVideo);

      const closeModalButtons = document.querySelectorAll(
        `${selectors.modalWinnersVideo} ${selectors.modalCloseButton}`
      );

      function toggleModal() {
        modal.classList.toggle("show-modal");
        $(selectors.modalVideo).each(function () {
          $(this).trigger("pause").empty();
        });
      }

      function windowOnClick(event) {
        if (event.target === modal) {
          toggleModal();
        }
      }

      function handleWinnersVideosEvent() {
        $(selectors.modalActionButton).off("click");
        $(selectors.modalActionButton).on("click", (event) => {
          event.preventDefault();
          const videoUrl = event.target.parentElement.getAttribute(
            "data-video-url"
          );
          document
            .querySelector(`${selectors.modalWinnersVideo}`)
            .classList.toggle("show-modal");
          $(selectors.modalVideo).each(function () {
            $(this)
              .empty()
              .append(`<source src="${videoUrl}">`)
              .off()
              .trigger("load");
          });
        });
      }

      if (modal) {
        closeModalButtons.forEach((e) =>
          e.addEventListener("click", toggleModal)
        );
        window.addEventListener("click", windowOnClick);
        if ($(selectors.winnersVideosWrapper).length > 0) {
          $(selectors.winnersVideosWrapper).on("init", () => {
            handleWinnersVideosEvent();
          });
          $(selectors.winnersVideosWrapper).on("afterChange", () => {
            handleWinnersVideosEvent();
          });
        } else {
          handleWinnersVideosEvent();
        }
      }
    };

    const init = () => {
      registerModal();
    };

    init();
  }

  return WinnersVideoModal;
})();

theme.WinnersVideoModal = WinnersVideoModal();

const AdvertisePage = () => {
  function AdvertisePage() {
    (() => {
      $(document).ready(() => {
        if (new URL(window.location.href).search !== "") {
          saveUtmParameters();
        }
        $("div.advertise-page a").click(function (event) {
          event.preventDefault();
          redirectWithCurrentQueryParams(event.target.href);
        });
      });
    })();
  }
  return AdvertisePage;
};

const redirectWithCurrentQueryParams = function (anchorHref) {
  const anchorURL = new URL(anchorHref);
  theme.Utils.getCurrentQueryParams().forEach((value, key) => {
    anchorURL.searchParams.append(key, value);
  });
  window.location.href = anchorURL.href;
};

const saveUtmParameters = () => {
  const UTM_PARAMS_KEY = "UTM_PARAMS";
  const params = {};

  theme.Utils.getCurrentQueryParams().forEach((value, key) => {
    params[key] = value;
  });
  theme.Utils.saveInSessionStorage(UTM_PARAMS_KEY, params);
};

theme.AdvertisePage = AdvertisePage();

// Unit testing
if (typeof module !== "undefined" && module.exports) {
  module.exports = {
    redirectWithCurrentQueryParams,
    saveUtmParameters,
  };
}

const BlogPage = () => {
  function BlogPage() {
    (() => {
      $(document).ready(() => {
        $(".js-permalink").on("click", function () {
          $(this).find(".permalink").get(0).select();
          document.execCommand("copy");
        });
      });
    })();
  }
  return BlogPage;
};

theme.BlogPage = BlogPage();

// Unit testing
if (typeof module !== "undefined" && module.exports) {
  module.exports = {};
}

const ArcadePage = () => {
  function ArcadePage() {
    (() => {
      new window.theme.Sweepstake();
    })();
  }

  return ArcadePage;
};

theme.ArcadePage = ArcadePage();

// @ts-check
window.theme.CplOfferCollectionPage = (() => {
  function init() {
    const { collectionMetafields } = window.FKL;
    if (!Object.entries(collectionMetafields).length) {
      console.error("Unconfigured collection metafields");
      return;
    }
    const mainContent = document.getElementById("MainContent");
    if (mainContent) mainContent.style.paddingTop = "0px";
    window.FKL.sweepstakeId =
      collectionMetafields.sweepstake_id || "no-sweep-id";
    window.FKL.minimumCplOffersTaken =
      collectionMetafields.minimum_cpl_offers_taken &&
      collectionMetafields.minimum_cpl_offers_taken > 0
        ? collectionMetafields.minimum_cpl_offers_taken
        : 1;
    window.FKL.newGridUI =
      collectionMetafields.new_grid_ui &&
      collectionMetafields.new_grid_ui.toLocaleLowerCase() == "true";
    window.FKL.renderWidget(
      "CplOfferPage",
      document.getElementById("widget-container")
    );
  }

  return init;
})();

window.theme.DeprecatedFeature = (() => {
  function init() {
    if (window.FKL.isDeprecatedFeature) {
      window.location.href = theme.Routing.redirectToNextPage(
        window.FKL.objectMetafields,
        window.FKL.objectHandle
      );
    }
  }

  return init;
})();

const DontSellPersonalInfo = () => {
  function DontSellPersonalInfo() {
    const selectors = {
      formADontSellPersonalInfo: "#FormDontSellPersonalInfo",
    };

    const createForm = (selector, options) => {
      const $el = $(selector);
      const formUrl = $el.attr("data-form-url");
      return Formio.createForm($el[0], formUrl, options || {});
    };

    createForm(selectors.formADontSellPersonalInfo).then((form) => {
      form.on("submit", (submission) => {
        window.jstag?.send({
          event: "opt-out",
          email: submission.data.email,
        });
      });
    });
  }

  return DontSellPersonalInfo;
};

theme.DontSellPersonalInfo = DontSellPersonalInfo();

// Unit testing
if (typeof module !== "undefined" && module.exports) {
  module.exports = {};
}

const GetInTouch = (() => {
  function GetInTouch() {
    const selectors = {
      formAdvertise: "#FormAdvtise",
    };
    const UTM_PARAMS_KEY = "UTM_PARAMS";

    const createForm = function (selector, options) {
      const $el = $(selector);
      const formUrl = $el.attr("data-form-url");
      return Formio.createForm($el[0], formUrl, options || {});
    };

    const setUtmParams = () => {
      const currentUrl = new URL(window.location.href);
      const utmParameters = theme.Utils.retrieveFromSessionStorage(
        UTM_PARAMS_KEY
      );

      for (const [key, value] of Object.entries(utmParameters)) {
        currentUrl.searchParams.append(key, value);
      }
      window.history.pushState(utmParameters, "", currentUrl);
    };

    if (window.Formio) {
      createForm(selectors.formAdvertise).then(function (form) {
        if (
          !window.location.href.includes("?") &&
          theme.Utils.retrieveFromSessionStorage(UTM_PARAMS_KEY)
        ) {
          setUtmParams();
        }

        form.on("initialized", function () {
          const urlParams = new URLSearchParams(window.location.search);
          if (
            urlParams.get("case_study") &&
            urlParams.get("case_study") === "true"
          ) {
            $(".formio-component-requestACaseStudy input").first().click();
          }
        });
        form.on("submit", function (submission) {
          console.log(submission);
        });
        form.on("submitDone", function () {
          $(selectors.formAdvertise).find("input").val("");
          $(selectors.formAdvertise)
            .find(".formio-component-submit")
            .replaceWith(
              `<b style="font-size: 16px">Thank you!<br/>
                We will be in touch shortly</b>`
            );
          window.lintrk("track", { conversion_id: 2414986 });
        });
      });
    }
  }

  return GetInTouch;
})();

theme.GetInTouch = GetInTouch();

const ecommerceVariantsSelectors = {
  ecommerceVariantsContainer: ".ecommerce-collection_container",
  hideElementClass: "hide",
  donationVariantsContainer: ".non-profit-sweep_product-variants-container",
  noPurchaseBtn: ".btn-no--purchase",
  ecommerceProductVariantContainer:
    ".ecommerce-product-variant_buy-btn-container",
  shopifyProductVariantForm: "form[action$='/cart/add']",
  buyProductBtn: ".ecommerce-buy-product-btn",
  shopifyVariantLinkMoreOptions: ".shopify-payment-button__more-options",
  shopifyVariantBuyBtn: ".shopify-payment-button__button",
  nextPageBtn: ".next-page--btn",
  pageIndicator: ".page--indicator",
  ecommerceProductWrapper: ".ecommerce-product_wrapper",
  ecommercePaginationContainer: ".pagination--container",
  nonProfitLanderFormContainer: ".non-profit-sweep_product-form-container",
};

const IS_AFTER_ECOMMERCE = "isAfterEcommerce";

let ecommerceProductIndex = 0;

class EcommerceVariantsUtils {
  static showEcommerceVariantsInLander() {
    const donationVariantsContainer = document.querySelector(
      ecommerceVariantsSelectors.donationVariantsContainer
    );

    const ecommerceVariantsContainer = document.querySelector(
      ecommerceVariantsSelectors.ecommerceVariantsContainer
    );

    if (donationVariantsContainer != null)
      donationVariantsContainer.classList.add(
        ecommerceVariantsSelectors.hideElementClass
      );

    if (ecommerceVariantsContainer != null)
      ecommerceVariantsContainer.classList.remove(
        ecommerceVariantsSelectors.hideElementClass
      );

    theme.NonProfitUtils.createNonProfitEndpointURL();
  }

  static hideEcommerceVariantsInLander() {
    const ecommerceVariantsContainer = document.querySelector(
      ecommerceVariantsSelectors.ecommerceVariantsContainer
    );

    if (ecommerceVariantsContainer != null)
      ecommerceVariantsContainer.classList.add(
        ecommerceVariantsSelectors.hideElementClass
      );
  }

  static hideNonProfitFormContainer() {
    const nonProfitLanderFormContainer = document.querySelector(
      ecommerceVariantsSelectors.nonProfitLanderFormContainer
    );

    if (nonProfitLanderFormContainer != null)
      nonProfitLanderFormContainer.classList.add(
        ecommerceVariantsSelectors.hideElementClass
      );
  }

  static handleNextStepAfterEcommerceVariants() {
    window.FKL.skipEcommerceVariants = true;
    if (window.FKL.hasPageDonations) {
      this.hideEcommerceVariantsInLander();
      window.theme.NonProfitUtils.handleNextFlowStep(true);
      return;
    }
    window.theme.SweepstakeUtils.handleLanderRedirection(
      window.FKL.widgetsweepLanderUrl,
      window.FKL.widgetproductHandle
    );
  }

  static handleNextPageUrlBtn() {
    const noPurchaseBtn = document.querySelector(
      ecommerceVariantsSelectors.noPurchaseBtn
    );

    if (noPurchaseBtn != null) {
      noPurchaseBtn.addEventListener("click", () => {
        this.handleNextStepAfterEcommerceVariants();
      });
    }
  }

  static handleEcommerceVariantsButtons() {
    const ecommerceProductVariantContainers = document.querySelectorAll(
      ecommerceVariantsSelectors.ecommerceProductVariantContainer
    );

    ecommerceProductVariantContainers.forEach((variantContainer) => {
      const shopifyVariantForm = variantContainer.querySelector(
        ecommerceVariantsSelectors.shopifyProductVariantForm
      );

      const buyProductBtn = variantContainer.querySelector(
        ecommerceVariantsSelectors.buyProductBtn
      );

      const buyProductBtnAction = () => {
        const shopifyVariantLinkMoreOptions = variantContainer.querySelector(
          ecommerceVariantsSelectors.shopifyVariantLinkMoreOptions
        );

        const shopifyVariantBuyBtn = variantContainer.querySelector(
          ecommerceVariantsSelectors.shopifyVariantBuyBtn
        );

        this.createEcommerceNextPageUrl();

        if (shopifyVariantLinkMoreOptions) {
          shopifyVariantLinkMoreOptions.click();
        } else if (shopifyVariantBuyBtn) {
          shopifyVariantBuyBtn.click();
        }
      };

      if (shopifyVariantForm != null) {
        shopifyVariantForm.classList.add(
          ecommerceVariantsSelectors.hideElementClass
        );
      }

      if (buyProductBtn != null) {
        buyProductBtn.addEventListener("click", buyProductBtnAction);
      }
    });
  }

  static handlePaginationProgress() {
    ecommerceProductIndex++;

    const ecommerceVariantsContainer = document.querySelector(
      ecommerceVariantsSelectors.ecommerceVariantsContainer
    );

    const ecommerceProducts = ecommerceVariantsContainer.querySelectorAll(
      ecommerceVariantsSelectors.ecommerceProductWrapper
    );

    const selectedProduct = ecommerceProducts[ecommerceProductIndex];

    ecommerceProducts.forEach((productContainer) => {
      productContainer.classList.add(
        ecommerceVariantsSelectors.hideElementClass
      );
    });

    if (selectedProduct) {
      selectedProduct.classList.remove(
        ecommerceVariantsSelectors.hideElementClass
      );
    }

    if (ecommerceProductIndex + 1 === ecommerceProducts.length) {
      const ecommercePaginationContainer = document.querySelector(
        ecommerceVariantsSelectors.ecommercePaginationContainer
      );

      ecommercePaginationContainer.classList.add(
        ecommerceVariantsSelectors.hideElementClass
      );
    }
  }

  static handleNextProductBtn() {
    const nextPageBtn = document.querySelector(
      ecommerceVariantsSelectors.nextPageBtn
    );

    const ecommerceVariantsContainer = document.querySelector(
      ecommerceVariantsSelectors.ecommerceVariantsContainer
    );

    const ecommerceProducts = ecommerceVariantsContainer.querySelectorAll(
      ecommerceVariantsSelectors.ecommerceProductWrapper
    );

    if (nextPageBtn != null) {
      nextPageBtn.addEventListener("click", () => {
        this.handlePaginationProgress(ecommerceProducts);
      });
    }

    if (ecommerceProducts.length <= 1) {
      nextPageBtn.classList.add(ecommerceVariantsSelectors.hideElementClass);
    }
  }

  static handleEcommerceVariants() {
    this.handleNextPageUrlBtn();
    this.handleEcommerceVariantsButtons();
    this.handleNextProductBtn();
  }

  static getIsAfterEcommerceFlag() {
    return sessionStorage.getItem(IS_AFTER_ECOMMERCE);
  }

  static clearIsAfterEcommerceFlag() {
    theme.Utils.clearInSessionStorage(IS_AFTER_ECOMMERCE);
  }

  static createEcommerceNextPageUrl() {
    const ECOMMERCE_NEXT_PAGE_URL = "ecommerceNextPageUrl";
    theme.Utils.saveInSessionStorage(
      ECOMMERCE_NEXT_PAGE_URL,
      window.FKL.ecommerceNextPageUrl
    );
  }
}

theme.EcommerceVariantsUtils = EcommerceVariantsUtils;

const ecommerceVideoSelectors = {
  widgetContainer: "#ecommerce-video",
  hide: "hide",
  donationVariantsContainer: ".non-profit-sweep_product-variants-container",
};

const IS_AFTER_ECOMMERCE_VIDEO = "isAfterEcommerceVideo";
const ECOMMERCE_VIDEO_NEXT_PAGE_URL = "ecommerceVideoNextPageUrl";

class EcommerceVideoUtils {
  static show() {
    const donationVariantsContainer = document.querySelector(
      ecommerceVideoSelectors.donationVariantsContainer
    );

    const container = document.querySelector(
      ecommerceVideoSelectors.widgetContainer
    );

    if (donationVariantsContainer != null)
      donationVariantsContainer.classList.add(ecommerceVideoSelectors.hide);

    if (container != null) {
      container.classList.remove(ecommerceVideoSelectors.hide);
    }

    theme.NonProfitUtils.createNonProfitEndpointURL();
    this.createEcommerceVideoNextPageUrl();
  }

  static hide() {
    const container = document.querySelector(
      ecommerceVideoSelectors.widgetContainer
    );

    if (container != null) {
      container.classList.add(ecommerceVideoSelectors.hide);
    }

    theme.NonProfitUtils.clearNonProfitEndpointURL();
  }

  static skip() {
    window.FKL.skipEcommerceVideo = true;

    if (window.FKL.hasPageDonations) {
      this.hide();
      window.theme.NonProfitUtils.handleNextFlowStep(true);
      return;
    }
  }

  static mountWidget() {
    window.FKL.renderWidget(
      "EcommerceVideo",
      document.getElementById("ecommerce-video-widget-container")
    );
  }

  static getIsAfterEcommerceVideoFlag() {
    return sessionStorage.getItem(IS_AFTER_ECOMMERCE_VIDEO);
  }

  static clearIsAfterEcommerceVideoFlag() {
    theme.Utils.clearInSessionStorage(IS_AFTER_ECOMMERCE_VIDEO);
  }

  static createEcommerceVideoNextPageUrl() {
    theme.Utils.saveInSessionStorage(
      ECOMMERCE_VIDEO_NEXT_PAGE_URL,
      window.FKL.ecommerceVideoNextPageUrl
    );
  }
}

theme.EcommerceVideoUtils = EcommerceVideoUtils;

const NonProfitSweep = () => {
  // The productHandle and productMetadata variable comes from
  // sections/product-template-non-profit-sweep.liquid file

  const SLICKED_ELEMENT_CLASS = "slick-initialized";
  const DESKTOP_BREAKPOINT = 749;

  const selectors = {
    noThanksBtn: ".btn-no-thanks--donations",
    sectionNonProfitDonations:
      "#shopify-section-product-template-non-profit-sweep",
    donationVariantsWrapper: ".product-variants-container",
    variantsContainer: "variants-container",
    variantsElements: ".product-variant--container",
  };

  function handleMobileVariantsCarousel() {
    const variantSlider = document.querySelector(
      selectors.donationVariantsWrapper,
      selectors.sectionNonProfitDonations
    );
    const variantsElements = 
    theme.NonProfitUtils.getVariantsContainer().querySelectorAll(
      selectors.variantsElements
    );
    const variantsSlidesToShow = 3;

    if (
      !variantSlider.classList.contains(SLICKED_ELEMENT_CLASS) &&
      window.innerWidth <= DESKTOP_BREAKPOINT
    ) {
      $(variantSlider).slick({
        slidesToShow: Math.min(variantsSlidesToShow, variantsElements.length),
        slidesToScroll: 1,
        arrows: true,
        infinite: false,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: DESKTOP_BREAKPOINT,
            settings: "unslick",
          },
        ],
      });
    }
  }

  function hideNoThanksButtonIfStandalonePage() {
    const sweepstakeSubmission =
    theme.Sweepstake.prototype.retrieveSubmission();
    if (!sweepstakeSubmission) {
      $(selectors.noThanksBtn).hide();
    }
  }

  function NonProfitSweep() {
    const init = () => {
      theme.NonProfitUtils.handleMaxDonationValues();
      theme.NonProfitUtils.handleProductAvailability();
      handleMobileVariantsCarousel();
      theme.NonProfitUtils.handleNextPageUrlBtn();
      hideNoThanksButtonIfStandalonePage();
      theme.NonProfitUtils.createNonProfitEndpointURL();

      $(window).on("resize", () => {
        handleMobileVariantsCarousel();
      });
    };

    init();
  }

  return NonProfitSweep;
};

theme.NonProfitSweep = NonProfitSweep();

const NON_PROFIT_ENDPOINT_URL = "nonProfitEndpointURL";
const nonProfitSweepLanderSelectors = {
  donationVariantsContainer: ".non-profit-sweep_product-variants-container",
  landerFormContainer: ".non-profit-sweep_product-form-container",
  nonProfitSweepstakeSubheader: ".sweepstake-details_subheader",
  nonProfitSweepstakeHeader: ".sweepstake-details_header",
  nonProfitNoDonationHeader: ".sweepstake-no-donation_header",
  nonProfitSponsorsSection: ".sweepstakes-cpl-sponsors-section",
  noThanksBtn: ".btn-no-thanks--donations",
  hideElementClass: "hide",
  variantsContainer: "variants-container",
  variantsElements: ".product-variant--container",
  variantEntriesAttribute: "data-variant-entries",
  loadingSpinner: ".spinner",
  pageBody: ".non-profit-sweep",
  productVariantContainer: ".product-variant_buy-btn-container",
  productVariantForm: "form[action$='/cart/add']",
  variantFormMoreOptionsBtn: ".shopify-payment-button__more-options",
  shopifyVariantBuyBtn: ".shopify-payment-button__button",
  landerDonationBtn: ".lander-donation-btn",
  nonProfitVariantsWrapper: ".non-profit-sweep_product-variants-wrapper",
  nonProfitVariantsContainer: ".non-profit-sweep_product-variants",
  secondSetVariantHidden: ".variant--hidden",
  secondSetVariantHiddenClass: "variant--hidden",
  secondSetVariantClass: "second_set_variant",
  variantsMainTitleContainer: ".product-variants-container_main-title",
  variantsMainTitle: "main-title",
  variantsMainTitleSecondSet: "second-set-main-title",
  variantsSweepstakeDetails: ".non-profit-sweep-details_header",
  mainImage: "#main-image",
  productTitle: "#product-title",
};
class NonProfitUtils {
  /**
   * Get variant elements to remove.
   *
   * @argument {Array<{elem: Element, entriesToEarn: number}>} variantsElements
   * @argument {number} maxDonationEntries
   * @argument {number} userDonationEntries
   */
  static getDonationVariantsToRemove(
    variantsElements,
    maxDonationEntries,
    userDonationEntries
  ) {
    const maxUserEntriesToEarn = maxDonationEntries - userDonationEntries;
    return variantsElements.filter(
      (variantElement) => variantElement.entriesToEarn > maxUserEntriesToEarn
    );
  }

  /**
   * Show donation variants in lander
   */
  static showDonationVariantsInLander() {
    const landerFormContainer = document.querySelector(
      nonProfitSweepLanderSelectors.landerFormContainer
    );
    const donationVariantsContainer = document.querySelector(
      nonProfitSweepLanderSelectors.donationVariantsContainer
    );

    if (landerFormContainer != null)
      landerFormContainer.classList.add(
        nonProfitSweepLanderSelectors.hideElementClass
      );
    if (donationVariantsContainer != null)
      donationVariantsContainer.classList.remove(
        nonProfitSweepLanderSelectors.hideElementClass
      );
  }

  /**
   * Hide donation variants in lander
   */
  static hideDonationVariantsInLander() {
    const landerFormContainer = document.querySelector(
      nonProfitSweepLanderSelectors.landerFormContainer
    );
    const donationVariantsContainer = document.querySelector(
      nonProfitSweepLanderSelectors.donationVariantsContainer
    );

    if (landerFormContainer != null)
      landerFormContainer.classList.remove(
        nonProfitSweepLanderSelectors.hideElementClass
      );
    if (donationVariantsContainer != null)
      donationVariantsContainer.classList.add(
        nonProfitSweepLanderSelectors.hideElementClass
      );
  }

  /**
   * Show donation variants lander spinner
   */
  static showDonationVariantsSpinner() {
    const nonProfitVariantsWrapper = document.querySelector(
      nonProfitSweepLanderSelectors.nonProfitVariantsWrapper
    );
    if (nonProfitVariantsWrapper != null) {
      const nonProfitVariantsContainer = nonProfitVariantsWrapper.querySelector(
        nonProfitSweepLanderSelectors.nonProfitVariantsContainer
      );
      const nonProfitVariantsSpinner = nonProfitVariantsWrapper.querySelector(
        nonProfitSweepLanderSelectors.loadingSpinner
      );
      if (nonProfitVariantsContainer != null)
        nonProfitVariantsContainer.classList.add(
          nonProfitSweepLanderSelectors.hideElementClass
        );
      if (nonProfitVariantsSpinner != null)
        nonProfitVariantsSpinner.classList.remove(
          nonProfitSweepLanderSelectors.hideElementClass
        );
    }
  }

  /**
   * Hide donation variants lander spinner
   */
  static hideDonationVariantsSpinner() {
    const nonProfitVariantsWrapper = document.querySelector(
      nonProfitSweepLanderSelectors.nonProfitVariantsWrapper
    );
    if (nonProfitVariantsWrapper != null) {
      const nonProfitVariantsContainer = nonProfitVariantsWrapper.querySelector(
        nonProfitSweepLanderSelectors.nonProfitVariantsContainer
      );
      const nonProfitVariantsSpinner = nonProfitVariantsWrapper.querySelector(
        nonProfitSweepLanderSelectors.loadingSpinner
      );
      if (nonProfitVariantsContainer != null)
        nonProfitVariantsContainer.classList.remove(
          nonProfitSweepLanderSelectors.hideElementClass
        );
      if (nonProfitVariantsSpinner != null)
        nonProfitVariantsSpinner.classList.add(
          nonProfitSweepLanderSelectors.hideElementClass
        );
    }
  }

  /**
   * Handle donation variants lander buttons
   */
  static handleDonationVariantsButtons() {
    const productVariantContainers = document.querySelectorAll(
      nonProfitSweepLanderSelectors.productVariantContainer
    );

    productVariantContainers.forEach((variantContainer) => {
      const variantForm = variantContainer.querySelector(
        nonProfitSweepLanderSelectors.productVariantForm
      );
      const landerDonationBtn = variantContainer.querySelector(
        nonProfitSweepLanderSelectors.landerDonationBtn
      );

      const landerDonationBtnCallBack = () => {
        if (
          !window.FKL.sweepFormSuccessfulOptin &&
          !window.FKL.sweepFormFailedOptin &&
          !window.FKL.donationsAsFirstStep
        ) {
          window.FKL.landerDonationSelectedBtn = landerDonationBtn;
          this.showDonationVariantsSpinner();
        } else if (
          window.FKL.sweepFormSuccessfulOptin ||
          window.FKL.donationsAsFirstStep
        ) {
          const donationTileLink = variantContainer.querySelector(
            nonProfitSweepLanderSelectors.variantFormMoreOptionsBtn
          );

          const donationTileBtn = variantContainer.querySelector(
            nonProfitSweepLanderSelectors.shopifyVariantBuyBtn
          );
          const variantInput = variantForm.querySelector(
            "input[name=\"id\"]"
          );
          const variantId = variantInput ? variantInput.value : "N/A";
          const variantElement = variantContainer.closest(
            nonProfitSweepLanderSelectors.variantsElements
          );
          const variantEntries = variantElement ? variantElement.getAttribute(
            nonProfitSweepLanderSelectors.variantEntriesAttribute
          ) : "0";
          const variantPrice = landerDonationBtn ? 
            landerDonationBtn.textContent.replace("Donate $", "") : "0";

          window.snaptr("track", "ADD_CART", {
            price: parseFloat(variantPrice),
            currency: "USD",
            item_ids: [variantId],
            item_category: "donation",
            number_items: 1,
            description: "Donation - " + variantEntries + " Entries",
            user_email: this.getUserEmail()
          });

          window.ttq.track("AddToCart", {
            contents: [
              {
                content_id: variantId,
                content_type: "donation",
                content_name: "Donation - " + variantEntries + " Entries"
              }
            ],
            value: parseFloat(variantPrice),
            currency: "USD"
          });

          window.twq(
            "event",
            `tw-${window.FKL.x_pixel_id}-${window.FKL.x_add_to_cart_event_id}`,
            {
              value: parseFloat(variantPrice),
              currency: "USD",
              contents: [
                {
                  content_type: "donation",
                  content_id: variantId,
                  content_name: `Donation - ${variantEntries} Entries`,
                  content_price: parseFloat(variantPrice),
                  num_items: 1,
                  content_group_id: null,
                },
              ],
              email_address: this.getUserEmail(),
            }
          );

          if (donationTileLink) {
            donationTileLink.click();
          } else if (donationTileBtn) {
            donationTileBtn.click();
          }
        } else if (window.FKL.sweepFormFailedOptin) {
          this.hideDonationVariantsSpinner();
          this.hideDonationVariantsInLander();
          window.FKL.sweepFormFailedOptin = false;
        }
      };

      if (variantForm != null) {
        variantForm.classList.add(
          nonProfitSweepLanderSelectors.hideElementClass
        );
      }
      if (landerDonationBtn != null) {
        landerDonationBtn.classList.remove(
          nonProfitSweepLanderSelectors.hideElementClass
        );
        landerDonationBtn.addEventListener("click", landerDonationBtnCallBack);
      }
    });
  }

  /**
   * Get next page URL
   *
   */
  static getNextPageUrl() {
    return theme.Routing.redirectToNextPage(
      window.FKL.productMetadata,
      window.FKL.productHandle
    );
  }

  /**
   * Handle next flow step
   *
   */
  static handleNextFlowStep(isDonationInLander) {
    if (isDonationInLander && !window.FKL.skipEcommerceVideo) {
      theme.EcommerceVideoUtils.mountWidget();
      theme.EcommerceVideoUtils.show();
      return;
    } else if (isDonationInLander && !window.FKL.skipEcommerceVariants) {
      theme.EcommerceVariantsUtils.showEcommerceVariantsInLander();
      return;
    } else if (
      isDonationInLander &&
      !window.FKL.skipFkc &&
      window.FKL.enable_fkc_widget
    ) {
      theme.FkcUtils.mountWidget();
      theme.FkcUtils.show();
      return;
    } else if (
      isDonationInLander &&
      !window.FKL.skipSnhu &&
      !theme.SnhuUtils.isCompletedInSession()
    ) {
      theme.SnhuUtils.mountWidget();
      theme.SnhuUtils.show();
      return;
    } else if (isDonationInLander && !window.FKL.landerQuizAnsweredOrSkipped) {
      theme.LanderQuizUtils.mountLanderQuizWidget();
      theme.LanderQuizUtils.showLanderQuiz(true);
      return;
    } else if (isDonationInLander && !window.FKL.skipLanderCplQuiz) {
      theme.LanderCplQuizUtils.mountLanderCplQuizWidget();
      theme.LanderCplQuizUtils.showLanderCplQuiz(true);
      return;
    }
    window.location.href = this.getNextPageUrl();
  }

  /**
   * Get variants container element
   */
  static getVariantsContainer() {
    return document.getElementById(
      nonProfitSweepLanderSelectors.variantsContainer
    );
  }

  /**
   * Show second variants set title
   *
   */
  static showSecondVariantsSetTitle() {
    const variantSweepstakeDetailsContainer = document.querySelector(
      nonProfitSweepLanderSelectors.variantsSweepstakeDetails
    );

    this.addClassIfElementExists(
      variantSweepstakeDetailsContainer,
      nonProfitSweepLanderSelectors.hideElementClass
    );

    const variantsSetsTitles =
      document.querySelector(
        nonProfitSweepLanderSelectors.variantsMainTitleContainer
      )?.children || [];

    variantsSetsTitles.forEach((variantSetTitle) => {
      if (
        variantSetTitle.classList.contains(
          nonProfitSweepLanderSelectors.variantsMainTitleSecondSet
        )
      ) {
        variantSetTitle.classList.remove(
          nonProfitSweepLanderSelectors.hideElementClass
        );
      } else if (
        variantSetTitle.classList.contains(
          nonProfitSweepLanderSelectors.variantsMainTitle
        )
      ) {
        variantSetTitle.classList.add(
          nonProfitSweepLanderSelectors.hideElementClass
        );
      }
    });
  }

  /**
   * Hide second variants set title
   *
   */
  static hideSecondVariantsSetTitle() {
    const variantsSetsTitles =
      document.querySelector(
        nonProfitSweepLanderSelectors.variantsMainTitleContainer
      )?.children || [];

    variantsSetsTitles.forEach((variantSetTitle) => {
      if (
        variantSetTitle.classList.contains(
          nonProfitSweepLanderSelectors.variantsMainTitleSecondSet
        )
      ) {
        variantSetTitle.classList.add(
          nonProfitSweepLanderSelectors.hideElementClass
        );
      } else if (
        variantSetTitle.classList.contains(
          nonProfitSweepLanderSelectors.variantsMainTitle
        )
      ) {
        variantSetTitle.classList.remove(
          nonProfitSweepLanderSelectors.hideElementClass
        );
      }
    });
  }

  /**
   * Show second variants set
   *
   */
  static showSecondVariantsSet() {
    const variantsElements = this.getVariantsContainer().querySelectorAll(
      nonProfitSweepLanderSelectors.variantsElements
    );
    variantsElements.forEach((variantElement) => {
      if (
        variantElement.classList.contains(
          nonProfitSweepLanderSelectors.secondSetVariantClass
        )
      ) {
        variantElement.classList.remove(
          nonProfitSweepLanderSelectors.secondSetVariantHiddenClass
        );
      } else {
        variantElement.classList.add(
          nonProfitSweepLanderSelectors.hideElementClass
        );
      }
    });
    this.showSecondVariantsSetTitle();
  }

  /**
   * Hide second variants set
   *
   */
  static hideSecondVariantsSet() {
    const variantsElements = this.getVariantsContainer().querySelectorAll(
      nonProfitSweepLanderSelectors.variantsElements
    );
    variantsElements.forEach((variantElement) => {
      if (
        variantElement.classList.contains(
          nonProfitSweepLanderSelectors.secondSetVariantClass
        )
      ) {
        variantElement.classList.add(
          nonProfitSweepLanderSelectors.secondSetVariantHiddenClass
        );
      } else {
        variantElement.classList.remove(
          nonProfitSweepLanderSelectors.hideElementClass
        );
      }
    });
    this.hideSecondVariantsSetTitle();
  }

  /**
   * Set next page URL
   *
   */
  static handleNextPageUrlBtn(isDonationInLander = false) {
    const noThanksBtn = document.querySelector(
      nonProfitSweepLanderSelectors.noThanksBtn
    );
    if (noThanksBtn != null) {
      noThanksBtn.addEventListener("click", () => {
        if (isDonationInLander) {
          const hasSecondVariantsSet =
            document.querySelectorAll(
              nonProfitSweepLanderSelectors.secondSetVariantHidden
            ).length > 0;

          if (hasSecondVariantsSet) {
            this.showSecondVariantsSet();
            return;
          } else if (
            !window.FKL.sweepFormSuccessfulOptin &&
            !window.FKL.sweepFormFailedOptin
          ) {
            window.FKL.landerDonationSelectedBtn = noThanksBtn;
            this.showDonationVariantsSpinner();
            if (window.FKL.donationsAsFirstStep) {
              this.hideDonationVariantsInLander();
              this.hideNonProfitSweepstakeDetails();
              this.showNoDonationSweepstakeDetails();
              this.showNonProfitSponsorsSection();
              window.FKL.donationsAsFirstStep = false;
            }
            return;
          } else if (window.FKL.sweepFormFailedOptin) {
            this.hideDonationVariantsSpinner();
            this.hideDonationVariantsInLander();
            this.hideSecondVariantsSet();
            window.FKL.sweepFormFailedOptin = false;
            return;
          }
        }
        if (!isDonationInLander || window.FKL.sweepFormSuccessfulOptin) {
          sessionStorage.removeItem(NON_PROFIT_ENDPOINT_URL);
          this.handleNextFlowStep(isDonationInLander);
        }
      });
    }
  }

  /**
   * Handle donation variants in lander
   */
  static handleDonationVariantsInLander() {
    this.hideDonationVariantsInLander();
    this.handleDonationVariantsButtons();
    this.handleNextPageUrlBtn(true);
  }

  /**
   * Remove donation variants received in array
   *
   * @argument {Array<{elem: Element, entriesToEarn: number}>} variantsToRemove
   */
  static removeDonationVariants(variantsToRemove) {
    variantsToRemove.map((variantElement) => {
      variantElement.elem.remove();
    });
  }

  /**
   * Get donation entries from user submission
   */
  static getUserDonationEntries() {
    const submission = theme.Sweepstake.prototype.retrieveSubmission();
    return Number(submission?.data?.donations) || 0;
  }

  /**
   * Get email from user submission
   */
  static getUserEmail() {
    const submission = theme.Sweepstake.prototype.retrieveSubmission();
    return submission?.data?.email;
  }

  /**
   * Handle donation variants in lander pre optin
   */
  static handleMaxDonationValues() {
    if (window.FKL.maxDonationEntries) {
      const maxDonationEntries = Number(window.FKL.maxDonationEntries);
      const userDonationEntries = this.getUserDonationEntries();
      const variantsElements = this.getVariantsContainer().querySelectorAll(
        nonProfitSweepLanderSelectors.variantsElements
      );

      const variantsToRemove = this.getDonationVariantsToRemove(
        [...variantsElements].map((variantElement) => {
          return {
            elem: variantElement,
            entriesToEarn: Number(
              variantElement.getAttribute(
                nonProfitSweepLanderSelectors.variantEntriesAttribute
              )
            ),
          };
        }),
        maxDonationEntries,
        userDonationEntries
      );
      this.removeDonationVariants(variantsToRemove);
    }
  }

  /**
   * Handle donation product availability
   */
  static handleProductAvailability() {
    const variantsElements = this.getVariantsContainer().querySelectorAll(
      nonProfitSweepLanderSelectors.variantsElements
    );
    const loadingSpinnerElement = document.querySelector(
      nonProfitSweepLanderSelectors.loadingSpinner
    );
    const pageBody = document.querySelector(
      nonProfitSweepLanderSelectors.pageBody
    );

    if (!window.FKL.donationProductAvailable || variantsElements.length === 0) {
      window.location.href = this.getNextPageUrl();
    } else {
      loadingSpinnerElement.classList.add(
        nonProfitSweepLanderSelectors.hideElementClass
      );
      pageBody.classList.remove(nonProfitSweepLanderSelectors.hideElementClass);
    }
  }

  /**
   * Create non-profit endpoint URL for donation extra entries
   */
  static createNonProfitEndpointURL(donationsAsFirstStep = false) {
    const sweepstakeSubmission = sessionStorage.getItem("sweepstakeSubmission");
    if (sweepstakeSubmission || donationsAsFirstStep) {
      const submissionId = JSON.parse(sweepstakeSubmission)?._id || "";
      const currentUrl = new URL(document.location.href);
      const params = {
        _id: submissionId,
        url_referrer: currentUrl.href,
      };

      const { yentaServicesApiUrl, donationProductHandle } = window.FKL;
      const nonProfitProductHandle = donationProductHandle.replace(
        /(-non-profit-sweep$)/,
        ""
      );
      const nonProfitEndpointURL = `${
        yentaServicesApiUrl
      }/non-profit/sweepstake/${
        nonProfitProductHandle
      }?${new URLSearchParams(params).toString()}`;
      sessionStorage.setItem(NON_PROFIT_ENDPOINT_URL, nonProfitEndpointURL);
    }
  }

  /**
   * Handle donation variants in lander post optin
   *
   */
  static handleDonationVariantsInLanderPostOptin() {
    window.FKL.sweepFormSuccessfulOptin = true;
    this.createNonProfitEndpointURL();
    if (window.FKL.landerDonationSelectedBtn) {
      window.FKL.landerDonationSelectedBtn.click();
    }
  }

  /**
   * Create non-profit endpoint URL for donation extra entries
   */
  static clearNonProfitEndpointURL() {
    theme.Utils.clearInSessionStorage(NON_PROFIT_ENDPOINT_URL);
  }

  /**
   * Handle non-profit submission error
   */
  static handleNonProfitSubmissionError() {
    window.FKL.sweepFormFailedOptin = true;
    if (window.FKL.landerDonationSelectedBtn) {
      window.FKL.landerDonationSelectedBtn.click();
    }
  }

  /**
   * Hides the Non Profit Sweepstake details
   */
  static hideNonProfitSweepstakeDetails() {
    const nonProfitSweepstakeHeaderElement = [
      document.querySelector(
        nonProfitSweepLanderSelectors.nonProfitSweepstakeHeader
      ),
      document.querySelector(
        nonProfitSweepLanderSelectors.nonProfitSweepstakeSubheader
      ),
    ];

    nonProfitSweepstakeHeaderElement.map((element) =>
      this.addClassIfElementExists(
        element,
        nonProfitSweepLanderSelectors.hideElementClass
      )
    );
  }

  /**
   * Applies a class to an element if it's on the page
   */
  static addClassIfElementExists(element, elementClass) {
    if (element != null) element.classList.add(elementClass);
  }

  /**
   * Shows the 'No donation' header
   */
  static showNoDonationSweepstakeDetails() {
    const nonProfitNoDonationHeaderElement = document.querySelector(
      nonProfitSweepLanderSelectors.nonProfitNoDonationHeader
    );

    if (nonProfitNoDonationHeaderElement != null)
      nonProfitNoDonationHeaderElement.classList.remove(
        nonProfitSweepLanderSelectors.hideElementClass
      );
  }

  /**
   * Hides the Non Profit Sponsors section
   */
  static hideNonProfitSponsorsSection() {
    const nonProfitSponsorsSectionContainer = document.querySelector(
      nonProfitSweepLanderSelectors.nonProfitSponsorsSection
    );

    this.addClassIfElementExists(
      nonProfitSponsorsSectionContainer,
      nonProfitSweepLanderSelectors.hideElementClass
    );
  }

  /**
   * Shows the Non Profit Sponsors section
   */
  static showNonProfitSponsorsSection() {
    const nonProfitSponsorsSectionContainer = document.querySelector(
      nonProfitSweepLanderSelectors.nonProfitSponsorsSection
    );

    if (nonProfitSponsorsSectionContainer != null)
      nonProfitSponsorsSectionContainer.classList.remove(
        nonProfitSweepLanderSelectors.hideElementClass
      );
  }

  /**
   * Displays donation tiles as the first step of the sweep flow
   */
  static handleDonationsAsFirstStep() {
    window.FKL.donationsAsFirstStep = true;
    this.hideNonProfitSponsorsSection();
    this.showDonationVariantsInLander();

    const variantSweepstakeDetailsContainer = document.querySelector(
      nonProfitSweepLanderSelectors.variantsSweepstakeDetails
    );

    if (variantSweepstakeDetailsContainer != null)
      variantSweepstakeDetailsContainer.classList.remove(
        nonProfitSweepLanderSelectors.hideElementClass
      );
  }

  /**
   * Handles the sweep content when the variant query param is present
   */
  static handleVariant(variant) {
    const mainImage = document.querySelector(
      nonProfitSweepLanderSelectors.mainImage
    );
    const productTitle = document.querySelector(
      nonProfitSweepLanderSelectors.productTitle
    );

    Object.entries(window.FKL.variantMainImages).forEach(([key, value]) => {
      if (key.includes(variant)) {
        mainImage.src = value;
      }
    });

    Object.entries(window.FKL.variantProductTitles).forEach(([key, value]) => {
      if (key.includes(variant)) {
        productTitle.innerHTML = value;
      }
    });
  }
}

theme.NonProfitUtils = NonProfitUtils;

// @ts-check
window.theme.QuizCollectionPage = (() => {
  function init() {
    const isItTrue = (value) => (value || "").toLocaleLowerCase() === "true";
    const { collectionMetafields } = window.FKL;
    if (!collectionMetafields) {
      console.error("Unconfigured collection metafields");
      return;
    }
    if (isItTrue(collectionMetafields.is_widget_matchup)) {
      window.FKL.matchUpSlug = collectionMetafields.matchup_id || "matchup";
      window.FKL.renderWidget(
        "MatchUp",
        document.getElementById("widget-container")
      );
    } else if (isItTrue(collectionMetafields.is_widget_puzzle)) {
      window.FKL.puzzleSlug = collectionMetafields.puzzle_id || "puzzle";
      window.FKL.renderWidget(
        "Puzzle",
        document.getElementById("widget-container")
      );
    } else if (isItTrue(collectionMetafields.is_widget_word_search)) {
      window.FKL.wordSearchSlug =
        collectionMetafields.word_search_id || "word-search";
      window.FKL.renderWidget(
        "WordSearch",
        document.getElementById("widget-container")
      );
    } else {
      window.FKL.quizSlug = collectionMetafields.quiz_id || "arcade";
      window.FKL.questionsPerPage = collectionMetafields.questions_per_page
        ? Number(collectionMetafields.questions_per_page)
        : 10;
      window.FKL.allowOptInReminder = !isItTrue(
        collectionMetafields.disable_opt_in_reminder
      );
      window.FKL.shouldDoublePoints = isItTrue(
        collectionMetafields.should_double_points
      );
      window.FKL.renderWidget(
        "Quiz",
        document.getElementById("widget-container")
      );
    }
  }

  return init;
})();

// @ts-check
class QuizUtils {
  /**
   * Limits the value of quiz extra entries.
   *
   * @argument {number} quizExtraEntries
   * @argument {number?} submissionCount
   * @argument {number} questionCount
   * @returns {number}
   */
  static limitExtraEntries(quizExtraEntries, submissionCount, questionCount) {
    if (submissionCount) {
      return Math.min(
        quizExtraEntries,
        submissionCount * questionCount
      );
    }
    return quizExtraEntries;
  }

  /**
   * Returns the base URL for sending CPL optins
   *
   * @argument {string} cplFormPath
   * @returns {string}
   */
  static getBaseURLForCPLForm(cplFormPath) {
    return window.FKL.oldFormioForms.includes(cplFormPath)
      ? window.FKL.oldFormioBaseURL
      : window.FKL.onPremiseFormioBaseURL;
  }
}

theme.QuizUtils = QuizUtils;

window.theme.SocialReferralPage = (() => {
  function init() {
    const mainContent = document.getElementById("MainContent");
    const siteFooter = document.getElementsByClassName("site-footer")[0];

    if (mainContent) mainContent.style.paddingTop = "0px";

    //Hiding site footer to prevent scroll
    if (siteFooter) siteFooter.style.display = "none";

    window.FKL.renderWidget(
      "SocialReferralPage",
      document.getElementById("widget-container")
    );
  }

  return init;
})();

window.theme.SponsorsList = (() => {
  function init() {
    const selectors = {
      sponsorsListPageContainer: "[data-section-type=sponsors-list]",
      spinnerSelector: ".sponsors-list-spinner",
      contentSelector: ".sponsors-list-content",
      hiddenClassName: "hidden",
    };

    window.theme.YentaApi.getTacPageDynamicContent(
      window.FKL.sweepHandler
    ).then((sponsorsCplsInfo) => {
      const pageSpinner = document
        .querySelector(selectors.sponsorsListPageContainer)
        .querySelector(selectors.spinnerSelector);
      const pageContent = document
        .querySelector(selectors.sponsorsListPageContainer)
        .querySelector(selectors.contentSelector);
      const pageFixedContent = theme.SponsorsListUtils.setDynamicCplList(
        pageContent.innerHTML,
        sponsorsCplsInfo
      );
      pageContent.innerHTML = pageFixedContent;
      pageSpinner.classList.add(selectors.hiddenClassName);
      pageContent.classList.remove(selectors.hiddenClassName);
    });
  }
  return init;
})();

const CPL_LIST_IDENTIFIER = "#--CPL_COSPONSOR_LIST--#";
const SHE_MEDIA_CPL = "she media";

class SponsorsListUtils {
  /**
   * Get an HTML list string from CPL cosponsors info array
   *
   * @argument {Array<string>} sponsorsCplsInfo
   *
   * @returns {string}
   */
  static getCplsInfoAsHtmlList(sponsorsCplsInfo) {
    const htmlListElements = sponsorsCplsInfo.reduce(
      (acc, cplInfo) =>
        acc +
        (!cplInfo.toLowerCase().includes(SHE_MEDIA_CPL)
          ? `<li>${cplInfo}</li>`
          : ""),
      ""
    );

    return htmlListElements != "" ? `<ol>${htmlListElements}</ol>` : "";
  }

  /**
   * Replace CPL list identifier with the current
   * CPL cosponsors information
   *
   * @argument {string} sponsorsListPageContent
   * @argument {Array<string>} sponsorsCplsInfo
   *
   * @returns {string}
   */
  static setDynamicCplList(sponsorsListPageContent, sponsorsCplsInfo) {
    if (!sponsorsListPageContent.includes(CPL_LIST_IDENTIFIER))
      return sponsorsListPageContent;
    else {
      return sponsorsListPageContent.replace(
        CPL_LIST_IDENTIFIER,
        this.getCplsInfoAsHtmlList(sponsorsCplsInfo)
      );
    }
  }
}

theme.SponsorsListUtils = SponsorsListUtils;

// Unit testing
if (typeof module !== "undefined" && module.exports) {
  module.exports = {
    CPL_LIST_IDENTIFIER,
  };
}

const SweepPanelSection = (() => {
  function SweepPanelSection() {
    const selectors = {
      exploreGiveawaysButton: ".explore-giveaways--button",
    };

    const scrollToNextSection = () => {
      $(selectors.exploreGiveawaysButton).on("click", (event) => {
        const sectionSelector = $(event.target).parents("div")[4];

        $("html, body").animate(
          {
            scrollTop: $(sectionSelector).next().offset().top,
          },
          "slow"
        );
      });
    };

    const init = () => {
      scrollToNextSection();
    };

    init();
  }

  return SweepPanelSection;
})();

theme.SweepPanelSection = SweepPanelSection();

const fkcSelectors = {
  container: "#fkc",
  hide: "hide",
  donationVariantsContainer: ".non-profit-sweep_product-variants-container",
};

class FkcUtils {
  static show() {
    const container = document.querySelector(fkcSelectors.container);

    const donationVariantsContainer = document.querySelector(
      fkcSelectors.donationVariantsContainer
    );

    if (container != null) container.classList.remove(fkcSelectors.hide);

    if (donationVariantsContainer != null)
      donationVariantsContainer.classList.add(fkcSelectors.hide);
  }

  static hide() {
    const container = document.querySelector(fkcSelectors.container);
    if (container != null) container.classList.add(fkcSelectors.hide);
  }

  static mountWidget() {
    window.FKL.renderWidget(
      "Fkc",
      document.getElementById("fkc-widget-container")
    );
  }

  static skip() {
    window.FKL.skipFkc = true;

    if (window.FKL.hasPageDonations) {
      this.hide();
      window.theme.NonProfitUtils.handleNextFlowStep(true);
      return;
    }
  }
}

theme.FkcUtils = FkcUtils;

const Sweepstake = (() => {
  const SWEEPSTAKE_SUBMISSION = "sweepstakeSubmission";
  const INITIAL_SUBMISSION = "initialSubmission";
  const CPL_EXTRA_ENTRIES_HASH = "cplExtraEntriesHash";
  const ENABLE_RE_ENTRY_OPTINS = "enableReEntryOptins";
  const SWEEPSTAKE_SESSION_ENTRIES = "sweepstakeSessionEntries";
  const ARCADE_CURRENT_GAME = "arcadeCurrentGame";
  const SWEEPSTAKE_LANDER_URL = "currentSweepLanderUrl";

  // TODO: these flags are for testing in staging only
  const HAS_CART = window.FKL.hasCart === "True";
  const IS_FKL_SWEEP = window.FKL.productMetadata
    ? window.FKL.productMetadata.is_FKL_sweep &&
      window.FKL.productMetadata.is_FKL_sweep.toLowerCase() === "true"
    : false;
  const SWEEP_RE_ENTRY_ACTIVE = window.FKL.productMetadata
    ? !(
        window.FKL.productMetadata.no_re_entry_sweep &&
        window.FKL.productMetadata.no_re_entry_sweep.toLowerCase() === "true"
      )
    : true;
  const HOURS_BETWEEN_ENTRIES =
    window.FKL.productMetadata &&
    window.FKL.productMetadata.minimum_hrs_between_entries &&
    !isNaN(Number(window.FKL.productMetadata.minimum_hrs_between_entries))
      ? Number(window.FKL.productMetadata.minimum_hrs_between_entries)
      : 24; //24 hours by default for re entry sweep
  const IS_NON_PROFIT_SWEEP = window.FKL.isNonProfitSweep || false;

  const validationCheck = {
    PASS: "PASS",
    ERROR_RE_ENTRY_HOURS: "ERROR_RE_ENTRY_HOURS",
    ERROR_MAX_ENTRIES_REACHED: "ERROR_MAX_ENTRIES_REACHED",
    FORMIO_CUSTOM_ERROR: "customReEntrySweeps",
  };

  const selectors = {
    hiddenSweepstakeHandle: "",
    hiddenHandle: "#SweepstakeHandle",
    formSweepstake: "#FormSweepstake",
    sectionMain: ".sweepstake-main",
    sectionEntries: ".sweepstake-entries",
    sectionThank: ".sweepstake-thank",
    buttonSubmitBrands: ".submit-brands",
    sectionLearnMore: ".learn-more",
    sectionPrizeList: ".prize-list",
    sectionSponsors: ".sponsors",
    formPathAttr: "data-form-path-url",
  };

  function Sweepstake() {
    const createForm = (selector, options) => {
      const $el = $(selector);
      const formUrl = $el.attr("data-form-url");
      return Formio.createForm($el[0], formUrl, options || {});
    };

    // TODO: testing only, this will save the cart status based on
    // the product.metafields.global.hasCart flag
    const storeCartState = (cart) => {
      const CART_ID = "testCart";
      theme.Utils.saveInSessionStorage(CART_ID, cart);
    };

    const handle = $(selectors.hiddenHandle).val();
    const termsUrl = "/pages/" + handle + "-terms-conditions";
    const beneficiaryTerms =
      window.FKL.productMetadata && window.FKL.productMetadata.beneficiary_terms
        ? window.FKL.productMetadata.beneficiary_terms
        : "";
    const cplLanderTerms = `I agree to the 
    <a href="${termsUrl}" target="_blank">Terms & Conditions</a>
     of this sweepstake. I agree to receive email communications 
     from FindKeep.Love ${beneficiaryTerms} and all brands listed below.`;

    const getReCaptchaV2Element = () => {
      return document.querySelector(".formio-component-reCaptchaV2Placeholder");
    };

    const verifyToken = (token) => {
      const VERIFY_SERVER = window.FKL.reCAPTCHAv2ServerUrl;
      const url = `${VERIFY_SERVER}/${token}`;
      fetch(url, { method: "POST" })
        .then((resp) => {
          console.log(resp);
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const fillRecaptcha = (form) => {
      const recaptchaComponent = window.FormioUtils.getComponent(
        form.components,
        "recaptcha"
      );
      theme.RecaptchaUtils.withRecaptchaV3((verificationResult) => {
        const score = verificationResult["score"] || 0;
        recaptchaComponent.setValue(verificationResult);
        if (score <= window.FKL.reCaptchaV2MinScore) {
          window.grecaptcha.render(getReCaptchaV2Element(), {
            sitekey: window.FKL.reCAPTCHAv2SiteKey,
            callback: verifyToken,
          });
        }
      });
    };

    const fillIPAddress = (form) => {
      const ipAddressComponent = window.FormioUtils.getComponent(
        form.components,
        "ipAddress"
      );
      if (!ipAddressComponent) {
        return;
      }
      fetch("https://api64.ipify.org")
        .then((resp) => resp.text())
        .then((data) => {
          ipAddressComponent.setValue(data);
        })
        .catch(() => {
          ipAddressComponent.setValue(null);
        });
    };

    const handleEmailLowerCase = (form) => {
      const emailComponent = window.FormioUtils.getComponent(
        form.components,
        "email"
      );
      document
        .getElementById(`${emailComponent.id}-email`)
        .addEventListener("keyup", () => {
          emailComponent.setValue(
            emailComponent.getValue().toLocaleLowerCase()
          );
        });
    };

    const removeHiddenFields = () => {
      $(".form-view-hidden-field").remove();
    };

    const fklSweepView = () => {
      if (IS_FKL_SWEEP) {
        const learnMoreSection = $(selectors.sectionLearnMore);
        const prizeListSection = $(selectors.sectionPrizeList);
        const sponsorsSection = $(selectors.sectionSponsors);

        learnMoreSection.html("Sponsored by FindKeep.Love");
        prizeListSection.hide();
        sponsorsSection.hide();
      }
    };

    const lastOptInData = (() => {
      //Prefilled sweep form just on thank you page
      if (document.querySelector("[data-section-type=thank-you-page]")) {
        const userSubmission = this.retrieveSubmission();
        if (userSubmission && userSubmission.data) {
          const { email, zipCode, gender, birthYear } = userSubmission.data;
          return {
            email: email,
            zipCode: zipCode,
            gender: gender,
            birthYear: birthYear,
          };
        }
      }
      return null;
    })();

    const handleLanderSponsors = async () => {
      const formUrl = this.getFormPathURL();
      const [
        cplLanderSponsors,
        cplInfluencerSponsor,
      ] = await theme.YentaApi.getLanderSponsors(formUrl)
        .then((data) => {
          const dataCplCosponsors =
            data.cpls_cosponsors?.length === 0 ? null : data.cpls_cosponsors;
          return [dataCplCosponsors, data.influencer];
        })
        .catch((error) => {
          console.error(error);
          return [];
        });

      window.FKL.cplLanderSponsors = cplLanderSponsors;
      window.FKL.cplInfluencerSponsor = cplInfluencerSponsor;
      if (cplLanderSponsors || cplInfluencerSponsor) {
        theme.SweepstakeUtils.handleLanderDOMChanges(
          cplLanderSponsors,
          cplInfluencerSponsor,
          cplLanderTerms
        );
        theme.SweepstakeUtils.handleSponsorsImpressions(
          cplLanderSponsors,
          cplInfluencerSponsor
        );
      }
      if (window.FKL.hasPageDonations) {
        theme.NonProfitUtils.handleDonationVariantsInLander();
      }
      theme.SweepstakeUtils.hideSpinnerShowLander();
    };

    const getIsDonationsFirstStepParam = () => {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);

      return urlParams.has("sweepstake_donations");
    };

    const getVariantParam = () => {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);

      return urlParams.get("variant");
    };

    const init = async () => {
      const isAfterDonation = theme.SweepstakeUtils.getIsAfterDonationFlag();
      const isAfterEcommerce =
        theme.EcommerceVariantsUtils.getIsAfterEcommerceFlag();
      const isAfterEcommerceVideo =
        theme.EcommerceVideoUtils.getIsAfterEcommerceVideoFlag();
      const isDonationsFirstStep = getIsDonationsFirstStepParam();
      const variant = getVariantParam();

      await handleLanderSponsors();
      fklSweepView();

      if (IS_NON_PROFIT_SWEEP) {
        theme.EcommerceVariantsUtils.handleEcommerceVariants();
      }

      // Skip the ecommerce video if the user has already passed video or tiles
      if (isAfterEcommerceVideo || isAfterEcommerce) {
        window.FKL.skipEcommerceVideo = true;
      }

      if (isAfterEcommerce) {
        window.FKL.skipEcommerceVariants = true;
      }

      if (!isAfterDonation && !isAfterEcommerce && !isAfterEcommerceVideo) {
        storeCartState(HAS_CART);
        this.clearSubmission();
        theme.Utils.clearInSessionStorage(INITIAL_SUBMISSION);
        theme.Utils.saveInSessionStorage(
          ENABLE_RE_ENTRY_OPTINS,
          SWEEP_RE_ENTRY_ACTIVE
        );
        theme.ShoppingCart.clearCart().then(theme.ShoppingCart.setCartCount);
        this.$brands = $(".brand");
        $.each(this.$brands, (index, object) => {
          const $checkboxes = $(object).find("input[type=checkbox]");
          $(object).on("click", () => {
            $checkboxes.prop("checked", !$checkboxes.prop("checked"));
          });
        });

        if (window.FKL.hasPageDonations && isDonationsFirstStep) {
          const IS_DONATION_FIRST_STEP = "isDonationsFirstStep";
          theme.Utils.saveInSessionStorage(IS_DONATION_FIRST_STEP, true);
          theme.NonProfitUtils.createNonProfitEndpointURL(isDonationsFirstStep);
          theme.NonProfitUtils.handleDonationsAsFirstStep();
        }

        if (IS_NON_PROFIT_SWEEP && variant) {
          theme.NonProfitUtils.handleVariant(variant);
        }
      } else {
        theme.SweepstakeUtils.handleLanderRedirection(
          SWEEPSTAKE_LANDER_URL,
          handle
        );
        theme.SweepstakeUtils.clearIsAfterDonationFlag();
        theme.EcommerceVariantsUtils.clearIsAfterEcommerceFlag();
        theme.EcommerceVariantsUtils.hideNonProfitFormContainer();
        theme.EcommerceVideoUtils.clearIsAfterEcommerceVideoFlag();
      }
    };

    const hooks = {
      beforeSubmit: (formSubmission, next) => {
        const $recaptchav2Resp = $("#g-recaptcha-response");
        if ($recaptchav2Resp.length && !$recaptchav2Resp.val()) {
          return next([
            {
              type: validationCheck.FORMIO_CUSTOM_ERROR,
              message: "Please, verify you're not a robot to continue.",
            },
          ]);
        }
        if (window.FKL.hasPageDonations) {
          theme.NonProfitUtils.showDonationVariantsInLander();
        }
        if (!SWEEP_RE_ENTRY_ACTIVE) {
          next();
          return;
        }
        this.getPreviousSubmission(formSubmission.data.email)
          .then((serverSubmission) => {
            if (!serverSubmission) {
              return Promise.reject({
                code: validationCheck.PASS,
              });
            }
            const lastSubmissionDate = new Date(
              serverSubmission.modified
            ).getTime();
            const now = new Date();
            const minDateToReEntry = new Date(
              now.getTime() - Math.round(HOURS_BETWEEN_ENTRIES * 60 * 60 * 1000)
            );
            if (lastSubmissionDate < minDateToReEntry) {
              return Promise.resolve(serverSubmission);
            } else {
              const hoursDifference =
                (lastSubmissionDate - minDateToReEntry) / 1000 / 60 / 60;
              const message = `You've already opted-in. Please come back in
              ${
                hoursDifference < 1
                  ? Math.round(hoursDifference * 60)
                  : Math.floor(hoursDifference)
              }
              ${
                hoursDifference < 1
                  ? "minutes"
                  : `hours and ${Math.round(
                      (hoursDifference - Math.floor(hoursDifference)) * 60
                    )} minutes`
              }`;
              return Promise.reject({
                code: validationCheck.ERROR_RE_ENTRY_HOURS,
                message,
              });
            }
          })
          .then((submission) => {
            const formUrl = this.getFormPathURL();
            const updatedSubmission = {
              ...submission,
              data: {
                ...submission.data,
                submissionCount: (submission.data.submissionCount || 0) + 1,
                ...(window.FKL.singleBrandSweepSponsor && {
                  smsSelectedCompanies: window.FKL.singleBrandSweepSponsor,
                }),
              },
            };
            const submissionPayload =
              theme.SweepstakeUtils.includeLanderAcceptedCpls(
                window.FKL.cplLanderSponsors,
                updatedSubmission
              );
            return theme.ShopifyFormioProxy.updateFormioSubmission(
              formUrl,
              submissionPayload
            );
          })
          .then((submission) => {
            return theme.RecaptchaUtils.updateSubmissionToken(submission);
          })
          .then(async (submission) => {
            this.storeSubmission(submission);
            this.sendEventToLytics(handle, submission);
            this.onSubmissionSendEventToPixel(
              submission.data.email,
              submission.data.zipCode,
              handle
            );
            this.storeSubmissionHash(submission);
            this.storeSubmissionCplExtraEntriesHash(submission);
            if (window.FKL.cplLanderSponsors?.length > 0) {
              await theme.SweepstakeUtils.handleLanderPostOptin(
                window.FKL.cplLanderSponsors,
                submission.data.email,
                this.getFormPathURL()
              );
            }
            next();
          })
          .catch((err) => {
            if (
              err &&
              (err.code === validationCheck.ERROR_RE_ENTRY_HOURS ||
                err.code === validationCheck.ERROR_MAX_ENTRIES_REACHED)
            ) {
              next([
                {
                  message: err.message,
                  type: validationCheck.FORMIO_CUSTOM_ERROR,
                },
              ]);
            } else if (err && err.code === validationCheck.PASS) {
              next();
            } else {
              console.error(err);
              alert("Service Error");
            }
          });
      },
    };

    if (window.Formio) {
      createForm(selectors.formSweepstake, {
        noAlerts: true,
        hooks,
      }).then((form) => {
        const spanTerms = $(selectors.formSweepstake)
          .find("input[type=\"checkbox\"][name=\"data[termsCond]\"]")
          .next();

        if (window.FKL.singleBrandSweepSponsor) {
          const pSmsTermsAndPolicy = $(selectors.formSweepstake).find(
            ".formio-component-htmlByEntering p:first"
          );
          pSmsTermsAndPolicy.remove();

          spanTerms.html(
            spanTerms.addClass("small").html().replace(
              "I agree to the Terms and Conditions",
              `By checking this box you agree to receive 
                 recurring automated promotional and 
                 personalized marketing text messages 
                 (e.g. cart reminders) from 
                 ${window.FKL.singleBrandSweepSponsor} at 
                 the cell number used when signing up.
                 Consent is not a condition of any purchase. 
                 Reply HELP for help and STOP to cancel.
                 Msg frequency varies. Msg & data rates may apply. View
                 <a href="${window.FKL.singleBrandSweepSmsTerms}" 
                 target="_blank">Terms</a>, 
                 <a href="${window.FKL.singleBrandSweepSmsPrivacyPolicy}" 
                 target="_blank">Privacy</a>, 
                 and <a href="${termsUrl}" target="_blank">Giveaway Terms</a>.`
            )
          );
        } else {
          spanTerms.html(
            spanTerms
              .addClass("sweep-form--terms")
              .html()
              .replace(
                "I agree to the Terms and Conditions",
                window.FKL.cplLanderSponsors?.length > 0
                  ? cplLanderTerms
                  : `${
                      IS_NON_PROFIT_SWEEP
                        ? `By entering, I agree to receive email 
                communications from FindKeep.Love ${beneficiaryTerms} and 
                all participating brands. `
                        : ""
                    }I agree to the ${
                      window.FKL.arcade_tac_on_sweep_forms &&
                      !document.querySelector(".sweepstake-thank-arcade__body")
                        ? `<a href="${termsUrl}" target="_blank">
                  Terms & Conditions of this sweepstake</a>
                  and the <a href="${window.FKL.arcade_tac_url}" 
                  target="_blank">FindKeep.Love Arcade</a>.`
                        : `<a href="${termsUrl}" target="_blank">
                  Terms and Conditions</a>.`
                    }`
              )
          );
        }

        // Prevent the submission from going to the form.io server.
        form.nosubmit = true;

        form.submission = {
          data: {
            email: theme.customer.email,
            submissionCount: 1,
            quizExtraEntries: 0,
            smsExtraEntries: 0,
            termsCond: true,
            ...(window.FKL.singleBrandSweepSponsor && {
              smsSelectedCompanies: window.FKL.singleBrandSweepSponsor,
              smsTermsAndConditions: true,
            }),
            ...lastOptInData,
          },
        };

        form.on("initialized", function () {
          fillRecaptcha(form);
          fillIPAddress(form);
          handleEmailLowerCase(form);
          removeHiddenFields();
        });

        form.on("submit", (submission) => {
          const formUrl = this.getFormPathURL();
          const submissionPayload =
            theme.SweepstakeUtils.includeLanderAcceptedCpls(
              window.FKL.cplLanderSponsors,
              submission,
              window.FKL.cplInfluencerSponsor
            );
          theme.ShopifyFormioProxy.submitFormioSweepSubmission(
            formUrl,
            submissionPayload
          )
            .then(async (submission) => {
              this.storeSubmission(submission);
              this.sendUserDataToLytics(submission);
              this.sendEventToLytics(handle, submission);
              this.onSubmissionSendEventToPixel(
                submission.data.email,
                submission.data.zipCode,
                handle
              );
              this.storeSubmissionHash(submission);
              this.storeSubmissionCplExtraEntriesHash(submission);
              if (
                window.FKL.cplLanderSponsors?.length > 0 ||
                window.FKL.cplInfluencerSponsor
              ) {
                await theme.SweepstakeUtils.handleLanderPostOptin(
                  window.FKL.cplLanderSponsors,
                  submission.data.email,
                  this.getFormPathURL(),
                  window.FKL.cplInfluencerSponsor
                );
              }
              form.emit("submitDone", submission);
            })
            .catch((error) => {
              if (error.details) {
                form.emit("error", error.details);
              } else {
                console.error(error);
                alert("Service Error");
              }
            });
        });

        form.on("submitDone", () => {
          theme.SweepstakeUtils.handleLanderRedirection(
            SWEEPSTAKE_LANDER_URL,
            handle
          );
        });

        form.on("error", (event) => {
          console.log("Error: ", event);
          if (event.length === 1) {
            const error = event[0];
            if (
              (error.type === "any.unique" ||
                (error.context && error.context.validator === "unique")) &&
              error.path[0] === "email"
            ) {
              if (SWEEP_RE_ENTRY_ACTIVE) {
                $(".formio-component-email").removeClass(
                  "formio-error-wrapper"
                );
                $(".formio-component-email").find(".formio-errors").hide();
                theme.SweepstakeUtils.handleLanderRedirection(
                  SWEEPSTAKE_LANDER_URL,
                  handle
                );
              } else {
                $(".formio-component-email")
                  .find(".formio-errors")
                  .text("Sorry, you can only enter this sweeps once");
                theme.NonProfitUtils.handleNonProfitSubmissionError();
              }
            } else if (error.type === validationCheck.FORMIO_CUSTOM_ERROR) {
              $(".formio-component-email").addClass("formio-error-wrapper");
              $(".formio-component-email")
                .find(".formio-errors")
                .html(error.message)
                .show();
              theme.NonProfitUtils.handleNonProfitSubmissionError();
            }
          }
        });
      });
    }

    init();
  }

  Sweepstake.prototype = _.assignIn({}, Sweepstake.prototype, {
    clearSubmission: function () {
      theme.Utils.clearInSessionStorage(SWEEPSTAKE_SUBMISSION);
      theme.Utils.clearInSessionStorage(SWEEPSTAKE_SESSION_ENTRIES);
      theme.Utils.clearInSessionStorage(ARCADE_CURRENT_GAME);
      theme.Utils.clearInSessionStorage(SWEEPSTAKE_LANDER_URL);
      theme.NonProfitUtils.clearNonProfitEndpointURL();
    },

    storeSubmission: function (submission) {
      theme.Utils.saveInSessionStorage(SWEEPSTAKE_SUBMISSION, submission);
      theme.Utils.getHash(submission.data.email).then((hashEmail) => {
        // Save userId for GTM
        window.FKL.userId = hashEmail;
      });
    },

    sendUserDataToLytics: function (submission) {
      const userEmail = submission.data.email;
      theme.LyticsService.userDataTracker(userEmail);
    },

    sendEventToLytics: function (sweepName, submission) {
      theme.LyticsService.sweepOptinEventTracker(sweepName, submission);
    },

    onSubmissionSendEventToPixel: function (userEmail, userZipCode, sweepName) {
      try {
        window.fbq("track", "CompleteRegistration");
        window.snaptr("init", window.FKL.snap_pixel_id, {
          user_email: userEmail,
          geo_postal_code: userZipCode,
        });
        window.snaptr("track", "SIGN_UP");

        window.ttq.identify({
          email: userEmail,
        });
        
        window.ttq.track("CompleteRegistration", {
          contents: [
            {
              content_id: sweepName,
              content_type: "non-profit-sweepstake",
              content_name: sweepName
            }
          ],
        });
        window.twq("event", `tw-${window.FKL.x_pixel_id}-${window.FKL.x_lead_event_id}`, {
          contents: [
            {
              content_type: "non-profit-sweepstake",
              content_id: sweepName,
              content_name: sweepName,
              content_price: null,
              num_items: null,
              content_group_id: null,
            }],
          email_address: userEmail,
        });

      } catch (error) {
        console.error(error);
      }
    },

    storeSubmissionHash: function (submission) {
      theme.Utils.getHash(JSON.stringify(submission.data)).then((hash) =>
        theme.Utils.saveInSessionStorage(INITIAL_SUBMISSION, hash)
      );
    },

    storeSubmissionCplExtraEntriesHash: function (submission) {
      const { _id, created, data } = submission;
      const cplExtraEntriesObj = {
        _id,
        created,
        submissionCount: data?.submissionCount ?? 1,
        cplExtraEntries: data?.cplExtraEntries ?? 0,
      };
      theme.Utils.getHash(JSON.stringify(cplExtraEntriesObj)).then((hash) =>
        theme.Utils.saveInSessionStorage(CPL_EXTRA_ENTRIES_HASH, hash)
      );
    },

    retrieveSubmission: function () {
      const submission = theme.Utils.retrieveFromSessionStorage(
        SWEEPSTAKE_SUBMISSION
      );
      submission &&
        theme.Utils.getHash(submission.data.email).then((hashEmail) => {
          // Save userId for GTM
          window.FKL.userId = hashEmail;
        });
      return submission;
    },

    checkHash: function () {
      const submission = theme.Sweepstake.prototype.retrieveSubmission();
      return submission
        ? theme.Utils.getHash(JSON.stringify(submission.data)).then((hash) => {
            const initialSubmissionHash =
              theme.Utils.retrieveFromSessionStorage(
                "initialSubmission"
              );
            if (hash !== initialSubmissionHash) {
              return Promise.reject(this.hashChecks.NO_MATCH);
            }
            return Promise.resolve();
          })
        : Promise.reject(this.hashChecks.NO_SUBMISSION);
    },

    checkCplExtraEntriesHash: function () {
      const submission = theme.Sweepstake.prototype.retrieveSubmission();
      if (submission) {
        const { _id, created, data } = submission;
        const cplExtraEntriesObj = {
          _id,
          created,
          submissionCount: data?.submissionCount ?? 1,
          cplExtraEntries: data?.cplExtraEntries ?? 0,
        };
        return theme.Utils.getHash(JSON.stringify(cplExtraEntriesObj)).then(
          (hash) => {
            const cplExtraEntriesHash = theme.Utils.retrieveFromSessionStorage(
              CPL_EXTRA_ENTRIES_HASH
            );
            if (hash !== cplExtraEntriesHash) {
              return Promise.reject(this.hashChecks.NO_MATCH);
            }
            return Promise.resolve();
          }
        );
      } else {
        return Promise.reject(this.hashChecks.NO_SUBMISSION);
      }
    },

    getPreviousSubmission: function (email) {
      const PROXY_PATH = `${window.FKL.yentaServicesApiUrl}/proxy`;
      const formPath = this.getFormPathURL();
      const url = `${PROXY_PATH}${formPath}?email=${encodeURIComponent(
        theme.Utils.escapeRegExp(email)
      )}`;
      return fetch(url)
        .then((resp) => resp.json())
        .then((submissions) => {
          if (submissions.length === 1) {
            const submission = {
              ...submissions[0],
              data: {
                ...submissions[0].data,
                email: submissions[0].data.email.toLocaleLowerCase(),
              },
            };
            this.storeSubmission(submission);
            return submission;
          }

          if (
            submissions.message &&
            submissions.message.includes("Max number of extra entries reached")
          ) {
            return Promise.reject({
              code: validationCheck.ERROR_MAX_ENTRIES_REACHED,
              message: `You’ve reached the maximum number of entries for
              this giveaway. Check out other giveaways with amazing prizes
              <a href="https://www.findkeep.love/collections/all"
              style="color: inherit;">here</a>!`,
            });
          }

          return null;
        });
    },

    getFormPathURL: function () {
      return document
        .querySelector(selectors.formSweepstake)
        .getAttribute(selectors.formPathAttr);
    },

    hashChecks: {
      NO_MATCH: "NO-MATCH",
      NO_SUBMISSION: "NO-SUBMISSION",
    },
  });

  return Sweepstake;
})();

theme.Sweepstake = Sweepstake;

const landerSelectors = {
  landerFormContainer: ".sweep-cosponsors_product-form-container",
  nonProfitLanderFormContainer: ".non-profit-sweep_product-form-container",
  donationVariantsContainer: ".non-profit-sweep_product-variants-container",
  landerCplQuizContainer: "#cpl-quiz",
  landerDemographicsQuizContainer: ".sweepstake-lander-quiz-container",
  hideElementClass: "hide",
  adsBottomContainer: "#lander-cpl-quiz-ads--bottom",
};

class LanderCplQuizUtils {
  /**
   * Mount CPL quiz widget in lander
   */
  static mountLanderCplQuizWidget() {
    window.FKL.renderWidget(
      "LanderCplQuiz",
      document.getElementById("lander-cpl-quiz-widget-container")
    );
  }

  /**
   * Show CPL quiz in lander
   */
  static showLanderCplQuiz(isNonProfitSweepLander = false) {
    const landerContainerToHide = document.querySelector(
      isNonProfitSweepLander
        ? landerSelectors.donationVariantsContainer
        : landerSelectors.landerFormContainer
    );
    const landerDemographicsContainerToHide = document.querySelector(
      landerSelectors.landerDemographicsQuizContainer
    );
    const landerCplQuizContainer = document.querySelector(
      landerSelectors.landerCplQuizContainer
    );
    const nonProfitLanderFormContainer = document.querySelector(
      landerSelectors.nonProfitLanderFormContainer
    );

    if (landerContainerToHide != null)
      landerContainerToHide.classList.add(landerSelectors.hideElementClass);
    if (nonProfitLanderFormContainer != null)
      nonProfitLanderFormContainer.classList.add(
        landerSelectors.hideElementClass
      );
    if (landerDemographicsContainerToHide != null)
      landerDemographicsContainerToHide.classList.add(
        landerSelectors.hideElementClass
      );
    if (landerCplQuizContainer != null)
      landerCplQuizContainer.classList.remove(landerSelectors.hideElementClass);
  }

  /**
   * Handle the sweep flow for the lander quizzes
   */
  static handleLanderQuizFlow() {
    if (window.FKL.hasPageDonations) {
      window.theme.NonProfitUtils.handleNextFlowStep(true);
      return;
    }
    window.theme.SweepstakeUtils.handleLanderRedirection(
      window.FKL.widgetsweepLanderUrl,
      window.FKL.widgetproductHandle
    );
  }

  /**
   * Handle the redirection to the Video Ads Quiz
   */
  static handleLanderCplQuizNextSweepStep() {
    window.FKL.afterLanderCplQuiz = true;
    const bottomAdsContainer = document.querySelector(
      landerSelectors.adsBottomContainer
    );
    if (bottomAdsContainer)
      bottomAdsContainer.classList.add(landerSelectors.hideElementClass);
    this.handleLanderQuizFlow();
  }

  /**
   * Handle the next sweep step after the CPL Quiz
   */
  static handleVideoAdsQuizNextSweepStep() {
    window.FKL.skipLanderCplQuiz = true;
    this.handleLanderQuizFlow();
  }
}

theme.LanderCplQuizUtils = LanderCplQuizUtils;

const DEMOGRAPHIC_QUIZ_COMPLETED = "demographicQuizCompleted";
const landerQuizSelectors = {
  landerFormContainer: ".sweep-cosponsors_product-form-container",
  nonProfitLanderFormContainer: ".non-profit-sweep_product-form-container",
  donationVariantsContainer: ".non-profit-sweep_product-variants-container",
  landerQuizContainer: ".sweepstake-lander-quiz-container",
  hideElementClass: "hide",
};

class LanderQuizUtils {
  /**
   * Show demographic quiz in lander
   */
  static showLanderQuiz(isNonProfitSweepLander = false) {
    const landerContainerToHide = document.querySelector(
      isNonProfitSweepLander
        ? landerQuizSelectors.donationVariantsContainer
        : landerQuizSelectors.landerFormContainer
    );
    const landerQuizContainer = document.querySelector(
      landerQuizSelectors.landerQuizContainer
    );
    const nonProfitLanderFormContainer = document.querySelector(
      landerQuizSelectors.nonProfitLanderFormContainer
    );

    if (landerContainerToHide != null)
      landerContainerToHide.classList.add(landerQuizSelectors.hideElementClass);
    if (landerQuizContainer != null)
      landerQuizContainer.classList.remove(
        landerQuizSelectors.hideElementClass
      );
    if (nonProfitLanderFormContainer != null)
      nonProfitLanderFormContainer.classList.add(
        landerQuizSelectors.hideElementClass
      );
  }

  /**
   * Mount demographic quiz widget in lander
   */
  static mountLanderQuizWidget() {
    window.FKL.renderWidget(
      "LanderQuiz",
      document.getElementById("lander-quiz-widget-container")
    );
  }

  /**
   * Handle next sweep flow step
   */
  static handleNextSweepFlowStep() {
    window.FKL.landerQuizAnsweredOrSkipped = true;
    if (window.FKL.hasPageDonations) {
      window.theme.NonProfitUtils.handleNextFlowStep(true);
      return;
    }
    window.theme.SweepstakeUtils.handleLanderRedirection(
      window.FKL.widgetsweepLanderUrl,
      window.FKL.widgetproductHandle
    );
  }

  /**
   * Save demographic quiz completion in session storage
   */
  static saveDemographicQuizCompletionInSession() {
    theme.Utils.saveInSessionStorage(DEMOGRAPHIC_QUIZ_COMPLETED, true);
  }

  /**
   * Checks if the demographic quiz has been completed
   */
  static isDemographicQuizCompletedInSession() {
    return theme.Utils.retrieveFromSessionStorage(DEMOGRAPHIC_QUIZ_COMPLETED);
  }
}

theme.LanderQuizUtils = LanderQuizUtils;

const SNHU_COMPLETED = "snhuCompleted";
const snhuSelectors = {
  container: "#snhu",
  hide: "hide",
  donationVariantsContainer: ".non-profit-sweep_product-variants-container",
};

class SnhuUtils {
  static show() {
    const container = document.querySelector(snhuSelectors.container);

    const donationVariantsContainer = document.querySelector(
      snhuSelectors.donationVariantsContainer
    );

    if (container != null) container.classList.remove(snhuSelectors.hide);

    if (donationVariantsContainer != null)
      donationVariantsContainer.classList.add(snhuSelectors.hide);
  }

  static hide() {
    const container = document.querySelector(snhuSelectors.container);
    if (container != null) container.classList.add(snhuSelectors.hide);
  }

  static mountWidget() {
    window.FKL.renderWidget(
      "Snhu",
      document.getElementById("snhu-widget-container")
    );
  }

  static skip() {
    window.FKL.skipSnhu = true;

    if (window.FKL.hasPageDonations) {
      this.hide();
      window.theme.NonProfitUtils.handleNextFlowStep(true);
      return;
    }
  }

  static saveCompletionInSession() {
    theme.Utils.saveInSessionStorage(SNHU_COMPLETED, true);
  }

  static isCompletedInSession() {
    return theme.Utils.retrieveFromSessionStorage(SNHU_COMPLETED);
  }
}

theme.SnhuUtils = SnhuUtils;

const IS_AFTER_DONATION = "isAfterDonation";
const sweepLanderSelectors = {
  landerSpinner: ".sweep-lander-spinner",
  landerPage: "[cpl-lander-sponsors-allowed=true]",
  regularLanderElementsSelector: ".regular_lander",
  cplLanderElementsSelector: ".cpls_lander",
  hiddenElementClass: "cpls_lander--hidden-element",
  mainSponsorsLogosContainerDesktop: ".sweepstake-sponsors--logos-desktop",
  sponsorsLogosContainerDesktop: ".sweepstake-cpl-sponsors--logos-desktop",
  sponsorsLogosContainerMobile: ".sweepstake-cpl-sponsors--logos-mobile",
  sweepDescriptionContainer: ".sweepstake-details_description",
  cplSponsorListContainerSelector: ".sweepstakes-cpl-sponsors-container",
  sweepHeaderSelector: ".sweepstake-details_header",
  cplLanderElementsClass: "cpls_lander",
  sweepFormTermsSelector: ".sweep-form--terms",
  sweepBlackBannerSelector: ".sweep_header",
  arcadeModalChooseGame: "#arcadeModalChooseGame",
  showModalClass: "show-modal",
};

class SweepstakeUtils {
  /**
   * Hide spinner and show sweep lander
   */
  static hideSpinnerShowLander() {
    const landerSpinnerElement = document.querySelector(
      sweepLanderSelectors.landerSpinner
    );
    const landerPageElement = document.querySelector(
      sweepLanderSelectors.landerPage
    );
    if (landerSpinnerElement != null)
      landerSpinnerElement.style.display = "none";
    if (landerPageElement != null) landerPageElement.style.display = "block";
  }

  /**
   * Apply DOM changes in the CPL lander
   *
   * @argument {Array<Cpl>} sponsorsCpls
   * @argument {Cpl} cplInfluencerSponsor
   * @argument {String} cplLanderTerms
   */
  static handleLanderDOMChanges(
    sponsorsCpls,
    cplInfluencerSponsor,
    cplLanderTerms
  ) {
    document
      .querySelectorAll(sweepLanderSelectors.regularLanderElementsSelector)
      .forEach((regularLanderElement) => {
        regularLanderElement.style.display = "none";
      });
    document
      .querySelectorAll(sweepLanderSelectors.cplLanderElementsSelector)
      .forEach((regularLanderElement) => {
        regularLanderElement.classList.remove(
          sweepLanderSelectors.hiddenElementClass
        );
      });
    document
      .querySelector(sweepLanderSelectors.sweepDescriptionContainer)
      .classList.add(sweepLanderSelectors.cplLanderElementsClass);
    document
      .querySelector(sweepLanderSelectors.sweepHeaderSelector)
      .classList.add(sweepLanderSelectors.cplLanderElementsClass);
    document
      .querySelector(sweepLanderSelectors.sweepBlackBannerSelector)
      .classList.add(sweepLanderSelectors.cplLanderElementsClass);

    this.addLanderSponsorsLogos(sponsorsCpls, cplInfluencerSponsor);
    if (sponsorsCpls) {
      this.addCplLanderSponsorsList(sponsorsCpls);
      this.updateFormTerms(cplLanderTerms);
    }
  }

  /**
   * Add sponsors logos
   *
   * @argument {Array<Cpl>} sponsorsCpls
   */
  static addLanderSponsorsLogos(sponsorsCpls, cplInfluencerSponsor = null) {
    if (cplInfluencerSponsor) {
      const mainLogosContainerDesktop = document.querySelector(
        sweepLanderSelectors.mainSponsorsLogosContainerDesktop
      );
      const influencerSponsorLogoTag = this.getLanderSponsorsLogos([
        cplInfluencerSponsor,
      ]);
      const mainDesktopSponsorsLogos = mainLogosContainerDesktop.innerHTML;

      mainLogosContainerDesktop.innerHTML = `${mainDesktopSponsorsLogos}
      ${influencerSponsorLogoTag}`;
    }

    const logosContainerDesktop = document.querySelector(
      sweepLanderSelectors.sponsorsLogosContainerDesktop
    );
    const logosContainerMobile = document.querySelector(
      sweepLanderSelectors.sponsorsLogosContainerMobile
    );

    const sponsorsLogosTagsDesktop = this.getLanderSponsorsLogos(
      sponsorsCpls || []
    );
    const sponsorsLogosTagsMobile = this.getLanderSponsorsLogos([
      cplInfluencerSponsor,
      ...(sponsorsCpls || []),
    ]);

    logosContainerDesktop.innerHTML = sponsorsLogosTagsDesktop;
    logosContainerMobile.innerHTML = `${logosContainerMobile.innerHTML}
    ${sponsorsLogosTagsMobile}`;
  }

  /**
   * Add CPL sponsors list
   *
   * @argument {Array<T>} sponsorsCpls
   */
  static addCplLanderSponsorsList(sponsorsCpls) {
    const cplSponsorListContainer = document.querySelector(
      sweepLanderSelectors.cplSponsorListContainerSelector
    );

    if (cplSponsorListContainer === null) return;

    const cplSponsorsList = this.getCplLanderSponsorsList(sponsorsCpls);

    cplSponsorListContainer.innerHTML = cplSponsorsList;
  }

  /**
   * Update form terms and conditions
   *
   * @argument {String} cplLanderTerms
   */
  static updateFormTerms(cplLanderTerms) {
    const sweepFormTerms = document.querySelector(
      sweepLanderSelectors.sweepFormTermsSelector
    );

    if (sweepFormTerms != null) sweepFormTerms.innerHTML = cplLanderTerms;
  }

  /**
   * Get sponsors logos
   *
   * @argument {Array<T>} sponsorsCpls
   */
  static getLanderSponsorsLogos(sponsorsCpls) {
    return sponsorsCpls
      .filter((cpl) => !!cpl)
      .reduce(
        (acc, cpl) =>
          acc +
          `<div class="sweepstake-cpl-sponsor--logo-container">
        <img class="sweepstake-cpl-sponsor--logo"
        src="${cpl.logoUrl}" alt="${cpl.name || ""} logo">
        </div>`,
        ""
      );
  }

  /**
   * Get CPLs sponsors list
   *
   * @argument {Array<T>} sponsorsCpls
   */
  static getCplLanderSponsorsList(sponsorsCpls) {
    const MIN_DESKTOP_AD_UNIT_VERSION = 3;
    const MAX_DESKTOP_AD_UNIT_VERSION = 5;
    let desktopAdUnitVersion = MIN_DESKTOP_AD_UNIT_VERSION;
    
    const MOBILE_AD_UNIT_FST_VERSION = 2;
    const MOBILE_AD_UNIT_SND_VERSION = 3;
    
    return sponsorsCpls.reduce((acc, cpl, index, cplsList) => {
      const cplGrid = this.generateCplGrid(cpl);
      let result = acc + cplGrid;
      const isNotLastCpl = index < cplsList.length - 1;
      
      if (isNotLastCpl) {

        // Desktop ad units: after every two sponsors
        const isEvenIndex = (index + 1) % 2 === 0;
        if (isEvenIndex) {
          result += this.generateDesktopAdUnitHtml(desktopAdUnitVersion);
          desktopAdUnitVersion = 
            desktopAdUnitVersion === MAX_DESKTOP_AD_UNIT_VERSION 
              ? MIN_DESKTOP_AD_UNIT_VERSION
              : desktopAdUnitVersion + 1;
        }

        // Mobile ad units: FST after 2nd, 7th, 12th... SND after 5th, 10th, 15th...
        if ((index - 1) % 5 === 0) {
          result += this.generateMobileAdUnitHtml(MOBILE_AD_UNIT_FST_VERSION);
        } else if ((index + 1) % 5 === 0) {
          result += this.generateMobileAdUnitHtml(MOBILE_AD_UNIT_SND_VERSION);
        }
      }

      return result;
    }, "");
  }
  
  /**
   * Generates Grid for a single CPL
   * 
   * @param {Object} cpl - CPL object
   * @returns {string} HTML string for the CPL
   */
  static generateCplGrid(cpl) {
    return `<div class="grid sweep-cpl-sponsor grid--no-gutters">
      <div class="grid__item small--one-whole 
          medium-up--one-half sweep-cpl-sponsor-image">
        <img class="grid-view-item__image" 
          src="${cpl.imageUrl}" 
          alt="${cpl.name || ""}">
      </div>
      <div class="grid__item small--one-whole 
          medium-up--one-half sweep-cpl-sponsor-info">
        <div class="sweep-cpl-sponsor-info-container">
          <img class="logo" 
            src="${cpl.logoUrl}" 
            alt="${cpl.name} logo">
          <div class="description">
            <p>${cpl.description || ""}</p>
          </div>
        </div>
      </div>
    </div>`;
  }
  
  /**
   * Generates HTML for a desktop ad unit
   * 
   * @param {number} version - Ad unit version number
   * @returns {string} HTML string for the desktop ad unit
   */
  static generateDesktopAdUnitHtml(version) {
    return `
    <div class="hidden-on-mobile">
      <div data-aaad='true' 
        data-aa-adunit='/22181265/fkl_728v_${version}'></div>
    </div>
    `;
  }
  
  /**
   * Generates HTML for a mobile ad unit
   * 
   * @param {number} version - Ad unit version number
   * @returns {string} HTML string for the mobile ad unit
   */
  static generateMobileAdUnitHtml(version) {
    return `
    <div class="hidden-on-desktop">
      <div data-aaad='true' 
        data-aa-adunit='/22181265/fkl_MOB_300v_${version}'></div>
    </div>
    `;
  }

  /**
   * Opt-in to lander sponsors forms
   *
   * @argument {Array<T>} sponsorsCpls
   * @argument {string} userEmail
   */
  static async optInToSponsorsForms(sponsorsCpls, userEmail) {
    if (sponsorsCpls) {
      const CPL_OPT_IN_GA_ACTION = "Lander Opt-in";
      const hashEmail = await window.theme.Utils.getHash(userEmail);
      theme.GAService.setUserDataTracker(hashEmail);

      const fixedCpls = sponsorsCpls.filter(
        (cpl) => cpl.formPath && cpl.formPath != ""
      );

      fixedCpls.forEach((cpl) => {
        const baseURL = window.theme.QuizUtils.getBaseURLForCPLForm(
          cpl.formPath
        );
        const formio = new window.Formio(`${baseURL}/${cpl.formPath}`);
        formio
          .saveSubmission({
            data: {
              email: userEmail,
              agreeToTerms: true,
              optinOrigin: "Sweep Lander",
            },
          })
          .catch((err) => {
            console.error(err);
          });
        window.theme.GAService.landerCplEventTracker(
          CPL_OPT_IN_GA_ACTION,
          cpl.name,
          cpl.bid || 0
        );
        window.theme.LyticsService.acceptedCplEventTracker(
          cpl.name,
          userEmail
        ).catch((err) => {
          console.error(err);
        });
      });
    }
  }

  /**
   * Includes lander accepted CPLs in the sweep submission
   *
   * @argument {Array<T>} sponsorsCpls
   * @argument {Submission} submission
   * @argument {CPL?} cplInfluencerSponsor
   */
  static includeLanderAcceptedCpls(
    sponsorsCpls,
    submission,
    cplInfluencerSponsor = null
  ) {
    if (sponsorsCpls) {
      const previousLanderAcceptedCpls =
        submission.data?.landerAcceptedCpls || "";
      const landerAcceptedCpls = [
        ...new Set(
          previousLanderAcceptedCpls
            .split(",")
            .concat(
              [cplInfluencerSponsor, ...(sponsorsCpls ? sponsorsCpls : [])]
                .filter((cpl) => !!cpl && !!cpl.name)
                .map((cpl) => cpl.name)
            )
            .filter((cplName) => cplName !== "")
        ),
      ].join(",");

      return {
        ...submission,
        data: {
          ...submission.data,
          landerAcceptedCpls,
        },
      };
    }
    return submission;
  }

  /**
   * Handle Sponsor Impressions Events
   *
   * @argument {Array<Cpl>} sponsorsCpls
   * @argument {Cpl} cplInfluencerSponsor
   */
  static handleSponsorsImpressions(sponsorsCpls, cplInfluencerSponsor) {
    const CPL_OPT_IN_GA_ACTION = "Lander Impression";
    const impressionSponsors = [cplInfluencerSponsor, ...(sponsorsCpls || [])];
    theme.GAService.enableDataTracker();
    impressionSponsors
      .filter((cpl) => !!cpl && cpl.formPath && cpl.formPath != "")
      .forEach((cpl) => {
        window.theme.LyticsService.viewedCplEventTracker(cpl.name);
        window.theme.GAService.landerCplEventTracker(
          CPL_OPT_IN_GA_ACTION,
          cpl.name,
          cpl.bid || 0
        );
      });
  }

  /**
   * Handle lander post-optin logic
   *
   * @argument {Array<CPL>} sponsorsCpls
   * @argument {string} userEmail
   * @argument {string} sweepFormPath
   * @argument {CPL?} cplInfluencerSponsor
   */
  static async handleLanderPostOptin(
    sponsorsCpls,
    userEmail,
    sweepFormPath,
    cplInfluencerSponsor = null
  ) {
    try {
      const sponsorsToOptin = [
        cplInfluencerSponsor,
        ...(sponsorsCpls || []),
      ].filter((cpl) => !!cpl);
      await this.optInToSponsorsForms(sponsorsToOptin, userEmail);
      if (sponsorsCpls?.length > 0) {
        theme.LyticsService.sweepCplLanderEventTracker(
          sponsorsCpls,
          userEmail,
          sweepFormPath
        );
        await theme.YentaApi.notifyCplLanderOptin(
          sponsorsCpls,
          sweepFormPath,
          userEmail
        );
      }
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * Retrieve the isAfterDonation flag from the session storage
   */
  static getIsAfterDonationFlag() {
    return sessionStorage.getItem(IS_AFTER_DONATION);
  }

  /**
   * Clears the isAfterDonation flag from the session storage
   */
  static clearIsAfterDonationFlag() {
    theme.Utils.clearInSessionStorage(IS_AFTER_DONATION);
  }

  /**
   * Handle lander redirection
   *
   * @argument {string} sweepLanderUrl
   * @argument {string} productHandle
   */
  static handleLanderRedirection(sweepLanderUrl, productHandle) {
    const submission = theme.Sweepstake.prototype.retrieveSubmission();
    const landerProductMetadata = window.FKL.productMetadata;
    const IS_ARCADE = landerProductMetadata
      ? landerProductMetadata.arcade &&
        landerProductMetadata.arcade.toLowerCase() === "true"
      : false;
    const isAfterDonation = this.getIsAfterDonationFlag();
    const isAfterEcommerce =
      theme.EcommerceVariantsUtils.getIsAfterEcommerceFlag();
    const isAfterEcommerceVideo =
      theme.EcommerceVideoUtils.getIsAfterEcommerceVideoFlag();
    if (submission) {
      if (
        window.FKL.hasPageDonations &&
        !isAfterDonation &&
        !isAfterEcommerce &&
        !isAfterEcommerceVideo
      ) {
        theme.NonProfitUtils.handleDonationVariantsInLanderPostOptin();
      } else if (
        window.FKL.hasPageDonations &&
        !window.FKL.skipEcommerceVideo &&
        !isAfterEcommerce &&
        !isAfterEcommerceVideo
      ) {
        theme.EcommerceVideoUtils.mountWidget();
        theme.EcommerceVideoUtils.show();
      } else if (
        window.FKL.hasPageDonations &&
        !window.FKL.skipEcommerceVariants &&
        !isAfterEcommerce
      ) {
        theme.EcommerceVariantsUtils.showEcommerceVariantsInLander();
      } else if (
        window.FKL.hasPageDonations &&
        !window.FKL.skipFkc &&
        window.FKL.enable_fkc_widget
      ) {
        theme.FkcUtils.mountWidget();
        theme.FkcUtils.show();
      } else if (
        window.FKL.hasPageDonations &&
        !window.FKL.skipSnhu &&
        !theme.SnhuUtils.isCompletedInSession()
      ) {
        theme.SnhuUtils.mountWidget();
        theme.SnhuUtils.show();
      } else if (
        !window.FKL.landerQuizAnsweredOrSkipped &&
        !theme.LanderQuizUtils.isDemographicQuizCompletedInSession()
      ) {
        window.FKL.widgetsweepLanderUrl = sweepLanderUrl;
        window.FKL.widgetproductHandle = productHandle;
        theme.LanderQuizUtils.mountLanderQuizWidget();
        theme.LanderQuizUtils.showLanderQuiz();
      } else if (!window.FKL.skipLanderCplQuiz) {
        theme.LanderCplQuizUtils.mountLanderCplQuizWidget();
        theme.LanderCplQuizUtils.showLanderCplQuiz();
      } else if (
        IS_ARCADE &&
        document.querySelector(sweepLanderSelectors.arcadeModalChooseGame)
      ) {
        document
          .querySelector(sweepLanderSelectors.arcadeModalChooseGame)
          .classList.toggle(sweepLanderSelectors.showModalClass);
      } else {
        sessionStorage.setItem(sweepLanderUrl, window.location.href);
        window.location.href = theme.Routing.redirectToNextPage(
          landerProductMetadata,
          productHandle
        );
      }
      theme.Utils.clearInSessionStorage(IS_AFTER_DONATION);
    } else {
      console.error("Submission not found");
      alert("Service Error");
    }
  }
}

theme.SweepstakeUtils = SweepstakeUtils;

const SweepstakesCollectionPage = (() => {
  const selectors = {
    sweepstakesCollectionPageTabs: ".sweepstakes-collection-body-tabs-tab",
    sweepstakesCollectionPageTabsContainer:
      ".sweepstakes-collection-body-tab-container",
    sweepstakesCollectionPageSelectedtabClass: "selected-tab",
  };

  const bindTabsAction = () => {
    const pageTabs = document.querySelectorAll(
      selectors.sweepstakesCollectionPageTabs
    );
    const pageTabsContainer = document.querySelectorAll(
      selectors.sweepstakesCollectionPageTabsContainer
    );

    function displayTab(event, tabId) {
      pageTabs.forEach((pageTab) => {
        pageTab.classList.remove(
          selectors.sweepstakesCollectionPageSelectedtabClass
        );
      });
      pageTabsContainer.forEach((pageTabContainer) => {
        pageTabContainer.style.display = "none";
      });
      event.target.classList.add(
        selectors.sweepstakesCollectionPageSelectedtabClass
      );
      document.getElementById(tabId).style.display = "block";
    }

    pageTabs.forEach((pageTab) => {
      const tabContainerid = pageTab.getAttribute("data-tab-name");
      pageTab.addEventListener("click", (event) =>
        displayTab(event, tabContainerid)
      );
    });
  };

  function SweepstakesCollectionPage() {
    const init = () => {
      bindTabsAction();
    };

    init();
  }

  return SweepstakesCollectionPage;
})();

theme.SweepstakesCollectionPage = SweepstakesCollectionPage();

const SweepstakesPage = (() => {
  const selectors = {
    sweepstakesPageTabItem: ".all-sweepstakes--tabs-item",
    sweepstakesPageTabContent: ".regular-sweepstakes--giveaways-container",
    sweepstakesPageSelectedTab: "selected-tab",
  };

  const bindTabsAction = () => {
    const pageTabs = document.querySelectorAll(
      selectors.sweepstakesPageTabItem
    );

    const pageTabsContainer = document.querySelectorAll(
      selectors.sweepstakesPageTabContent
    );

    function displayTab(event, tabId) {
      pageTabs.forEach((pageTab) => {
        pageTab.classList.remove(selectors.sweepstakesPageSelectedTab);
      });

      pageTabsContainer.forEach((pageTabContainer) => {
        pageTabContainer.style.display = "none";
      });

      event.target.classList.add(selectors.sweepstakesPageSelectedTab);

      document.getElementById(tabId).style.display = "block";
    }

    pageTabs.forEach((pageTab) => {
      const tabContainerid = pageTab.getAttribute("data-tab-name");
      pageTab.addEventListener("click", (event) =>
        displayTab(event, tabContainerid)
      );
    });
  };

  function SweepstakesPage() {
    const init = () => {
      bindTabsAction();
    };

    init();
  }

  return SweepstakesPage;
})();

theme.SweepstakesPage = SweepstakesPage();

const ThankYouPage = () => {
  const SWEEP_TOTAL_ENTRIES = "sweepTotalEntries";

  function ThankYouPage() {
    const userSubmission = window.FKL.sweepstakeSubmission;
    const assetURL = window.FKL.assetWidgetUrl;

    const socialShareData = [
      {
        mobileClass: "",
        url: "fkl-facebook-icon.png",
        shareableLink: "//www.facebook.com/sharer.php?u=",
      },
      {
        mobileClass: "",
        url: "twitter-fkl.png",
        shareableLink: "//twitter.com/share?text=",
      },
      {
        mobileClass: "",
        url: "fkl-mail-icon.png",
        shareableLink: "mailto:?body=",
      },
      {
        mobileClass: "display--mobile",
        url: "fkl-snapchat-icon.png",
        shareableLink: "https://snapchat.com/scan?attachmentUrl=",
      },
      {
        mobileClass: "display--mobile",
        url: "fkl-whatsapp-icon.png",
        shareableLink: "whatsapp://send?text=",
      },
    ];

    const selectors = {
      formSweepstake: "#FormSweepstake",
      thankYouPageMainElement: ".sweepstake-thank",
      loadingArcadeSpinner: ".auto-arcade--spinner",
      hiddenHandle: "#SweepstakeHandle",
      thankYouBannerEntries: ".congrats-total-entries--number",
      thankYouPageBannerElement: ".thank-you-page__banner",
      thankYouEntriesTitle: ".congrats-entries--text",
    };

    const socialReferralSelectors = {
      copyLinkButton: ".social-referral-copy--button",
      linkCopiedMessage: ".social-referral--copied-message",
      socialReferralEntries: ".social-referral--entries",
      socialReferralLink: ".social-referral--output-link",
      socialShareIconsContainer: ".social-referral-social--icons-container",
    };

    function setEntries(entries) {
      const entriesElementSelector = selectors.thankYouBannerEntries;
      const entriesElement = document.querySelector(entriesElementSelector);
      entriesElement.innerHTML = entries;
      entries && sessionStorage.setItem(SWEEP_TOTAL_ENTRIES, entries);
      pluralizeEntries(entries);
    }

    function pluralizeEntries(entries) {
      if (entries > 1) {
        const thankYouEntriesTitleElement = document.querySelector(
          selectors.thankYouEntriesTitle
        );
        thankYouEntriesTitleElement.innerHTML = "entries";
      }
    }

    function copyToClipboard(socialReferralLink) {
      const copyLinkButtonElement = document.querySelector(
        socialReferralSelectors.copyLinkButton
      );
      const linkCopiedMessageElement = document.querySelector(
        socialReferralSelectors.linkCopiedMessage
      );

      copyLinkButtonElement.addEventListener("click", () => {
        navigator.clipboard.writeText(socialReferralLink);
        linkCopiedMessageElement.classList.add("show--message");
      });
    }

    function getTotalEntries() {
      if (userSubmission) {
        const {
          submissionCount = 1,
          quizExtraEntries = 0,
          smsExtraEntries = 0,
          cplExtraEntries = 0,
          referralExtraEntries = 0,
        } = userSubmission.data;
        return (
          submissionCount +
          quizExtraEntries +
          smsExtraEntries +
          cplExtraEntries +
          referralExtraEntries
        );
      }
      $(selectors.thankYouPageBannerElement).hide();
    }

    function handleUnavailableAutoArcade() {
      $(selectors.loadingArcadeSpinner).hide();
      $(selectors.thankYouPageMainElement).show();
      sessionStorage.removeItem(SWEEP_TOTAL_ENTRIES);
    }

    function handleAutoArcade() {
      if (userSubmission && userSubmission.data.email) {
        theme.Sweepstake.prototype
          .getPreviousSubmission(userSubmission.data.email)
          .then((submission) => {
            const formPathUrl = theme.Sweepstake.prototype.getFormPathURL();
            if (!submission) {
              return theme.ShopifyFormioProxy.submitFormioSweepSubmission(
                formPathUrl,
                {
                  data: {
                    email: userSubmission.data.email,
                    zipCode: userSubmission.data.zipCode,
                    birthYear: userSubmission.data.birthYear,
                    gender: userSubmission.data.gender,
                    submissionCount: 1,
                    quizExtraEntries: 0,
                    smsExtraEntries: 0,
                    termsCond: true,
                    urlReferrer: window.location.href,
                  },
                }
              );
            } else {
              return theme.ShopifyFormioProxy.updateFormioSubmission(
                formPathUrl,
                {
                  ...submission,
                  data: {
                    ...submission.data,
                    submissionCount: (submission.data.submissionCount || 0) + 1,
                  },
                }
              );
            }
          })
          .then((submission) => {
            return theme.RecaptchaUtils.updateSubmissionToken(submission);
          })
          .then((submission) => {
            const SWEEPSTAKE_LANDER_URL = "currentSweepLanderUrl";
            sessionStorage.setItem(
              SWEEPSTAKE_LANDER_URL,
              "https://www.findkeep.love/pages/arcade"
            );
            theme.Sweepstake.prototype.storeSubmission(submission);
            theme.Sweepstake.prototype.sendEventToLytics(
              $(selectors.hiddenHandle).val(),
              submission
            );
            theme.Sweepstake.prototype.onSubmissionSendEventToPixel(
              submission.data.email,
              submission.data.zipCode
            );
            theme.Sweepstake.prototype.storeSubmissionHash(submission);
            window.location.href = theme.Routing.redirectToNextPage(
              window.FKL.productMetadata,
              $(selectors.hiddenHandle).val()
            );
          })
          .catch((err) => {
            console.error(err);
            handleUnavailableAutoArcade();
          });
      } else {
        handleUnavailableAutoArcade();
      }
    }

    function setSocialIconsData(socialReferralLink) {
      const socialShareIconsContainerElement = document.querySelector(
        socialReferralSelectors.socialShareIconsContainer
      );
      const socialShareHTML = socialShareData.reduce(
        (acc, socialIcon) =>
          acc +
          `<a class="social-referral-social-share--link ${
            socialIcon.mobileClass || ""
          }"
            target="_blank"
            href="${socialIcon.shareableLink + socialReferralLink}"
            rel="noopener noreferrer">
            <img
              class="social-referral-social-share--icon"
              src="${assetURL.replace("$asset$", socialIcon.url)}"
            />
          </a>`,
        ""
      );

      socialShareIconsContainerElement.innerHTML = socialShareHTML;
    }

    async function handleSocialReferralData() {
      const socialReferralData =
        await window.theme.YentaApi.getSocialReferralInformation(
          userSubmission,
          `/sweepstake/${window.FKL.thankYouPageHandle}`
        );
      const extraEntriesElement = document.querySelector(
        socialReferralSelectors.socialReferralEntries
      );
      const socialReferralLinkElement = document.querySelector(
        socialReferralSelectors.socialReferralLink
      );

      extraEntriesElement.innerHTML =
        `+${socialReferralData.social_referral_extra_entries}`;
      socialReferralLinkElement.value = socialReferralData.social_referral_link;

      setSocialIconsData(
        encodeURIComponent(socialReferralData.social_referral_link)
      );
      copyToClipboard(socialReferralData.social_referral_link);
    }

    (() => {
      try {
        setEntries(getTotalEntries());
        window.FKL.autoArcade && handleAutoArcade();
        handleSocialReferralData();
      } finally {
        if (window.FKL.autoArcade) {
          new window.theme.Sweepstake();
        }
      }
    })();
  }

  return ThankYouPage;
};

theme.ThankYouPage = ThankYouPage();

const WinnersVideos = (() => {
  function WinnersVideos() {
    var selectors = {
      sectionWinnersVideos: "#shopify-section-winners-videos",
      winnerVideoWrapper: ".winners-page__video-wrapper",
    };
    var init = function () {
      $(selectors.winnerVideoWrapper, selectors.sectionWinnersVideos).slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        infinite: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    };

    init();
  }

  return WinnersVideos;
})();

theme.WinnersVideos = WinnersVideos();

theme.init = function () {
  theme.customerTemplates.init();

  // Theme-specific selectors to make tables scrollable
  var tableSelectors = ".rte table," + ".custom__item-inner--html table";

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: "scrollable-wrapper",
  });

  // Theme-specific selectors to make iframes responsive
  var iframeSelectors = `.rte iframe[src*="youtube.com/embed"],
      .rte iframe[src*="player.vimeo"],
      .custom__item-inner--html iframe[src*="youtube.com/embed"],
      .custom__item-inner--html iframe[src*="player.vimeo"]`;

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: "video-wrapper",
  });

  // Common a11y fixes
  // TODO: some tracking links are being generated with the hash symbol (#)
  // causing the utm params parsing to not being parsed correctly and throwing
  // a Syntax Error, wrapping this in a try-catch solves the issue temporarily
  try {
    slate.a11y.pageLinkFocus($(window.location.hash));
  } catch (error) {
    console.error(error.message);
  }

  $(".in-page-link").on("click", function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $(`a[href="#"]`).on("click", function (evt) {
    evt.preventDefault();
  });

  $(".shopping-cart-component.trigger").on("click", function () {
    window.location.href = "/cart";
  });

  slate.a11y.accessibleLinks({
    messages: {
      newWindow: theme.strings.newWindow,
      external: theme.strings.external,
      newWindowExternal: theme.strings.newWindowExternal,
    },
    $links: $("a[href]:not([aria-describedby], .product-single__thumbnail)"),
  });

  theme.FormStatus.init();

  var selectors = {
    image: "[data-image]",
    imagePlaceholder: "[data-image-placeholder]",
    imageWithPlaceholderWrapper: "[data-image-with-placeholder-wrapper]",
  };

  var classes = {
    hidden: "hide",
  };

  $(document).on("lazyloaded", function (e) {
    var $target = $(e.target);

    if (!$target.is(selectors.image)) {
      return;
    }

    $target
      .closest(selectors.imageWithPlaceholderWrapper)
      .find(selectors.imagePlaceholder)
      .addClass(classes.hidden);
  });

  // When the theme loads, lazysizes might load images before the "lazyloaded"
  // event listener has been attached. When this happens, the following function
  // hides the loading placeholders.
  function onLoadHideLazysizesAnimation() {
    $(selectors.image + ".lazyloaded")
      .closest(selectors.imageWithPlaceholderWrapper)
      .find(selectors.imagePlaceholder)
      .addClass(classes.hidden);
  }

  onLoadHideLazysizesAnimation();

  (() => {
    new Swiper(".swiper-container", {
      autoplay: {
        delay: 10000,
      },
      autoHeight: true,
      direction: "horizontal",
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  })();
};

$(theme.init);

$(document).ready(function () {
  var sections = new theme.Sections();

  sections.register("cart-template", theme.Cart);
  sections.register("product", theme.Product);
  sections.register("giftoffer-collection", theme.Giftoffers);
  sections.register("giftoffer", theme.Giftoffer);
  sections.register("sweepstake", theme.Sweepstake);
  sections.register("get-in-touch-template", theme.GetInTouch);
  sections.register("dont-sell-personal-info", theme.DontSellPersonalInfo);
  sections.register("collection-template", theme.Filters);
  sections.register("product-template", theme.Product);
  sections.register("header-section", theme.HeaderSection);
  sections.register("map", theme.Maps);
  sections.register("slideshow-section", theme.SlideshowSection);
  sections.register(
    "sliding-collection-section",
    theme.SlidingCollectionSection
  );
  sections.register("video-section", theme.VideoSection);
  sections.register("quotes", theme.Quotes);
  sections.register("other-winners", theme.OtherWinners);
  sections.register("hero-section", theme.HeroSection);
  sections.register("product-recommendations", theme.ProductRecommendations);
  sections.register("collection-quiz", theme.QuizCollectionPage);
  sections.register("non-profit-sweep", theme.NonProfitSweep);
  sections.register("arcade-page", theme.ArcadePage);
  sections.register("thank-you-page", theme.ThankYouPage);
  sections.register("advertise-page", theme.AdvertisePage);
  sections.register("blog-page", theme.BlogPage);
  sections.register(
    "collection-sweepstake-completed",
    theme.CompletedSweepstakePage
  );
  sections.register("arcade-modal-prize-vault", theme.ArcadePrizeVaultModal);
  sections.register("arcade-modal-choose-game", theme.ArcadeChooseGameModal);
  sections.register("winners-videos", theme.WinnersVideos);
  sections.register("winner-video-modal", theme.WinnersVideoModal);
  sections.register("single-brand-sweepstake", theme.Sweepstake);
  sections.register("collection-cpl-offer-page", theme.CplOfferCollectionPage);
  sections.register(
    "sweepstakes-collection-page",
    theme.SweepstakesCollectionPage
  );
  sections.register("sweepstake-non-profit", theme.Sweepstake);
  sections.register("sweepstake-cosponsors", theme.Sweepstake);
  sections.register("page-social-referral", theme.SocialReferralPage);
  sections.register("black-arcade-section", theme.ArcadePage);
  sections.register("sweepstake-panel-section", theme.SweepPanelSection);
  sections.register("all-sweepstakes-page", theme.SweepstakesPage);
  sections.register("sponsors-list", theme.SponsorsList);
  sections.register("deprecated-feature", theme.DeprecatedFeature);
});
